// 銀行分行資料

const branches2 = {
  "000": [
    [
      "0000022",
      "國庫局"
    ]
  ],
  "004": [
    [
      "0040037",
      "營業部"
    ],
    [
      "0040059",
      "公庫部"
    ],
    [
      "0040071",
      "館前分行"
    ],
    [
      "0040093",
      "臺南分行"
    ],
    [
      "0040107",
      "臺中分行"
    ],
    [
      "0040118",
      "高雄分行"
    ],
    [
      "0040129",
      "基隆分行"
    ],
    [
      "0040130",
      "中興新村分行"
    ],
    [
      "0040141",
      "嘉義分行"
    ],
    [
      "0040152",
      "新竹分行"
    ],
    [
      "0040163",
      "彰化分行"
    ],
    [
      "0040174",
      "屏東分行"
    ],
    [
      "0040185",
      "花蓮分行"
    ],
    [
      "0040196",
      "延平分行"
    ],
    [
      "0040200",
      "中山分行"
    ],
    [
      "0040211",
      "高雄加工出口區分行"
    ],
    [
      "0040222",
      "宜蘭分行"
    ],
    [
      "0040233",
      "臺東分行"
    ],
    [
      "0040244",
      "澎湖分行"
    ],
    [
      "0040255",
      "鳳山分行"
    ],
    [
      "0040266",
      "桃園分行"
    ],
    [
      "0040277",
      "板橋分行"
    ],
    [
      "0040288",
      "新營分行"
    ],
    [
      "0040299",
      "苗栗分行"
    ],
    [
      "0040303",
      "豐原分行"
    ],
    [
      "0040314",
      "斗六分行"
    ],
    [
      "0040325",
      "南投分行"
    ],
    [
      "0040336",
      "南門分行"
    ],
    [
      "0040347",
      "公館分行"
    ],
    [
      "0040358",
      "左營分行"
    ],
    [
      "0040369",
      "北投分行"
    ],
    [
      "0040370",
      "霧峰分行"
    ],
    [
      "0040381",
      "金門分行"
    ],
    [
      "0040392",
      "馬祖分行"
    ],
    [
      "0040406",
      "安平分行"
    ],
    [
      "0040417",
      "中壢分行"
    ],
    [
      "0040428",
      "三重分行"
    ],
    [
      "0040439",
      "頭份分行"
    ],
    [
      "0040440",
      "前鎮分行"
    ],
    [
      "0040451",
      "城中分行"
    ],
    [
      "0040462",
      "民權分行"
    ],
    [
      "0040473",
      "潭子分行"
    ],
    [
      "0040484",
      "連城分行"
    ],
    [
      "0040495",
      "員林分行"
    ],
    [
      "0040509",
      "松江分行"
    ],
    [
      "0040510",
      "鼓山分行"
    ],
    [
      "0040521",
      "龍山分行"
    ],
    [
      "0040532",
      "忠孝分行"
    ],
    [
      "0040543",
      "信義分行"
    ],
    [
      "0040554",
      "復興分行"
    ],
    [
      "0040565",
      "三民分行"
    ],
    [
      "0040576",
      "臺中港分行"
    ],
    [
      "0040587",
      "羅東分行"
    ],
    [
      "0040598",
      "埔里分行"
    ],
    [
      "0040602",
      "岡山分行"
    ],
    [
      "0040613",
      "新興分行"
    ],
    [
      "0040624",
      "苓雅分行"
    ],
    [
      "0040646",
      "松山分行"
    ],
    [
      "0040657",
      "健行分行"
    ],
    [
      "0040668",
      "中和分行"
    ],
    [
      "0040679",
      "太保分行"
    ],
    [
      "0040680",
      "竹北分行"
    ],
    [
      "0040705",
      "士林分行"
    ],
    [
      "0040716",
      "新莊分行"
    ],
    [
      "0040727",
      "大甲分行"
    ],
    [
      "0040738",
      "新竹科學園區分行"
    ],
    [
      "0040749",
      "樹林分行"
    ],
    [
      "0040750",
      "新店分行"
    ],
    [
      "0040794",
      "黎明分行"
    ],
    [
      "0040808",
      "民生分行"
    ],
    [
      "0040819",
      "永康分行"
    ],
    [
      "0040820",
      "三多分行"
    ],
    [
      "0040853",
      "臺北世貿中心分行"
    ],
    [
      "0040864",
      "大安分行"
    ],
    [
      "0040875",
      "華江分行"
    ],
    [
      "0040886",
      "潮州分行"
    ],
    [
      "0040897",
      "蘇澳分行"
    ],
    [
      "0040901",
      "大雅分行"
    ],
    [
      "0040912",
      "楠梓分行"
    ],
    [
      "0040923",
      "臺中工業區分行"
    ],
    [
      "0041067",
      "敦化分行"
    ],
    [
      "0041078",
      "南港分行"
    ],
    [
      "0041089",
      "和平分行"
    ],
    [
      "0041090",
      "水湳分行"
    ],
    [
      "0041104",
      "中崙分行"
    ],
    [
      "0041115",
      "土城分行"
    ],
    [
      "0041159",
      "桃園國際機場分行"
    ],
    [
      "0041160",
      "大昌分行"
    ],
    [
      "0041182",
      "五甲分行"
    ],
    [
      "0041193",
      "博愛分行"
    ],
    [
      "0041207",
      "中庄分行"
    ],
    [
      "0041218",
      "平鎮分行"
    ],
    [
      "0041229",
      "仁愛分行"
    ],
    [
      "0041230",
      "南崁分行"
    ],
    [
      "0041241",
      "圓山分行"
    ],
    [
      "0041355",
      "五股分行"
    ],
    [
      "0041366",
      "大里分行"
    ],
    [
      "0041377",
      "安南分行"
    ],
    [
      "0041414",
      "西屯分行"
    ],
    [
      "0041425",
      "天母分行"
    ],
    [
      "0041436",
      "鹿港分行"
    ],
    [
      "0041447",
      "內壢分行"
    ],
    [
      "0041469",
      "臺南科學園區分行"
    ],
    [
      "0041470",
      "虎尾分行"
    ],
    [
      "0041481",
      "淡水分行"
    ],
    [
      "0041539",
      "內湖分行"
    ],
    [
      "0041540",
      "嘉北分行"
    ],
    [
      "0041551",
      "東港分行"
    ],
    [
      "0041562",
      "汐止分行"
    ],
    [
      "0041573",
      "梧棲分行"
    ],
    [
      "0041595",
      "小港分行"
    ],
    [
      "0041609",
      "中屏分行"
    ],
    [
      "0041621",
      "群賢分行"
    ],
    [
      "0041643",
      "北大路分行"
    ],
    [
      "0041654",
      "文山分行"
    ],
    [
      "0041702",
      "太平分行"
    ],
    [
      "0041713",
      "德芳分行"
    ],
    [
      "0041724",
      "建國分行"
    ],
    [
      "0041768",
      "屏東農科園區分行"
    ],
    [
      "0041861",
      "東桃園分行"
    ],
    [
      "0041872",
      "蘆洲分行"
    ],
    [
      "0041919",
      "高雄國際機場分行"
    ],
    [
      "0041931",
      "永吉簡易型分行"
    ],
    [
      "0041942",
      "東門簡易型分行"
    ],
    [
      "0041953",
      "愛國簡易型分行"
    ],
    [
      "0041986",
      "臺電簡易型分行"
    ],
    [
      "0042053",
      "北府簡易型分行"
    ],
    [
      "0042189",
      "臺北港分行"
    ],
    [
      "0042204",
      "臺中科學園區分行"
    ],
    [
      "0042215",
      "高雄科學園區分行"
    ],
    [
      "0042237",
      "東湖分行"
    ],
    [
      "0042248",
      "高榮分行"
    ],
    [
      "0042259",
      "南港軟體園區分行"
    ],
    [
      "0042260",
      "龍潭分行"
    ],
    [
      "0042271",
      "仁德分行"
    ],
    [
      "0042282",
      "林口分行"
    ],
    [
      "0042293",
      "木柵分行"
    ],
    [
      "0042307",
      "臺南創新園區分行"
    ],
    [
      "0042363",
      "武昌分行"
    ],
    [
      "0042385",
      "臺北分行"
    ],
    [
      "0042396",
      "金山分行"
    ],
    [
      "0042400",
      "信安分行"
    ],
    [
      "0042411",
      "劍潭分行"
    ],
    [
      "0042422",
      "萬華分行"
    ],
    [
      "0042433",
      "板新分行"
    ],
    [
      "0042444",
      "新永和分行"
    ],
    [
      "0042455",
      "南新莊分行"
    ],
    [
      "0042477",
      "新明分行"
    ],
    [
      "0042488",
      "六家分行"
    ],
    [
      "0042499",
      "北臺中分行"
    ],
    [
      "0042525",
      "嘉南分行"
    ],
    [
      "0042536",
      "南都分行"
    ],
    [
      "0042558",
      "北高雄分行"
    ],
    [
      "0042569",
      "成功分行"
    ],
    [
      "0042570",
      "北花蓮分行"
    ],
    [
      "0042709",
      "新湖分行"
    ],
    [
      "0042710",
      "五福分行"
    ],
    [
      "0042721",
      "六甲頂分行"
    ],
    [
      "0042787",
      "中都分行"
    ],
    [
      "0042798",
      "臺北國際機場分行"
    ],
    [
      "0042802",
      "新莊副都心分行"
    ],
    [
      "0042835",
      "仁武分行"
    ],
    [
      "0042891",
      "臺中國際機場分行"
    ],
    [
      "0042905",
      "臺中精密園區分行"
    ],
    [
      "0042972",
      "亞矽創新分行"
    ]
  ],
  "005": [
    [
      "0050027",
      "基隆分行"
    ],
    [
      "0050038",
      "中和分行"
    ],
    [
      "0050049",
      "南港分行"
    ],
    [
      "0050050",
      "台北分行"
    ],
    [
      "0050061",
      "民權分行"
    ],
    [
      "0050072",
      "古亭分行"
    ],
    [
      "0050083",
      "長安分行"
    ],
    [
      "0050094",
      "士林分行"
    ],
    [
      "0050108",
      "三重分行"
    ],
    [
      "0050119",
      "宜蘭分行"
    ],
    [
      "0050120",
      "羅東分行"
    ],
    [
      "0050131",
      "桃園分行"
    ],
    [
      "0050142",
      "中壢分行"
    ],
    [
      "0050153",
      "石門分行"
    ],
    [
      "0050164",
      "新竹分行"
    ],
    [
      "0050175",
      "竹東分行"
    ],
    [
      "0050186",
      "花蓮分行"
    ],
    [
      "0050197",
      "玉里分行"
    ],
    [
      "0050201",
      "苗栗分行"
    ],
    [
      "0050212",
      "頭份分行"
    ],
    [
      "0050223",
      "豐原分行"
    ],
    [
      "0050234",
      "大甲分行"
    ],
    [
      "0050245",
      "台中分行"
    ],
    [
      "0050256",
      "南投分行"
    ],
    [
      "0050267",
      "員林分行"
    ],
    [
      "0050278",
      "斗六分行"
    ],
    [
      "0050289",
      "北港分行"
    ],
    [
      "0050290",
      "嘉義分行"
    ],
    [
      "0050304",
      "新營分行"
    ],
    [
      "0050315",
      "永康分行"
    ],
    [
      "0050326",
      "台南分行"
    ],
    [
      "0050337",
      "高雄分行"
    ],
    [
      "0050348",
      "岡山分行"
    ],
    [
      "0050359",
      "美濃分行"
    ],
    [
      "0050360",
      "屏東分行"
    ],
    [
      "0050371",
      "台東分行"
    ],
    [
      "0050382",
      "青年分行"
    ],
    [
      "0050393",
      "金門分行"
    ],
    [
      "0050407",
      "澎湖分行"
    ],
    [
      "0050418",
      "營業部"
    ],
    [
      "0050452",
      "和平分行"
    ],
    [
      "0050463",
      "潮州分行"
    ],
    [
      "0050474",
      "彰化分行"
    ],
    [
      "0050485",
      "中山分行"
    ],
    [
      "0050496",
      "永和分行"
    ],
    [
      "0050500",
      "板橋分行"
    ],
    [
      "0050511",
      "鳳山分行"
    ],
    [
      "0050522",
      "湖口分行"
    ],
    [
      "0050533",
      "蘇澳分行"
    ],
    [
      "0050544",
      "新興分行"
    ],
    [
      "0050555",
      "西台中分行"
    ],
    [
      "0050566",
      "虎尾分行"
    ],
    [
      "0050577",
      "仁愛分行"
    ],
    [
      "0050588",
      "忠孝分行"
    ],
    [
      "0050599",
      "中正分行"
    ],
    [
      "0050614",
      "新店分行"
    ],
    [
      "0050625",
      "北台南分行"
    ],
    [
      "0050636",
      "松山分行"
    ],
    [
      "0050647",
      "內湖分行"
    ],
    [
      "0050658",
      "三民分行"
    ],
    [
      "0050669",
      "民雄分行"
    ],
    [
      "0050670",
      "大社分行"
    ],
    [
      "0050692",
      "前鎮分行"
    ],
    [
      "0050706",
      "路竹分行"
    ],
    [
      "0050717",
      "五甲分行"
    ],
    [
      "0050728",
      "太平分行"
    ],
    [
      "0050739",
      "正濱分行"
    ],
    [
      "0050740",
      "敦化分行"
    ],
    [
      "0050762",
      "蘆洲分行"
    ],
    [
      "0050773",
      "北台中分行"
    ],
    [
      "0050784",
      "苓雅分行"
    ],
    [
      "0050795",
      "信義分行"
    ],
    [
      "0050809",
      "土城分行"
    ],
    [
      "0050810",
      "淡水分行"
    ],
    [
      "0050821",
      "草屯分行"
    ],
    [
      "0050832",
      "東台南分行"
    ],
    [
      "0050843",
      "通霄分行"
    ],
    [
      "0050854",
      "學甲分行"
    ],
    [
      "0050865",
      "新莊分行"
    ],
    [
      "0050876",
      "雙和分行"
    ],
    [
      "0050898",
      "白河分行"
    ],
    [
      "0050902",
      "復興分行"
    ],
    [
      "0050913",
      "平鎮分行"
    ],
    [
      "0050935",
      "文山分行"
    ],
    [
      "0050946",
      "中港分行"
    ],
    [
      "0050957",
      "東板橋分行"
    ],
    [
      "0050968",
      "南崁分行"
    ],
    [
      "0050979",
      "建國分行"
    ],
    [
      "0050980",
      "樹林分行"
    ],
    [
      "0050991",
      "東台北分行"
    ],
    [
      "0051002",
      "西三重分行"
    ],
    [
      "0051013",
      "南台中分行"
    ],
    [
      "0051024",
      "長春分行"
    ],
    [
      "0051035",
      "東新竹分行"
    ],
    [
      "0051046",
      "新市分行"
    ],
    [
      "0051057",
      "博愛分行"
    ],
    [
      "0051068",
      "中崙分行"
    ],
    [
      "0051079",
      "華江分行"
    ],
    [
      "0051080",
      "竹北分行"
    ],
    [
      "0051091",
      "安平分行"
    ],
    [
      "0051105",
      "嘉興分行"
    ],
    [
      "0051116",
      "南新莊分行"
    ],
    [
      "0051127",
      "三峽分行"
    ],
    [
      "0051138",
      "沙鹿分行"
    ],
    [
      "0051149",
      "南桃園分行"
    ],
    [
      "0051150",
      "汐止分行"
    ],
    [
      "0051161",
      "萬華分行"
    ],
    [
      "0051172",
      "小港分行"
    ],
    [
      "0051183",
      "新工分行"
    ],
    [
      "0051194",
      "烏日分行"
    ],
    [
      "0051208",
      "西湖分行"
    ],
    [
      "0051219",
      "八德分行"
    ],
    [
      "0051220",
      "北屯分行"
    ],
    [
      "0051231",
      "大安分行"
    ],
    [
      "0051242",
      "北中壢分行"
    ],
    [
      "0051253",
      "高樹分行"
    ],
    [
      "0051264",
      "枋寮分行"
    ],
    [
      "0051286",
      "金城分行"
    ],
    [
      "0051297",
      "光復分行"
    ],
    [
      "0051301",
      "左營分行"
    ],
    [
      "0051312",
      "北桃園分行"
    ],
    [
      "0051323",
      "東港分行"
    ],
    [
      "0051334",
      "天母分行"
    ],
    [
      "0051345",
      "泰山分行"
    ],
    [
      "0051356",
      "中科分行"
    ],
    [
      "0051367",
      "大園分行"
    ],
    [
      "0051378",
      "楊梅分行"
    ],
    [
      "0051404",
      "城東分行"
    ],
    [
      "0051415",
      "松南分行"
    ],
    [
      "0051426",
      "福興分行"
    ],
    [
      "0051437",
      "林口分行"
    ],
    [
      "0051448",
      "西屯分行"
    ],
    [
      "0051459",
      "內壢分行"
    ],
    [
      "0051460",
      "竹南分行"
    ],
    [
      "0051471",
      "安南分行"
    ],
    [
      "0051482",
      "汐科分行"
    ],
    [
      "0051493",
      "楠梓分行"
    ],
    [
      "0051507",
      "大里分行"
    ],
    [
      "0051518",
      "大灣分行"
    ],
    [
      "0051530",
      "大發分行"
    ],
    [
      "0051563",
      "工研院分行"
    ],
    [
      "0051574",
      "北三重分行"
    ],
    [
      "0051585",
      "圓通分行"
    ],
    [
      "0051600",
      "大直分行"
    ],
    [
      "0051611",
      "南屯分行"
    ],
    [
      "0051633",
      "寶中分行"
    ],
    [
      "0051644",
      "中清分行"
    ],
    [
      "0051655",
      "南京東路分行"
    ],
    [
      "0051666",
      "仁武分行"
    ],
    [
      "0051677",
      "青埔分行"
    ]
  ],
  "006": [
    [
      "0060017",
      "總行"
    ],
    [
      "0060028",
      "館前分行"
    ],
    [
      "0060039",
      "西門分行"
    ],
    [
      "0060040",
      "延平分行"
    ],
    [
      "0060051",
      "大稻埕分行"
    ],
    [
      "0060062",
      "東門分行"
    ],
    [
      "0060073",
      "松山分行"
    ],
    [
      "0060084",
      "新店分行"
    ],
    [
      "0060095",
      "永和分行"
    ],
    [
      "0060109",
      "三重分行"
    ],
    [
      "0060110",
      "板橋分行"
    ],
    [
      "0060121",
      "基隆分行"
    ],
    [
      "0060132",
      "宜蘭分行"
    ],
    [
      "0060143",
      "蘇澳分行"
    ],
    [
      "0060154",
      "桃園分行"
    ],
    [
      "0060165",
      "中壢分行"
    ],
    [
      "0060176",
      "新竹分行"
    ],
    [
      "0060187",
      "苗栗分行"
    ],
    [
      "0060198",
      "頭份分行"
    ],
    [
      "0060202",
      "豐原分行"
    ],
    [
      "0060213",
      "沙鹿分行"
    ],
    [
      "0060224",
      "台中分行"
    ],
    [
      "0060235",
      "彰化分行"
    ],
    [
      "0060246",
      "員林分行"
    ],
    [
      "0060257",
      "南投分行"
    ],
    [
      "0060268",
      "斗六分行"
    ],
    [
      "0060279",
      "北港分行"
    ],
    [
      "0060280",
      "嘉義分行"
    ],
    [
      "0060291",
      "新營分行"
    ],
    [
      "0060305",
      "台南分行"
    ],
    [
      "0060316",
      "成功分行"
    ],
    [
      "0060327",
      "鳳山分行"
    ],
    [
      "0060338",
      "岡山分行"
    ],
    [
      "0060349",
      "高雄分行"
    ],
    [
      "0060350",
      "新興分行"
    ],
    [
      "0060361",
      "屏東分行"
    ],
    [
      "0060372",
      "潮州分行"
    ],
    [
      "0060383",
      "花蓮分行"
    ],
    [
      "0060394",
      "台東分行"
    ],
    [
      "0060408",
      "澎湖分行"
    ],
    [
      "0060419",
      "南京東路分行"
    ],
    [
      "0060420",
      "北高雄分行"
    ],
    [
      "0060431",
      "大同分行"
    ],
    [
      "0060453",
      "忠孝分行"
    ],
    [
      "0060464",
      "景美分行"
    ],
    [
      "0060475",
      "士林分行"
    ],
    [
      "0060486",
      "汐止分行"
    ],
    [
      "0060497",
      "新莊分行"
    ],
    [
      "0060501",
      "中興分行"
    ],
    [
      "0060512",
      "苓雅分行"
    ],
    [
      "0060545",
      "台北分行"
    ],
    [
      "0060567",
      "營業部"
    ],
    [
      "0060578",
      "南豐原分行"
    ],
    [
      "0060589",
      "羅東分行"
    ],
    [
      "0060590",
      "三民分行"
    ],
    [
      "0060604",
      "城東分行"
    ],
    [
      "0060615",
      "佳里分行"
    ],
    [
      "0060626",
      "中和分行"
    ],
    [
      "0060637",
      "南高雄分行"
    ],
    [
      "0060648",
      "南嘉義分行"
    ],
    [
      "0060659",
      "竹東分行"
    ],
    [
      "0060660",
      "林口文化分行"
    ],
    [
      "0060671",
      "東三重分行"
    ],
    [
      "0060682",
      "南興分行"
    ],
    [
      "0060693",
      "五權分行"
    ],
    [
      "0060707",
      "埔里分行"
    ],
    [
      "0060718",
      "大順分行"
    ],
    [
      "0060729",
      "南勢角分行"
    ],
    [
      "0060730",
      "朴子分行"
    ],
    [
      "0060763",
      "大安分行"
    ],
    [
      "0060774",
      "民權分行"
    ],
    [
      "0060785",
      "東高雄分行"
    ],
    [
      "0060796",
      "東台北分行"
    ],
    [
      "0060800",
      "城內分行"
    ],
    [
      "0060811",
      "建國分行"
    ],
    [
      "0060822",
      "圓山分行"
    ],
    [
      "0060833",
      "信義分行"
    ],
    [
      "0060844",
      "長春分行"
    ],
    [
      "0060855",
      "仁愛分行"
    ],
    [
      "0060866",
      "玉成分行"
    ],
    [
      "0060877",
      "古亭分行"
    ],
    [
      "0060888",
      "長安分行"
    ],
    [
      "0060899",
      "松興分行"
    ],
    [
      "0060903",
      "民族分行"
    ],
    [
      "0060914",
      "復興分行"
    ],
    [
      "0060925",
      "雙連分行"
    ],
    [
      "0060936",
      "民生分行"
    ],
    [
      "0060947",
      "新生分行"
    ],
    [
      "0060958",
      "松江分行"
    ],
    [
      "0060969",
      "永吉分行"
    ],
    [
      "0060981",
      "東新莊分行"
    ],
    [
      "0060992",
      "蘆洲分行"
    ],
    [
      "0061003",
      "前金分行"
    ],
    [
      "0061014",
      "成大分行"
    ],
    [
      "0061025",
      "大里分行"
    ],
    [
      "0061036",
      "海山分行"
    ],
    [
      "0061070",
      "南台中分行"
    ],
    [
      "0061081",
      "埔墘分行"
    ],
    [
      "0061092",
      "慈文分行"
    ],
    [
      "0061106",
      "北寧分行"
    ],
    [
      "0061117",
      "迴龍分行"
    ],
    [
      "0061128",
      "太平分行"
    ],
    [
      "0061139",
      "彰營分行"
    ],
    [
      "0061140",
      "彰儲分行"
    ],
    [
      "0061151",
      "虎尾分行"
    ],
    [
      "0061162",
      "南屯分行"
    ],
    [
      "0061173",
      "西台中分行"
    ],
    [
      "0061184",
      "溪湖分行"
    ],
    [
      "0061195",
      "烏日分行"
    ],
    [
      "0061209",
      "和美分行"
    ],
    [
      "0061210",
      "南桃園分行"
    ],
    [
      "0061221",
      "屏南分行"
    ],
    [
      "0061232",
      "東台南分行"
    ],
    [
      "0061243",
      "北新竹分行"
    ],
    [
      "0061254",
      "復旦分行"
    ],
    [
      "0061265",
      "竹山分行"
    ],
    [
      "0061276",
      "前鎮分行"
    ],
    [
      "0061287",
      "灣內分行"
    ],
    [
      "0061298",
      "路竹分行"
    ],
    [
      "0061302",
      "憲德分行"
    ],
    [
      "0061313",
      "竹北分行"
    ],
    [
      "0061324",
      "北新分行"
    ],
    [
      "0061335",
      "五洲分行"
    ],
    [
      "0061346",
      "臺大分行"
    ],
    [
      "0061368",
      "龜山分行"
    ],
    [
      "0061379",
      "大溪分行"
    ],
    [
      "0061380",
      "龍潭分行"
    ],
    [
      "0061391",
      "中原分行"
    ],
    [
      "0061405",
      "三興分行"
    ],
    [
      "0061427",
      "石牌分行"
    ],
    [
      "0061438",
      "西屯分行"
    ],
    [
      "0061449",
      "雙和分行"
    ],
    [
      "0061450",
      "土城分行"
    ],
    [
      "0061461",
      "光華分行"
    ],
    [
      "0061472",
      "北台南分行"
    ],
    [
      "0061483",
      "興鳳分行"
    ],
    [
      "0061494",
      "北屯分行"
    ],
    [
      "0061508",
      "一心路分行"
    ],
    [
      "0061519",
      "三峽分行"
    ],
    [
      "0061520",
      "北嘉義分行"
    ],
    [
      "0061531",
      "永康分行"
    ],
    [
      "0061542",
      "平鎮分行"
    ],
    [
      "0061553",
      "大發分行"
    ],
    [
      "0061564",
      "內湖分行"
    ],
    [
      "0061575",
      "光復分行"
    ],
    [
      "0061586",
      "二重分行"
    ],
    [
      "0061601",
      "北台中分行"
    ],
    [
      "0061656",
      "軍功分行"
    ],
    [
      "0061715",
      "永安分行"
    ],
    [
      "0061726",
      "中權分行"
    ],
    [
      "0061759",
      "太原分行"
    ],
    [
      "0061760",
      "松竹分行"
    ],
    [
      "0061852",
      "中清分行"
    ],
    [
      "0061885",
      "建成分行"
    ],
    [
      "0061900",
      "朝馬分行"
    ],
    [
      "0061966",
      "東台中分行"
    ],
    [
      "0061988",
      "美村分行"
    ],
    [
      "0062000",
      "黎明分行"
    ],
    [
      "0062033",
      "昌平分行"
    ],
    [
      "0062044",
      "精武分行"
    ],
    [
      "0062055",
      "文心分行"
    ],
    [
      "0062077",
      "神岡分行"
    ],
    [
      "0063030",
      "大竹分行"
    ],
    [
      "0063074",
      "林內分行"
    ],
    [
      "0063100",
      "南港分行"
    ],
    [
      "0063111",
      "伸港分行"
    ],
    [
      "0063122",
      "五股分行"
    ],
    [
      "0063133",
      "樹林分行"
    ],
    [
      "0063155",
      "林口分行"
    ],
    [
      "0063166",
      "左營分行"
    ],
    [
      "0063177",
      "泰山分行"
    ],
    [
      "0063199",
      "大坪林分行"
    ],
    [
      "0063373",
      "鶯歌分行"
    ],
    [
      "0063395",
      "鹿港分行"
    ],
    [
      "0063409",
      "新樹分行"
    ],
    [
      "0063410",
      "六家分行"
    ],
    [
      "0063421",
      "大雅分行"
    ],
    [
      "0063443",
      "八德分行"
    ],
    [
      "0063465",
      "鼓山分行"
    ],
    [
      "0063476",
      "大社分行"
    ],
    [
      "0063498",
      "逢甲分行"
    ],
    [
      "0063513",
      "林園分行"
    ],
    [
      "0063524",
      "高雄科技園區分行"
    ],
    [
      "0063535",
      "蘆竹分行"
    ],
    [
      "0063546",
      "北中和分行"
    ],
    [
      "0063557",
      "新湖分行"
    ],
    [
      "0063568",
      "丹鳳分行"
    ],
    [
      "0063580",
      "旗山分行"
    ],
    [
      "0063591",
      "大園分行"
    ],
    [
      "0063605",
      "南土城分行"
    ],
    [
      "0063616",
      "潭子分行"
    ],
    [
      "0063627",
      "后里分行"
    ],
    [
      "0063638",
      "長庚分行"
    ],
    [
      "0063649",
      "楠梓分行"
    ],
    [
      "0063650",
      "青埔分行"
    ],
    [
      "0065012",
      "自強分行"
    ],
    [
      "0065023",
      "中山分行"
    ],
    [
      "0065034",
      "敦南分行"
    ],
    [
      "0065056",
      "世貿分行"
    ],
    [
      "0065078",
      "光復南路分行"
    ],
    [
      "0065089",
      "北士林分行"
    ],
    [
      "0065090",
      "信維分行"
    ],
    [
      "0065104",
      "西湖分行"
    ],
    [
      "0065115",
      "大湖分行"
    ],
    [
      "0065137",
      "國醫中心分行"
    ],
    [
      "0065159",
      "南門分行"
    ],
    [
      "0065160",
      "新中分行"
    ],
    [
      "0065171",
      "中港分行"
    ],
    [
      "0065182",
      "衛道分行"
    ],
    [
      "0065193",
      "忠明南路分行"
    ],
    [
      "0065207",
      "東基隆分行"
    ],
    [
      "0065218",
      "赤崁分行"
    ],
    [
      "0065229",
      "府城分行"
    ],
    [
      "0065230",
      "開元分行"
    ],
    [
      "0065241",
      "港都分行"
    ],
    [
      "0065252",
      "七賢分行"
    ],
    [
      "0065274",
      "十全分行"
    ],
    [
      "0065285",
      "九如分行"
    ],
    [
      "0065296",
      "小港分行"
    ],
    [
      "0065300",
      "北三峽分行"
    ],
    [
      "0065311",
      "板新分行"
    ],
    [
      "0065322",
      "南三重分行"
    ],
    [
      "0065355",
      "寶橋分行"
    ],
    [
      "0065366",
      "新泰分行"
    ],
    [
      "0065377",
      "北土城分行"
    ],
    [
      "0065388",
      "南汐止分行"
    ],
    [
      "0065399",
      "北樹林分行"
    ],
    [
      "0065403",
      "五股工業區分行"
    ],
    [
      "0065414",
      "北羅東分行"
    ],
    [
      "0065425",
      "礁溪分行"
    ],
    [
      "0065436",
      "東桃園分行"
    ],
    [
      "0065447",
      "壢新分行"
    ],
    [
      "0065458",
      "南崁分行"
    ],
    [
      "0065470",
      "新明分行"
    ],
    [
      "0065481",
      "楊梅分行"
    ],
    [
      "0065492",
      "東台東分行"
    ],
    [
      "0065517",
      "東竹北分行"
    ],
    [
      "0065528",
      "北苗栗分行"
    ],
    [
      "0065539",
      "竹南分行"
    ],
    [
      "0065540",
      "豐中分行"
    ],
    [
      "0065551",
      "北大里分行"
    ],
    [
      "0065562",
      "東沙鹿分行"
    ],
    [
      "0065573",
      "草屯分行"
    ],
    [
      "0065584",
      "集集分行"
    ],
    [
      "0065595",
      "東埔里分行"
    ],
    [
      "0065609",
      "員新分行"
    ],
    [
      "0065610",
      "南彰化分行"
    ],
    [
      "0065621",
      "北斗分行"
    ],
    [
      "0065632",
      "竹塹分行"
    ],
    [
      "0065643",
      "新竹科學園區分行"
    ],
    [
      "0065665",
      "雲林分行"
    ],
    [
      "0065687",
      "北朴子分行"
    ],
    [
      "0065698",
      "北新營分行"
    ],
    [
      "0065702",
      "仁德分行"
    ],
    [
      "0065713",
      "南永康分行"
    ],
    [
      "0065735",
      "鳳松分行"
    ],
    [
      "0065746",
      "北岡山分行"
    ],
    [
      "0065757",
      "美濃分行"
    ],
    [
      "0065768",
      "大樹分行"
    ],
    [
      "0065816",
      "東港分行"
    ],
    [
      "0065827",
      "萬丹分行"
    ],
    [
      "0065838",
      "枋寮分行"
    ],
    [
      "0065849",
      "東嘉義分行"
    ],
    [
      "0065850",
      "北花蓮分行"
    ],
    [
      "0065919",
      "大直分行"
    ],
    [
      "0065942",
      "水湳分行"
    ],
    [
      "0066064",
      "仁美分行"
    ],
    [
      "0066097",
      "社皮分行"
    ],
    [
      "0066123",
      "港湖分行"
    ],
    [
      "0069021",
      "五甲分行"
    ],
    [
      "0069043",
      "淡水分行"
    ]
  ],
  "007": [
    [
      "0070937",
      "營業部"
    ],
    [
      "0070948",
      "安和分行"
    ],
    [
      "0071015",
      "南港分行"
    ],
    [
      "0071026",
      "西門分行"
    ],
    [
      "0071037",
      "忠孝路分行"
    ],
    [
      "0071059",
      "東湖分行（客戶移撥內湖分行服務）"
    ],
    [
      "0071060",
      "景美分行"
    ],
    [
      "0071071",
      "大直分行"
    ],
    [
      "0071118",
      "大稻埕分行"
    ],
    [
      "0071130",
      "信維分行"
    ],
    [
      "0071211",
      "建成分行"
    ],
    [
      "0071299",
      "華山分行"
    ],
    [
      "0071314",
      "大同分行"
    ],
    [
      "0071336",
      "新生分行"
    ],
    [
      "0071358",
      "劍潭分行"
    ],
    [
      "0071406",
      "圓山分行"
    ],
    [
      "0071417",
      "中山分行"
    ],
    [
      "0071428",
      "中崙分行"
    ],
    [
      "0071439",
      "南京東路分行"
    ],
    [
      "0071440",
      "城東分行"
    ],
    [
      "0071451",
      "民生分行"
    ],
    [
      "0071462",
      "松江分行"
    ],
    [
      "0071473",
      "民權分行"
    ],
    [
      "0071484",
      "八德分行"
    ],
    [
      "0071495",
      "長春分行"
    ],
    [
      "0071509",
      "內湖分行"
    ],
    [
      "0071510",
      "松山分行"
    ],
    [
      "0071521",
      "延吉分行"
    ],
    [
      "0071532",
      "光復分行"
    ],
    [
      "0071554",
      "興雅分行"
    ],
    [
      "0071576",
      "永春分行"
    ],
    [
      "0071587",
      "內科園區分行"
    ],
    [
      "0071598",
      "吉林分行"
    ],
    [
      "0071602",
      "仁愛分行"
    ],
    [
      "0071613",
      "大安分行"
    ],
    [
      "0071624",
      "信義分行"
    ],
    [
      "0071635",
      "復興分行"
    ],
    [
      "0071646",
      "敦化分行"
    ],
    [
      "0071657",
      "仁和分行"
    ],
    [
      "0071668",
      "世貿分行"
    ],
    [
      "0071679",
      "木柵分行"
    ],
    [
      "0071680",
      "松貿分行"
    ],
    [
      "0071691",
      "新湖分行"
    ],
    [
      "0071716",
      "古亭分行"
    ],
    [
      "0071727",
      "南門分行"
    ],
    [
      "0071738",
      "公館分行"
    ],
    [
      "0071761",
      "和平分行"
    ],
    [
      "0071819",
      "萬華分行"
    ],
    [
      "0071831",
      "雙園分行"
    ],
    [
      "0071901",
      "天母分行"
    ],
    [
      "0071912",
      "北投分行"
    ],
    [
      "0071923",
      "士林分行"
    ],
    [
      "0071934",
      "建國分行"
    ],
    [
      "0071945",
      "萬隆分行（客戶移撥木柵分行服務）"
    ],
    [
      "0071956",
      "石牌分行"
    ],
    [
      "0072012",
      "板橋分行"
    ],
    [
      "0072023",
      "華江分行"
    ],
    [
      "0072034",
      "樹林分行"
    ],
    [
      "0072056",
      "土城分行"
    ],
    [
      "0072067",
      "江子翠分行"
    ],
    [
      "0072078",
      "北土城分行"
    ],
    [
      "0072089",
      "林口工二分行"
    ],
    [
      "0072115",
      "三重埔分行"
    ],
    [
      "0072126",
      "長泰分行"
    ],
    [
      "0072137",
      "蘆洲分行"
    ],
    [
      "0072148",
      "頭前分行"
    ],
    [
      "0072159",
      "五股分行"
    ],
    [
      "0072160",
      "重陽分行"
    ],
    [
      "0072171",
      "五股工業區分行"
    ],
    [
      "0072182",
      "淡水分行"
    ],
    [
      "0072193",
      "新蘆分行"
    ],
    [
      "0072218",
      "新店分行"
    ],
    [
      "0072229",
      "大坪林分行"
    ],
    [
      "0072300",
      "泰山分行"
    ],
    [
      "0072311",
      "新莊分行"
    ],
    [
      "0072322",
      "鶯歌分行"
    ],
    [
      "0072333",
      "中和分行"
    ],
    [
      "0072344",
      "永和分行"
    ],
    [
      "0072355",
      "雙和分行"
    ],
    [
      "0072366",
      "連城分行"
    ],
    [
      "0072377",
      "瑞芳分行"
    ],
    [
      "0072388",
      "埔墘分行"
    ],
    [
      "0072399",
      "丹鳳分行"
    ],
    [
      "0072414",
      "基隆分行"
    ],
    [
      "0072436",
      "哨船頭分行"
    ],
    [
      "0072458",
      "汐止分行"
    ],
    [
      "0072469",
      "汐科分行"
    ],
    [
      "0072470",
      "幸福分行"
    ],
    [
      "0072517",
      "宜蘭分行"
    ],
    [
      "0072610",
      "羅東分行"
    ],
    [
      "0072621",
      "蘇澳分行"
    ],
    [
      "0072713",
      "桃園分行"
    ],
    [
      "0072724",
      "北桃分行"
    ],
    [
      "0072735",
      "中正分行（客戶移撥桃園分行服務）"
    ],
    [
      "0072791",
      "大湳分行"
    ],
    [
      "0072805",
      "內壢分行"
    ],
    [
      "0072816",
      "中壢分行"
    ],
    [
      "0072827",
      "西壢分行"
    ],
    [
      "0072838",
      "平鎮分行"
    ],
    [
      "0072849",
      "大園分行"
    ],
    [
      "0072850",
      "南崁分行"
    ],
    [
      "0072861",
      "青埔分行"
    ],
    [
      "0072872",
      "迴龍分行"
    ],
    [
      "0072908",
      "林口分行"
    ],
    [
      "0072919",
      "大溪分行"
    ],
    [
      "0072920",
      "龍潭分行"
    ],
    [
      "0073019",
      "新竹分行"
    ],
    [
      "0073020",
      "東門分行"
    ],
    [
      "0073031",
      "竹科分行"
    ],
    [
      "0073112",
      "竹東分行"
    ],
    [
      "0073123",
      "關西分行"
    ],
    [
      "0073134",
      "竹北分行"
    ],
    [
      "0073215",
      "苗栗分行"
    ],
    [
      "0073318",
      "竹南分行"
    ],
    [
      "0073329",
      "頭份分行"
    ],
    [
      "0074016",
      "台中分行"
    ],
    [
      "0074027",
      "南台中分行"
    ],
    [
      "0074038",
      "北台中分行"
    ],
    [
      "0074049",
      "中港分行"
    ],
    [
      "0074050",
      "北屯分行"
    ],
    [
      "0074061",
      "進化分行"
    ],
    [
      "0074072",
      "南屯分行"
    ],
    [
      "0074119",
      "豐原分行"
    ],
    [
      "0074120",
      "大里分行"
    ],
    [
      "0074153",
      "中科分行"
    ],
    [
      "0074212",
      "東勢分行"
    ],
    [
      "0074223",
      "沙鹿分行"
    ],
    [
      "0074234",
      "大甲分行"
    ],
    [
      "0074245",
      "太平分行"
    ],
    [
      "0074256",
      "清水分行"
    ],
    [
      "0074267",
      "大雅分行"
    ],
    [
      "0074315",
      "南投分行"
    ],
    [
      "0074418",
      "草屯分行"
    ],
    [
      "0074429",
      "埔里分行"
    ],
    [
      "0074511",
      "彰化分行"
    ],
    [
      "0074614",
      "員林分行"
    ],
    [
      "0074625",
      "鹿港分行"
    ],
    [
      "0074636",
      "溪湖分行"
    ],
    [
      "0074647",
      "北斗分行"
    ],
    [
      "0074717",
      "和美分行"
    ],
    [
      "0075013",
      "嘉義分行"
    ],
    [
      "0075035",
      "興嘉分行"
    ],
    [
      "0075116",
      "朴子分行"
    ],
    [
      "0075219",
      "斗六分行"
    ],
    [
      "0075312",
      "北港分行"
    ],
    [
      "0075323",
      "西螺分行"
    ],
    [
      "0075334",
      "虎尾分行"
    ],
    [
      "0076010",
      "台南分行"
    ],
    [
      "0076021",
      "運河分行（客戶移撥台南分行服務）"
    ],
    [
      "0076043",
      "富強分行"
    ],
    [
      "0076054",
      "赤崁分行"
    ],
    [
      "0076065",
      "竹溪分行"
    ],
    [
      "0076076",
      "金城分行"
    ],
    [
      "0076087",
      "安南分行"
    ],
    [
      "0076113",
      "新營分行"
    ],
    [
      "0076216",
      "鹽水分行"
    ],
    [
      "0076227",
      "麻豆分行"
    ],
    [
      "0076238",
      "善化分行"
    ],
    [
      "0076249",
      "佳里分行"
    ],
    [
      "0076250",
      "新化分行"
    ],
    [
      "0076261",
      "大灣分行"
    ],
    [
      "0076283",
      "南科園區分行"
    ],
    [
      "0076294",
      "歸仁分行"
    ],
    [
      "0076308",
      "永康分行"
    ],
    [
      "0077017",
      "高雄分行"
    ],
    [
      "0077028",
      "鹽埕分行"
    ],
    [
      "0077039",
      "新興分行"
    ],
    [
      "0077040",
      "三民分行"
    ],
    [
      "0077051",
      "苓雅分行"
    ],
    [
      "0077062",
      "左營分行"
    ],
    [
      "0077073",
      "楠梓分行"
    ],
    [
      "0077084",
      "五福分行"
    ],
    [
      "0077095",
      "十全分行"
    ],
    [
      "0077109",
      "前鎮分行"
    ],
    [
      "0077110",
      "灣內分行"
    ],
    [
      "0077121",
      "博愛分行"
    ],
    [
      "0077132",
      "鼎泰分行（客戶移撥博愛分行服務）"
    ],
    [
      "0077143",
      "小港分行"
    ],
    [
      "0077202",
      "五甲分行"
    ],
    [
      "0077213",
      "鳳山分行"
    ],
    [
      "0077305",
      "路竹分行"
    ],
    [
      "0077316",
      "岡山分行"
    ],
    [
      "0077327",
      "旗山分行"
    ],
    [
      "0077338",
      "林園分行"
    ],
    [
      "0077419",
      "屏東分行"
    ],
    [
      "0077512",
      "潮州分行"
    ],
    [
      "0077523",
      "東港分行"
    ],
    [
      "0077534",
      "恆春分行"
    ],
    [
      "0077785",
      "梓本分行"
    ],
    [
      "0077855",
      "萬巒分行"
    ],
    [
      "0078014",
      "花蓮分行"
    ],
    [
      "0078117",
      "台東分行"
    ],
    [
      "0078210",
      "澎湖分行"
    ]
  ],
  "008": [
    [
      "0081005",
      "營業部"
    ],
    [
      "0081016",
      "儲蓄分行"
    ],
    [
      "0081027",
      "總行國際金融部"
    ],
    [
      "0081038",
      "城內分行"
    ],
    [
      "0081049",
      "大稻埕分行"
    ],
    [
      "0081050",
      "建成分行"
    ],
    [
      "0081061",
      "中山分行"
    ],
    [
      "0081072",
      "圓山分行"
    ],
    [
      "0081083",
      "城東分行"
    ],
    [
      "0081094",
      "西門分行"
    ],
    [
      "0081108",
      "南松山分行"
    ],
    [
      "0081119",
      "仁愛路分行"
    ],
    [
      "0081120",
      "南京東路分行"
    ],
    [
      "0081131",
      "新生分行"
    ],
    [
      "0081142",
      "大同分行"
    ],
    [
      "0081153",
      "松山分行"
    ],
    [
      "0081164",
      "中崙分行"
    ],
    [
      "0081175",
      "臺北南門分行"
    ],
    [
      "0081186",
      "公館分行"
    ],
    [
      "0081197",
      "信義分行"
    ],
    [
      "0081201",
      "忠孝東路分行"
    ],
    [
      "0081212",
      "和平分行"
    ],
    [
      "0081223",
      "雙園分行"
    ],
    [
      "0081234",
      "士林分行"
    ],
    [
      "0081245",
      "東台北分行"
    ],
    [
      "0081256",
      "大安分行"
    ],
    [
      "0081267",
      "民生分行"
    ],
    [
      "0081278",
      "復興分行"
    ],
    [
      "0081289",
      "龍江分行"
    ],
    [
      "0081290",
      "永吉分行"
    ],
    [
      "0081304",
      "敦化分行"
    ],
    [
      "0081326",
      "大直分行"
    ],
    [
      "0081337",
      "敦和分行"
    ],
    [
      "0081348",
      "東湖分行"
    ],
    [
      "0081360",
      "東興分行"
    ],
    [
      "0081371",
      "北南港分行"
    ],
    [
      "0081382",
      "木柵分行"
    ],
    [
      "0081393",
      "板橋文化分行"
    ],
    [
      "0081430",
      "南內湖分行"
    ],
    [
      "0081452",
      "長安分行"
    ],
    [
      "0081474",
      "懷生分行"
    ],
    [
      "0081485",
      "中華路分行"
    ],
    [
      "0081496",
      "信維分行"
    ],
    [
      "0081511",
      "埔墘分行"
    ],
    [
      "0081522",
      "石牌分行"
    ],
    [
      "0081533",
      "瑞祥分行"
    ],
    [
      "0081544",
      "台大分行"
    ],
    [
      "0081566",
      "世貿分行"
    ],
    [
      "0081577",
      "萬華分行"
    ],
    [
      "0081588",
      "南港分行"
    ],
    [
      "0081599",
      "華江分行"
    ],
    [
      "0081603",
      "板橋分行"
    ],
    [
      "0081614",
      "三重分行"
    ],
    [
      "0081625",
      "北三重分行"
    ],
    [
      "0081636",
      "新莊分行"
    ],
    [
      "0081647",
      "永和分行"
    ],
    [
      "0081658",
      "中和分行"
    ],
    [
      "0081669",
      "新店分行"
    ],
    [
      "0081670",
      "淡水分行"
    ],
    [
      "0081681",
      "汐止分行"
    ],
    [
      "0081692",
      "南永和分行"
    ],
    [
      "0081706",
      "西三重分行"
    ],
    [
      "0081717",
      "南三重分行"
    ],
    [
      "0081728",
      "雙和分行"
    ],
    [
      "0081739",
      "新泰分行"
    ],
    [
      "0081740",
      "二重分行"
    ],
    [
      "0081751",
      "板新分行"
    ],
    [
      "0081762",
      "五股分行"
    ],
    [
      "0081773",
      "潭美分行"
    ],
    [
      "0081784",
      "北投分行"
    ],
    [
      "0081795",
      "西湖分行"
    ],
    [
      "0081809",
      "積穗分行"
    ],
    [
      "0081821",
      "福和分行"
    ],
    [
      "0081832",
      "南勢角分行"
    ],
    [
      "0081843",
      "北蘆洲分行"
    ],
    [
      "0081854",
      "蘆洲分行"
    ],
    [
      "0081865",
      "土城分行"
    ],
    [
      "0081876",
      "北新分行"
    ],
    [
      "0081898",
      "天母分行"
    ],
    [
      "0081902",
      "內湖分行"
    ],
    [
      "0081913",
      "樹林分行"
    ],
    [
      "0081924",
      "樟樹灣分行"
    ],
    [
      "0081935",
      "泰山分行"
    ],
    [
      "0081946",
      "三峽分行"
    ],
    [
      "0081957",
      "文山分行"
    ],
    [
      "0081968",
      "鶯歌分行"
    ],
    [
      "0081979",
      "北新莊分行"
    ],
    [
      "0081980",
      "北土城分行"
    ],
    [
      "0081991",
      "林口站前分行"
    ],
    [
      "0082002",
      "基隆分行"
    ],
    [
      "0082013",
      "基隆港口分行"
    ],
    [
      "0082116",
      "七堵分行"
    ],
    [
      "0082208",
      "羅東分行"
    ],
    [
      "0082219",
      "宜蘭分行"
    ],
    [
      "0082404",
      "桃園分行"
    ],
    [
      "0082415",
      "中壢分行"
    ],
    [
      "0082426",
      "楊梅分行"
    ],
    [
      "0082437",
      "壢昌分行"
    ],
    [
      "0082448",
      "北桃園分行"
    ],
    [
      "0082459",
      "南崁分行"
    ],
    [
      "0082460",
      "平鎮分行"
    ],
    [
      "0082471",
      "八德分行"
    ],
    [
      "0082482",
      "龜山分行"
    ],
    [
      "0082493",
      "龍潭分行"
    ],
    [
      "0082507",
      "大溪分行"
    ],
    [
      "0082518",
      "內壢分行"
    ],
    [
      "0082529",
      "林口分行"
    ],
    [
      "0082600",
      "觀音分行"
    ],
    [
      "0082622",
      "大園分行"
    ],
    [
      "0083009",
      "新竹分行"
    ],
    [
      "0083010",
      "竹東分行"
    ],
    [
      "0083021",
      "竹科分行"
    ],
    [
      "0083102",
      "新豐分行"
    ],
    [
      "0083135",
      "六家分行"
    ],
    [
      "0083205",
      "竹南分行"
    ],
    [
      "0083216",
      "頭份分行"
    ],
    [
      "0083227",
      "苗栗分行"
    ],
    [
      "0083238",
      "竹北分行"
    ],
    [
      "0083515",
      "大眾分行"
    ],
    [
      "0084006",
      "豐原分行"
    ],
    [
      "0084017",
      "東勢分行"
    ],
    [
      "0084028",
      "清水分行"
    ],
    [
      "0084039",
      "西豐原分行"
    ],
    [
      "0084202",
      "台中分行"
    ],
    [
      "0084224",
      "南台中分行"
    ],
    [
      "0084235",
      "北台中分行"
    ],
    [
      "0084246",
      "台中港路分行"
    ],
    [
      "0084257",
      "大里分行"
    ],
    [
      "0084268",
      "水湳分行"
    ],
    [
      "0084279",
      "五權分行"
    ],
    [
      "0084291",
      "大甲分行"
    ],
    [
      "0084305",
      "太平分行"
    ],
    [
      "0084316",
      "中科分行"
    ],
    [
      "0084512",
      "沙鹿分行"
    ],
    [
      "0085003",
      "草屯分行"
    ],
    [
      "0085014",
      "南投分行"
    ],
    [
      "0085209",
      "彰化分行"
    ],
    [
      "0085210",
      "和美分行"
    ],
    [
      "0085221",
      "員林分行"
    ],
    [
      "0085232",
      "鹿港分行"
    ],
    [
      "0085243",
      "溪湖分行"
    ],
    [
      "0085405",
      "斗六分行"
    ],
    [
      "0085416",
      "虎尾分行"
    ],
    [
      "0085427",
      "西螺分行"
    ],
    [
      "0086000",
      "嘉義分行"
    ],
    [
      "0086011",
      "嘉南分行"
    ],
    [
      "0086022",
      "朴子分行"
    ],
    [
      "0086206",
      "新營分行"
    ],
    [
      "0086217",
      "麻豆分行"
    ],
    [
      "0086228",
      "永康分行"
    ],
    [
      "0086402",
      "台南分行"
    ],
    [
      "0086424",
      "東台南分行"
    ],
    [
      "0086435",
      "西台南分行"
    ],
    [
      "0086446",
      "北台南分行"
    ],
    [
      "0086457",
      "南都分行"
    ],
    [
      "0086468",
      "安南分行"
    ],
    [
      "0086479",
      "仁德分行"
    ],
    [
      "0086480",
      "新市分行"
    ],
    [
      "0086815",
      "金華分行"
    ],
    [
      "0087007",
      "高雄分行"
    ],
    [
      "0087018",
      "東苓分行"
    ],
    [
      "0087029",
      "新興分行"
    ],
    [
      "0087030",
      "高雄三民分行"
    ],
    [
      "0087041",
      "苓雅分行"
    ],
    [
      "0087052",
      "前鎮分行"
    ],
    [
      "0087063",
      "高雄博愛分行"
    ],
    [
      "0087074",
      "南高雄分行"
    ],
    [
      "0087085",
      "東高雄分行"
    ],
    [
      "0087096",
      "大昌分行"
    ],
    [
      "0087100",
      "北高雄分行"
    ],
    [
      "0087111",
      "楠梓分行"
    ],
    [
      "0087122",
      "左營分行"
    ],
    [
      "0087199",
      "岡山分行"
    ],
    [
      "0087203",
      "鳳山分行"
    ],
    [
      "0087214",
      "路竹分行"
    ],
    [
      "0087225",
      "仁武分行"
    ],
    [
      "0087513",
      "籬仔內分行"
    ],
    [
      "0087524",
      "五甲分行"
    ],
    [
      "0087535",
      "光華分行"
    ],
    [
      "0087605",
      "小港分行"
    ],
    [
      "0087650",
      "高雄桂林分行"
    ],
    [
      "0088004",
      "屏東分行"
    ],
    [
      "0088015",
      "內埔分行"
    ],
    [
      "0088026",
      "潮州分行"
    ],
    [
      "0088130",
      "佳冬分行"
    ],
    [
      "0088200",
      "花蓮分行"
    ],
    [
      "0088303",
      "台東分行"
    ],
    [
      "0088886",
      "營運總部分行"
    ]
  ],
  "009": [
    [
      "0092200",
      "總行營業部"
    ],
    [
      "0093003",
      "吉林分行"
    ],
    [
      "0093010",
      "城內分行"
    ],
    [
      "0094004",
      "北台中分行"
    ],
    [
      "0094011",
      "南台中分行"
    ],
    [
      "0094028",
      "北屯分行"
    ],
    [
      "0094035",
      "水湳分行"
    ],
    [
      "0094042",
      "南屯分行"
    ],
    [
      "0094059",
      "台中分行"
    ],
    [
      "0094108",
      "基隆分行"
    ],
    [
      "0094115",
      "仁愛分行"
    ],
    [
      "0094122",
      "東基隆分行"
    ],
    [
      "0094202",
      "宜蘭分行"
    ],
    [
      "0094219",
      "羅東分行"
    ],
    [
      "0095005",
      "北門分行"
    ],
    [
      "0095012",
      "台北分行"
    ],
    [
      "0095029",
      "萬華分行"
    ],
    [
      "0095036",
      "西門分行"
    ],
    [
      "0095043",
      "永樂分行"
    ],
    [
      "0095050",
      "建成分行"
    ],
    [
      "0095067",
      "大同分行"
    ],
    [
      "0095074",
      "承德分行"
    ],
    [
      "0095081",
      "中山北路分行"
    ],
    [
      "0095109",
      "東門分行"
    ],
    [
      "0095116",
      "古亭分行"
    ],
    [
      "0095123",
      "五分埔分行"
    ],
    [
      "0095130",
      "大安分行"
    ],
    [
      "0095147",
      "城東分行"
    ],
    [
      "0095154",
      "中崙分行"
    ],
    [
      "0095161",
      "雙園分行"
    ],
    [
      "0095178",
      "士林分行"
    ],
    [
      "0095185",
      "總部分行"
    ],
    [
      "0095192",
      "松山分行"
    ],
    [
      "0095203",
      "忠孝東路分行"
    ],
    [
      "0095210",
      "信義分行"
    ],
    [
      "0095227",
      "東台北分行"
    ],
    [
      "0095234",
      "民生分行"
    ],
    [
      "0095241",
      "西松分行"
    ],
    [
      "0095258",
      "復興分行"
    ],
    [
      "0095265",
      "台北世貿中心分行"
    ],
    [
      "0095272",
      "敦化分行"
    ],
    [
      "0095289",
      "建國分行"
    ],
    [
      "0095296",
      "內湖分行"
    ],
    [
      "0095307",
      "天母分行"
    ],
    [
      "0095314",
      "中正分行"
    ],
    [
      "0095321",
      "仁和分行"
    ],
    [
      "0095338",
      "永春分行"
    ],
    [
      "0095345",
      "光隆分行"
    ],
    [
      "0095352",
      "木柵分行"
    ],
    [
      "0095369",
      "新湖分行"
    ],
    [
      "0095376",
      "東湖分行"
    ],
    [
      "0095383",
      "南港科學園區分行"
    ],
    [
      "0095390",
      "北投分行"
    ],
    [
      "0095401",
      "和平分行"
    ],
    [
      "0095418",
      "東興分行"
    ],
    [
      "0095425",
      "龍潭分行"
    ],
    [
      "0095432",
      "汐科分行"
    ],
    [
      "0095456",
      "新樹分行"
    ],
    [
      "0095463",
      "立德分行"
    ],
    [
      "0095470",
      "泰山分行"
    ],
    [
      "0095487",
      "五股工業區分行"
    ],
    [
      "0095494",
      "南新莊分行"
    ],
    [
      "0095505",
      "三重埔分行"
    ],
    [
      "0095512",
      "北三重埔分行"
    ],
    [
      "0095529",
      "新店分行"
    ],
    [
      "0095536",
      "永和分行"
    ],
    [
      "0095543",
      "瑞芳分行"
    ],
    [
      "0095550",
      "新莊分行"
    ],
    [
      "0095567",
      "樹林分行"
    ],
    [
      "0095574",
      "板橋分行"
    ],
    [
      "0095581",
      "三峽分行"
    ],
    [
      "0095598",
      "福和分行"
    ],
    [
      "0095609",
      "光復分行"
    ],
    [
      "0095623",
      "北新分行"
    ],
    [
      "0095630",
      "南三重分行"
    ],
    [
      "0095647",
      "中和分行"
    ],
    [
      "0095654",
      "西三重分行"
    ],
    [
      "0095661",
      "汐止分行"
    ],
    [
      "0095678",
      "雙和分行"
    ],
    [
      "0095685",
      "淡水分行"
    ],
    [
      "0095692",
      "楊梅分行"
    ],
    [
      "0095703",
      "桃園分行"
    ],
    [
      "0095710",
      "中壢分行"
    ],
    [
      "0095727",
      "新竹分行"
    ],
    [
      "0095734",
      "竹東分行"
    ],
    [
      "0095741",
      "苗栗分行"
    ],
    [
      "0095758",
      "新竹科學園區分行"
    ],
    [
      "0095765",
      "北中壢分行"
    ],
    [
      "0095772",
      "八德分行"
    ],
    [
      "0095789",
      "竹南分行"
    ],
    [
      "0095796",
      "南崁分行"
    ],
    [
      "0095807",
      "苑裡分行"
    ],
    [
      "0095814",
      "大甲分行"
    ],
    [
      "0095821",
      "清水分行"
    ],
    [
      "0095838",
      "豐原分行"
    ],
    [
      "0095845",
      "東勢分行"
    ],
    [
      "0095852",
      "霧峰分行"
    ],
    [
      "0095869",
      "大雅分行"
    ],
    [
      "0095876",
      "沙鹿分行"
    ],
    [
      "0095890",
      "太平分行"
    ],
    [
      "0095901",
      "草屯分行"
    ],
    [
      "0095918",
      "南投分行"
    ],
    [
      "0095925",
      "埔里分行"
    ],
    [
      "0095932",
      "水裡坑分行"
    ],
    [
      "0095963",
      "大肚分行"
    ],
    [
      "0095970",
      "青埔分行"
    ],
    [
      "0095987",
      "竹北分行"
    ],
    [
      "0096006",
      "彰化分行"
    ],
    [
      "0096013",
      "鹿港分行"
    ],
    [
      "0096020",
      "員林分行"
    ],
    [
      "0096037",
      "溪湖分行"
    ],
    [
      "0096044",
      "北斗分行"
    ],
    [
      "0096051",
      "西螺分行"
    ],
    [
      "0096068",
      "和美分行"
    ],
    [
      "0096075",
      "大里分行"
    ],
    [
      "0096099",
      "二林分行"
    ],
    [
      "0096100",
      "斗六分行"
    ],
    [
      "0096117",
      "斗南分行"
    ],
    [
      "0096124",
      "虎尾分行"
    ],
    [
      "0096131",
      "北港分行"
    ],
    [
      "0096204",
      "大林分行"
    ],
    [
      "0096211",
      "嘉義分行"
    ],
    [
      "0096228",
      "東嘉義分行"
    ],
    [
      "0096235",
      "新營分行"
    ],
    [
      "0096242",
      "永康分行"
    ],
    [
      "0096266",
      "歸仁分行"
    ],
    [
      "0096402",
      "台南分行"
    ],
    [
      "0096419",
      "延平分行"
    ],
    [
      "0096426",
      "西台南分行"
    ],
    [
      "0096433",
      "東台南分行"
    ],
    [
      "0096440",
      "南台南分行"
    ],
    [
      "0096457",
      "安南分行"
    ],
    [
      "0096506",
      "旗山分行"
    ],
    [
      "0096513",
      "岡山分行"
    ],
    [
      "0096520",
      "鳳山分行"
    ],
    [
      "0098119",
      "高雄分行"
    ],
    [
      "0098126",
      "七賢分行"
    ],
    [
      "0098133",
      "鹽埕分行"
    ],
    [
      "0098140",
      "東高雄分行"
    ],
    [
      "0098157",
      "南高雄分行"
    ],
    [
      "0098164",
      "北高雄分行"
    ],
    [
      "0098171",
      "三民分行"
    ],
    [
      "0098195",
      "前鎮分行"
    ],
    [
      "0098206",
      "九如路分行"
    ],
    [
      "0098213",
      "新興分行"
    ],
    [
      "0098220",
      "苓雅分行"
    ],
    [
      "0098237",
      "大順分行"
    ],
    [
      "0098244",
      "博愛分行"
    ],
    [
      "0098251",
      "左營分行"
    ],
    [
      "0098300",
      "屏東分行"
    ],
    [
      "0098317",
      "東港分行"
    ],
    [
      "0098324",
      "潮州分行"
    ],
    [
      "0098348",
      "恆春分行"
    ],
    [
      "0098404",
      "花蓮分行"
    ],
    [
      "0098508",
      "台東分行"
    ],
    [
      "0099269",
      "思源分行"
    ],
    [
      "0099283",
      "土城分行"
    ],
    [
      "0099290",
      "北桃園分行"
    ],
    [
      "0099301",
      "新明分行"
    ],
    [
      "0099318",
      "埔心分行"
    ],
    [
      "0099332",
      "西屯分行"
    ],
    [
      "0099349",
      "大發分行"
    ],
    [
      "0099356",
      "東林口分行"
    ],
    [
      "0099363",
      "新林口分行"
    ],
    [
      "0099523",
      "土庫分行"
    ],
    [
      "0099547",
      "路竹分行"
    ],
    [
      "0099554",
      "蘇澳分行"
    ],
    [
      "0099561",
      "北台南分行"
    ],
    [
      "0099603",
      "潭子分行"
    ],
    [
      "0099610",
      "北嘉義分行"
    ],
    [
      "0099627",
      "北新竹分行"
    ],
    [
      "0099634",
      "建興分行"
    ],
    [
      "0099641",
      "三和路分行"
    ],
    [
      "0099658",
      "吉成分行"
    ],
    [
      "0099689",
      "林口分行"
    ],
    [
      "0099696",
      "江翠分行"
    ],
    [
      "0099714",
      "長安東路分行"
    ],
    [
      "0099721",
      "晴光分行"
    ],
    [
      "0099738",
      "大直分行"
    ],
    [
      "0099752",
      "松江分行"
    ],
    [
      "0099790",
      "西內湖分行"
    ],
    [
      "0099801",
      "南港分行"
    ],
    [
      "0099818",
      "中港分行"
    ],
    [
      "0099832",
      "蘆洲分行"
    ],
    [
      "0099849",
      "中華路分行"
    ]
  ],
  "011": [
    [
      "0110026",
      "營業部"
    ],
    [
      "0110037",
      "儲蓄部"
    ],
    [
      "0110048",
      "高雄分行"
    ],
    [
      "0110060",
      "城中分行"
    ],
    [
      "0110082",
      "台中分行"
    ],
    [
      "0110093",
      "東台北分行"
    ],
    [
      "0110107",
      "台南分行"
    ],
    [
      "0110118",
      "桃園分行"
    ],
    [
      "0110129",
      "北高雄分行"
    ],
    [
      "0110130",
      "三重分行"
    ],
    [
      "0110141",
      "板橋分行"
    ],
    [
      "0110152",
      "永和分行"
    ],
    [
      "0110163",
      "員林分行"
    ],
    [
      "0110185",
      "信義分行"
    ],
    [
      "0110196",
      "民生分行"
    ],
    [
      "0110200",
      "忠孝分行"
    ],
    [
      "0110211",
      "龍山分行"
    ],
    [
      "0110222",
      "內湖分行"
    ],
    [
      "0110233",
      "中山分行"
    ],
    [
      "0110244",
      "仁愛分行"
    ],
    [
      "0110255",
      "新莊分行"
    ],
    [
      "0110266",
      "中壢分行"
    ],
    [
      "0110288",
      "松山分行"
    ],
    [
      "0110299",
      "新店分行"
    ],
    [
      "0110303",
      "前金分行"
    ],
    [
      "0110314",
      "松南分行"
    ],
    [
      "0110325",
      "蘆洲分行"
    ],
    [
      "0110336",
      "中和分行"
    ],
    [
      "0110347",
      "新竹分行"
    ],
    [
      "0110358",
      "中港分行"
    ],
    [
      "0110369",
      "士林分行"
    ],
    [
      "0110370",
      "東台南分行"
    ],
    [
      "0110381",
      "永康分行"
    ],
    [
      "0110392",
      "北三重分行"
    ],
    [
      "0110406",
      "南京東路分行"
    ],
    [
      "0110417",
      "大里分行"
    ],
    [
      "0110428",
      "土城分行"
    ],
    [
      "0110439",
      "世貿分行"
    ],
    [
      "0110440",
      "承德分行"
    ],
    [
      "0110451",
      "汐止分行"
    ],
    [
      "0110462",
      "屏東分行"
    ],
    [
      "0110473",
      "三民分行"
    ],
    [
      "0110484",
      "華江分行"
    ],
    [
      "0110495",
      "豐原分行"
    ],
    [
      "0110509",
      "鳳山分行"
    ],
    [
      "0110510",
      "天母分行"
    ],
    [
      "0110521",
      "樹林分行"
    ],
    [
      "0110532",
      "基隆分行"
    ],
    [
      "0110543",
      "楊梅分行"
    ],
    [
      "0110554",
      "內湖科技園區分行"
    ],
    [
      "0110565",
      "北中和分行"
    ],
    [
      "0110576",
      "西湖分行"
    ],
    [
      "0110598",
      "二重分行"
    ],
    [
      "0110602",
      "延平分行"
    ],
    [
      "0110613",
      "南崁分行"
    ],
    [
      "0110624",
      "南港分行"
    ],
    [
      "0110635",
      "北新竹分行"
    ],
    [
      "0110657",
      "宜蘭分行"
    ],
    [
      "0110668",
      "文山分行"
    ],
    [
      "0110680",
      "敦北分行"
    ],
    [
      "0110691",
      "東高雄分行"
    ],
    [
      "0110705",
      "竹北分行"
    ],
    [
      "0110716",
      "松江分行"
    ],
    [
      "0110727",
      "市政分行"
    ],
    [
      "0110738",
      "觀音分行"
    ],
    [
      "0110749",
      "北桃園分行"
    ],
    [
      "0110750",
      "丹鳳分行"
    ],
    [
      "0110761",
      "北新莊分行"
    ],
    [
      "0110772",
      "南屯分行"
    ],
    [
      "0110794",
      "林口分行"
    ],
    [
      "0110808",
      "竹科分行"
    ],
    [
      "0110819",
      "永吉分行"
    ]
  ],
  "012": [
    [
      "0122009",
      "營業部"
    ],
    [
      "0122032",
      "長安東路分行"
    ],
    [
      "0122102",
      "公庫處"
    ],
    [
      "0122205",
      "城東分行"
    ],
    [
      "0122216",
      "農安分行（客戶移撥建國分行服務）"
    ],
    [
      "0123006",
      "士林分行"
    ],
    [
      "0123017",
      "士東分行"
    ],
    [
      "0123028",
      "瑞光分行（客戶移撥瑞湖分行服務）"
    ],
    [
      "0123039",
      "玉成分行"
    ],
    [
      "0123040",
      "福港分行"
    ],
    [
      "0123051",
      "忠孝分行"
    ],
    [
      "0123062",
      "承德分行（客戶移撥延平分行服務）"
    ],
    [
      "0123073",
      "龍江分行（客戶移撥南京東路分行服務）"
    ],
    [
      "0123109",
      "延平分行"
    ],
    [
      "0123202",
      "木柵分行"
    ],
    [
      "0123213",
      "木新分行（客戶移撥木柵分行服務）"
    ],
    [
      "0123305",
      "西門分行（客戶移撥桂林分行服務）"
    ],
    [
      "0123408",
      "八德分行"
    ],
    [
      "0123419",
      "松南分行"
    ],
    [
      "0123420",
      "永吉分行"
    ],
    [
      "0123501",
      "中山分行"
    ],
    [
      "0123604",
      "北投分行"
    ],
    [
      "0123615",
      "石牌分行"
    ],
    [
      "0123707",
      "大安分行"
    ],
    [
      "0123800",
      "大同分行"
    ],
    [
      "0123903",
      "古亭分行"
    ],
    [
      "0124003",
      "雙園分行"
    ],
    [
      "0124014",
      "萬華分行"
    ],
    [
      "0124106",
      "建成分行"
    ],
    [
      "0124117",
      "市府分行"
    ],
    [
      "0124209",
      "南港分行"
    ],
    [
      "0124302",
      "景美分行"
    ],
    [
      "0124313",
      "興隆分行"
    ],
    [
      "0124405",
      "內湖分行"
    ],
    [
      "0124427",
      "文德分行"
    ],
    [
      "0124542",
      "民生分行"
    ],
    [
      "0124601",
      "信義分行"
    ],
    [
      "0124612",
      "莊敬分行"
    ],
    [
      "0124623",
      "東門分行"
    ],
    [
      "0124704",
      "松江分行"
    ],
    [
      "0124807",
      "和平分行"
    ],
    [
      "0124900",
      "延吉分行（客戶移撥安和分行服務）"
    ],
    [
      "0125103",
      "南門分行"
    ],
    [
      "0125206",
      "復興分行（客戶移撥敦北分行服務）"
    ],
    [
      "0125309",
      "西松分行"
    ],
    [
      "0125505",
      "桂林分行"
    ],
    [
      "0125701",
      "敦和分行"
    ],
    [
      "0125804",
      "臨沂分行"
    ],
    [
      "0125907",
      "中崙分行"
    ],
    [
      "0126007",
      "基隆路分行"
    ],
    [
      "0126100",
      "師大分行"
    ],
    [
      "0126203",
      "永春分行"
    ],
    [
      "0126214",
      "懷生分行"
    ],
    [
      "0126306",
      "民權分行"
    ],
    [
      "0126409",
      "吉林簡易型分行（客戶移撥松江分行服務）"
    ],
    [
      "0126502",
      "社子分行"
    ],
    [
      "0126605",
      "港都分行"
    ],
    [
      "0126683",
      "西湖分行"
    ],
    [
      "0126708",
      "萬隆分行（客戶移撥景美分行服務）"
    ],
    [
      "0126719",
      "中港分行"
    ],
    [
      "0126720",
      "新莊分行"
    ],
    [
      "0126731",
      "桃園分行"
    ],
    [
      "0126742",
      "台南分行"
    ],
    [
      "0126764",
      "松隆簡易型分行（客戶移撥永吉分行服務）"
    ],
    [
      "0126775",
      "埔墘分行"
    ],
    [
      "0126786",
      "北中壢分行"
    ],
    [
      "0126797",
      "三重分行"
    ],
    [
      "0126801",
      "豐原分行"
    ],
    [
      "0126812",
      "中和分行"
    ],
    [
      "0126823",
      "鼓山分行"
    ],
    [
      "0126845",
      "風城分行"
    ],
    [
      "0126856",
      "彰化分行"
    ],
    [
      "0126867",
      "東湖分行"
    ],
    [
      "0126878",
      "永和分行"
    ],
    [
      "0126889",
      "岡山分行"
    ],
    [
      "0126890",
      "台北一０一分行"
    ],
    [
      "0127015",
      "雙連分行（客戶移撥營業部服務）"
    ],
    [
      "0127026",
      "南京東路分行"
    ],
    [
      "0127037",
      "敦北分行"
    ],
    [
      "0127048",
      "仁愛分行"
    ],
    [
      "0127059",
      "高雄分行"
    ],
    [
      "0127060",
      "中正分行"
    ],
    [
      "0127071",
      "台中分行"
    ],
    [
      "0127093",
      "松高分行"
    ],
    [
      "0127107",
      "土城分行"
    ],
    [
      "0127118",
      "東寧分行"
    ],
    [
      "0127129",
      "鳳山分行"
    ],
    [
      "0127130",
      "中壢分行"
    ],
    [
      "0127152",
      "安和分行"
    ],
    [
      "0127163",
      "正義分行"
    ],
    [
      "0127174",
      "大湳分行"
    ],
    [
      "0127185",
      "嘉義分行"
    ],
    [
      "0127211",
      "板橋分行"
    ],
    [
      "0127222",
      "北台中分行"
    ],
    [
      "0127233",
      "三民分行"
    ],
    [
      "0127244",
      "建國分行"
    ],
    [
      "0127255",
      "新竹分行"
    ],
    [
      "0127266",
      "新店分行"
    ],
    [
      "0127277",
      "天母分行"
    ],
    [
      "0127288",
      "汐止分行"
    ],
    [
      "0127303",
      "永康分行"
    ],
    [
      "0127314",
      "城中分行"
    ],
    [
      "0127336",
      "五股分行（客戶移撥北新莊分行服務）"
    ],
    [
      "0127347",
      "新營分行"
    ],
    [
      "0127358",
      "屏東分行"
    ],
    [
      "0127369",
      "前鎮分行"
    ],
    [
      "0127370",
      "敦南分行"
    ],
    [
      "0127381",
      "保生分行"
    ],
    [
      "0127392",
      "員林分行"
    ],
    [
      "0127406",
      "羅東分行"
    ],
    [
      "0127417",
      "瑞湖分行"
    ],
    [
      "0127428",
      "基和簡易型分行（客戶移撥敦和分行服務）"
    ],
    [
      "0127439",
      "南昌簡易型分行（客戶移撥金華分行服務）"
    ],
    [
      "0127451",
      "花蓮分行"
    ],
    [
      "0127462",
      "竹北分行"
    ],
    [
      "0127473",
      "南台中分行"
    ],
    [
      "0127484",
      "博愛分行"
    ],
    [
      "0127495",
      "蘆洲分行"
    ],
    [
      "0127509",
      "華江分行"
    ],
    [
      "0127510",
      "大直分行"
    ],
    [
      "0127521",
      "樹林分行"
    ],
    [
      "0127532",
      "基隆分行"
    ],
    [
      "0127543",
      "竹科分行"
    ],
    [
      "0127554",
      "林口分行"
    ],
    [
      "0127565",
      "新板分行"
    ],
    [
      "0127576",
      "三峽分行"
    ],
    [
      "0127587",
      "南崁分行"
    ],
    [
      "0127598",
      "東台南分行"
    ],
    [
      "0127602",
      "左營分行"
    ],
    [
      "0127613",
      "大里分行"
    ],
    [
      "0127624",
      "得和分行"
    ],
    [
      "0127635",
      "斗六分行"
    ],
    [
      "0127646",
      "國美分行"
    ],
    [
      "0127657",
      "南勢角分行"
    ],
    [
      "0127668",
      "北屯分行"
    ],
    [
      "0127679",
      "淡水分行"
    ],
    [
      "0127680",
      "西屯分行"
    ],
    [
      "0127691",
      "北新分行"
    ],
    [
      "0127705",
      "市政分行"
    ],
    [
      "0127716",
      "北新莊分行"
    ],
    [
      "0127727",
      "大雅簡易型分行"
    ],
    [
      "0127738",
      "新北大道分行"
    ],
    [
      "0127750",
      "東林口分行"
    ],
    [
      "0127761",
      "南桃園分行"
    ],
    [
      "0127772",
      "信安分行"
    ],
    [
      "0127783",
      "光明分行"
    ],
    [
      "0127794",
      "宜蘭分行"
    ],
    [
      "0127808",
      "台東分行"
    ],
    [
      "0127819",
      "北台南分行"
    ],
    [
      "0127820",
      "竹南分行"
    ],
    [
      "0127831",
      "虎尾分行"
    ],
    [
      "0128023",
      "長安分行"
    ],
    [
      "0128034",
      "長安西路分行"
    ],
    [
      "0128045",
      "內科園區分行"
    ],
    [
      "0128056",
      "武陵分行"
    ],
    [
      "0128078",
      "東城分行"
    ],
    [
      "0128115",
      "中平分行"
    ],
    [
      "0128126",
      "小巨蛋分行"
    ],
    [
      "0128137",
      "松德分行"
    ],
    [
      "0128148",
      "介壽分行"
    ],
    [
      "0128160",
      "板南分行"
    ],
    [
      "0128171",
      "世貿分行"
    ],
    [
      "0128193",
      "前金分行"
    ],
    [
      "0128229",
      "東三重分行"
    ],
    [
      "0128230",
      "學士分行"
    ],
    [
      "0128241",
      "雙和分行"
    ],
    [
      "0128252",
      "劍潭分行"
    ],
    [
      "0128263",
      "東樹林分行"
    ],
    [
      "0128274",
      "北桃園分行"
    ],
    [
      "0128285",
      "竹城分行"
    ],
    [
      "0128296",
      "敦化分行"
    ],
    [
      "0128300",
      "北高雄分行"
    ],
    [
      "0128311",
      "東新營分行"
    ],
    [
      "0128322",
      "頭份分行"
    ],
    [
      "0128333",
      "中興分行"
    ],
    [
      "0128344",
      "光復分行"
    ],
    [
      "0128355",
      "南員林分行"
    ],
    [
      "0128366",
      "雲林分行"
    ],
    [
      "0128377",
      "屏南分行"
    ],
    [
      "0128388",
      "南海分行"
    ],
    [
      "0128399",
      "新生分行"
    ],
    [
      "0128403",
      "富錦分行"
    ],
    [
      "0128414",
      "南京分行"
    ],
    [
      "0128425",
      "縣政分行"
    ],
    [
      "0128436",
      "安平分行"
    ],
    [
      "0128458",
      "寶強分行"
    ],
    [
      "0128469",
      "金城分行"
    ],
    [
      "0128470",
      "昆陽分行"
    ],
    [
      "0128481",
      "北蘆洲分行"
    ],
    [
      "0128517",
      "重慶南路分行"
    ],
    [
      "0128562",
      "公益分行"
    ],
    [
      "0128584",
      "苓雅分行"
    ],
    [
      "0128595",
      "七賢分行"
    ],
    [
      "0128609",
      "思源分行"
    ],
    [
      "0128610",
      "東嘉義分行"
    ]
  ],
  "013": [
    [
      "0130017",
      "館前分行"
    ],
    [
      "0130028",
      "環球交易服務部"
    ],
    [
      "0130039",
      "南京東路分行"
    ],
    [
      "0130051",
      "高雄分行"
    ],
    [
      "0130062",
      "台中分行"
    ],
    [
      "0130073",
      "台北分行"
    ],
    [
      "0130095",
      "永和分行"
    ],
    [
      "0130109",
      "台南分行"
    ],
    [
      "0130110",
      "忠孝分行"
    ],
    [
      "0130121",
      "天母分行"
    ],
    [
      "0130132",
      "西台中分行"
    ],
    [
      "0130143",
      "東高雄分行"
    ],
    [
      "0130154",
      "信義分行"
    ],
    [
      "0130165",
      "光復分行"
    ],
    [
      "0130176",
      "板橋分行"
    ],
    [
      "0130187",
      "復興分行"
    ],
    [
      "0130198",
      "民權分行"
    ],
    [
      "0130202",
      "大安分行"
    ],
    [
      "0130213",
      "三重分行"
    ],
    [
      "0130224",
      "中壢分行"
    ],
    [
      "0130235",
      "員林分行"
    ],
    [
      "0130246",
      "新店分行"
    ],
    [
      "0130257",
      "新莊分行"
    ],
    [
      "0130268",
      "鳳山分行"
    ],
    [
      "0130279",
      "安和分行"
    ],
    [
      "0130280",
      "松江分行"
    ],
    [
      "0130291",
      "苓雅分行"
    ],
    [
      "0130305",
      "古亭分行"
    ],
    [
      "0130316",
      "建成分行"
    ],
    [
      "0130327",
      "東門分行"
    ],
    [
      "0130349",
      "桃園分行"
    ],
    [
      "0130350",
      "豐原分行"
    ],
    [
      "0130361",
      "嘉義分行"
    ],
    [
      "0130372",
      "松山分行"
    ],
    [
      "0130383",
      "前金分行"
    ],
    [
      "0130394",
      "北三重分行"
    ],
    [
      "0130408",
      "新竹分行"
    ],
    [
      "0130419",
      "永康分行"
    ],
    [
      "0130420",
      "中山分行"
    ],
    [
      "0130431",
      "埔墘分行"
    ],
    [
      "0130442",
      "新生分行"
    ],
    [
      "0130453",
      "中和分行"
    ],
    [
      "0130464",
      "清水分行"
    ],
    [
      "0130475",
      "彰化分行"
    ],
    [
      "0130486",
      "內科分行"
    ],
    [
      "0130497",
      "中正分行"
    ],
    [
      "0130501",
      "五權分行"
    ],
    [
      "0130512",
      "東台南分行"
    ],
    [
      "0130523",
      "新興分行"
    ],
    [
      "0130534",
      "敦南分行"
    ],
    [
      "0130545",
      "後埔分行"
    ],
    [
      "0130556",
      "蘆洲分行"
    ],
    [
      "0130567",
      "西門分行"
    ],
    [
      "0130578",
      "三民分行"
    ],
    [
      "0130590",
      "前鎮分行"
    ],
    [
      "0130604",
      "土城分行"
    ],
    [
      "0130615",
      "南高雄分行"
    ],
    [
      "0130626",
      "大同分行"
    ],
    [
      "0130637",
      "成功分行"
    ],
    [
      "0130648",
      "中港分行"
    ],
    [
      "0130659",
      "世貿分行"
    ],
    [
      "0130660",
      "北桃園分行"
    ],
    [
      "0130671",
      "善化分行"
    ],
    [
      "0130682",
      "士林分行"
    ],
    [
      "0130693",
      "雙和分行"
    ],
    [
      "0130707",
      "二重分行"
    ],
    [
      "0130729",
      "花蓮分行"
    ],
    [
      "0130730",
      "內湖分行"
    ],
    [
      "0130741",
      "華江分行"
    ],
    [
      "0130752",
      "竹科分行"
    ],
    [
      "0130763",
      "南門分行"
    ],
    [
      "0130774",
      "八德分行"
    ],
    [
      "0130785",
      "永春分行"
    ],
    [
      "0130796",
      "萬華分行"
    ],
    [
      "0131014",
      "屏東分行"
    ],
    [
      "0131025",
      "台東分行"
    ],
    [
      "0131036",
      "文山分行"
    ],
    [
      "0131047",
      "新樹分行"
    ],
    [
      "0131058",
      "宜蘭分行"
    ],
    [
      "0131069",
      "南港分行"
    ],
    [
      "0131070",
      "斗六分行"
    ],
    [
      "0131081",
      "南投分行"
    ],
    [
      "0131092",
      "汐止分行"
    ],
    [
      "0131106",
      "大直分行"
    ],
    [
      "0131117",
      "左營分行"
    ],
    [
      "0131128",
      "新營分行"
    ],
    [
      "0131139",
      "大甲分行"
    ],
    [
      "0131140",
      "苗栗分行"
    ],
    [
      "0131151",
      "北投分行"
    ],
    [
      "0131162",
      "臨安分行"
    ],
    [
      "0131173",
      "幸福分行"
    ],
    [
      "0131184",
      "華山分行"
    ],
    [
      "0131195",
      "東湖分行"
    ],
    [
      "0131209",
      "岡山分行"
    ],
    [
      "0131210",
      "臨沂分行"
    ],
    [
      "0131221",
      "新湖分行"
    ],
    [
      "0131232",
      "中崙分行"
    ],
    [
      "0131243",
      "基隆分行"
    ],
    [
      "0131254",
      "樹林分行"
    ],
    [
      "0131276",
      "淡水分行"
    ],
    [
      "0131287",
      "連城分行"
    ],
    [
      "0131298",
      "石牌分行"
    ],
    [
      "0131302",
      "南內湖分行"
    ],
    [
      "0131313",
      "景美分行"
    ],
    [
      "0131324",
      "寶橋分行"
    ],
    [
      "0131335",
      "丹鳳分行"
    ],
    [
      "0131346",
      "林口分行"
    ],
    [
      "0131357",
      "南崁分行"
    ],
    [
      "0131368",
      "東林口分行"
    ],
    [
      "0131379",
      "大湳分行"
    ],
    [
      "0131380",
      "松勤分行"
    ],
    [
      "0131391",
      "六家分行"
    ],
    [
      "0132011",
      "仁愛分行"
    ],
    [
      "0132022",
      "大昌分行"
    ],
    [
      "0132033",
      "民生分行"
    ],
    [
      "0132044",
      "篤行分行"
    ],
    [
      "0132055",
      "板東分行"
    ],
    [
      "0132066",
      "桃興分行"
    ],
    [
      "0132099",
      "嘉泰分行"
    ],
    [
      "0132103",
      "竹城分行"
    ],
    [
      "0132114",
      "忠誠分行"
    ],
    [
      "0132125",
      "敦化分行"
    ],
    [
      "0132147",
      "新泰分行"
    ],
    [
      "0132158",
      "文心分行"
    ],
    [
      "0132169",
      "福和分行"
    ],
    [
      "0132170",
      "四維分行"
    ],
    [
      "0132181",
      "營業部"
    ],
    [
      "0132206",
      "重新分行"
    ],
    [
      "0132217",
      "北中壢分行"
    ],
    [
      "0132228",
      "城東分行"
    ],
    [
      "0132239",
      "建國分行"
    ],
    [
      "0132251",
      "學府分行"
    ],
    [
      "0132262",
      "北新分行"
    ],
    [
      "0132273",
      "信安分行"
    ],
    [
      "0132295",
      "文德分行"
    ],
    [
      "0132321",
      "公益分行"
    ],
    [
      "0132332",
      "水湳分行"
    ],
    [
      "0132343",
      "市政分行"
    ],
    [
      "0132354",
      "東台中分行"
    ],
    [
      "0132365",
      "昌平分行"
    ],
    [
      "0132376",
      "健行分行"
    ],
    [
      "0132398",
      "西屯分行"
    ],
    [
      "0132402",
      "南屯分行"
    ],
    [
      "0132413",
      "崇德分行"
    ],
    [
      "0132457",
      "香山分行"
    ],
    [
      "0132468",
      "竹北分行"
    ],
    [
      "0132480",
      "同德分行"
    ],
    [
      "0132549",
      "彰美分行"
    ],
    [
      "0132550",
      "太平分行"
    ],
    [
      "0132561",
      "沙鹿分行"
    ],
    [
      "0132583",
      "大里分行"
    ],
    [
      "0132608",
      "逢甲分行"
    ],
    [
      "0132619",
      "大雅分行"
    ],
    [
      "0132620",
      "潭子分行"
    ],
    [
      "0132631",
      "光華分行"
    ],
    [
      "0132642",
      "西松分行"
    ],
    [
      "0132653",
      "蘭雅分行"
    ],
    [
      "0132664",
      "永平分行"
    ],
    [
      "0132675",
      "和平分行"
    ],
    [
      "0132686",
      "慶城分行"
    ],
    [
      "0132697",
      "瑞湖分行"
    ],
    [
      "0132701",
      "文昌分行"
    ],
    [
      "0132712",
      "正義分行"
    ],
    [
      "0132723",
      "新板分行"
    ],
    [
      "0132734",
      "永貞分行"
    ],
    [
      "0132778",
      "明誠分行"
    ]
  ],
  "016": [
    [
      "0161017",
      "營業部"
    ],
    [
      "0161028",
      "公庫部"
    ],
    [
      "0161039",
      "岡山本洲分行"
    ],
    [
      "0161040",
      "國外部"
    ],
    [
      "0161051",
      "信託部"
    ],
    [
      "0162003",
      "鳳山分行"
    ],
    [
      "0162025",
      "前金分行"
    ],
    [
      "0162036",
      "三民分行"
    ],
    [
      "0162081",
      "左營分行"
    ],
    [
      "0162106",
      "小港分行"
    ],
    [
      "0162117",
      "桃園分行"
    ],
    [
      "0162128",
      "林口分行"
    ],
    [
      "0162139",
      "右昌分行"
    ],
    [
      "0162140",
      "灣內分行"
    ],
    [
      "0162151",
      "屏東分行"
    ],
    [
      "0162162",
      "桂林分行"
    ],
    [
      "0162173",
      "北屯分行"
    ],
    [
      "0162184",
      "橋頭科學園區分行"
    ],
    [
      "0162195",
      "鼓山分行"
    ],
    [
      "0162209",
      "建國分行"
    ],
    [
      "0162210",
      "九如分行"
    ],
    [
      "0162221",
      "中壢分行"
    ],
    [
      "0162232",
      "草衙分行"
    ],
    [
      "0162243",
      "板橋分行"
    ],
    [
      "0162254",
      "台南分行"
    ],
    [
      "0162265",
      "三多分行"
    ],
    [
      "0162276",
      "大發分行"
    ],
    [
      "0162287",
      "大直分行"
    ],
    [
      "0162298",
      "台中分行"
    ],
    [
      "0162313",
      "旗津簡易型分行"
    ],
    [
      "0162324",
      "南高雄分行"
    ],
    [
      "0162335",
      "大里分行"
    ],
    [
      "0162346",
      "新竹分行"
    ],
    [
      "0162357",
      "市府分行"
    ],
    [
      "0162379",
      "中和分行"
    ],
    [
      "0162380",
      "台北分行"
    ],
    [
      "0162405",
      "成大分行"
    ],
    [
      "0162416",
      "北高雄分行"
    ],
    [
      "0162450",
      "博愛分行"
    ]
  ],
  "017": [
    [
      "0170022",
      "港都分行"
    ],
    [
      "0170033",
      "楠梓分行"
    ],
    [
      "0170044",
      "台中分行"
    ],
    [
      "0170055",
      "忠孝分行"
    ],
    [
      "0170066",
      "府城分行"
    ],
    [
      "0170077",
      "國外部"
    ],
    [
      "0170088",
      "台北復興分行"
    ],
    [
      "0170099",
      "財富管理處"
    ],
    [
      "0170103",
      "蘭雅分行"
    ],
    [
      "0170114",
      "財務處"
    ],
    [
      "0170125",
      "三重分行"
    ],
    [
      "0170136",
      "新興分行"
    ],
    [
      "0170147",
      "桃園分行"
    ],
    [
      "0170158",
      "中山分行"
    ],
    [
      "0170169",
      "高雄科技園區分行"
    ],
    [
      "0170170",
      "城中分行"
    ],
    [
      "0170181",
      "北彰化分行"
    ],
    [
      "0170192",
      "安和分行"
    ],
    [
      "0170206",
      "竹科新安分行"
    ],
    [
      "0170217",
      "天母分行"
    ],
    [
      "0170228",
      "嘉義分行"
    ],
    [
      "0170239",
      "花蓮分行"
    ],
    [
      "0170251",
      "國際金融業務分行"
    ],
    [
      "0170262",
      "北新竹分行"
    ],
    [
      "0170273",
      "板南分行"
    ],
    [
      "0170284",
      "潭子分行"
    ],
    [
      "0170295",
      "桃園國際機場分行"
    ],
    [
      "0170309",
      "南台北分行"
    ],
    [
      "0170310",
      "敦南分行"
    ],
    [
      "0170321",
      "員林分行"
    ],
    [
      "0170343",
      "永和分行"
    ],
    [
      "0170354",
      "豐原分行"
    ],
    [
      "0170365",
      "民生分行"
    ],
    [
      "0170376",
      "北台中分行"
    ],
    [
      "0170387",
      "三多分行"
    ],
    [
      "0170398",
      "中壢分行"
    ],
    [
      "0170402",
      "三民分行"
    ],
    [
      "0170413",
      "新莊分行"
    ],
    [
      "0170424",
      "松南分行"
    ],
    [
      "0170435",
      "大同分行"
    ],
    [
      "0170446",
      "南台中分行"
    ],
    [
      "0170457",
      "鳳山分行"
    ],
    [
      "0170468",
      "新店分行"
    ],
    [
      "0170479",
      "東高雄分行"
    ],
    [
      "0170480",
      "信義分行"
    ],
    [
      "0170491",
      "基隆分行"
    ],
    [
      "0170505",
      "永康分行"
    ],
    [
      "0170516",
      "內湖分行"
    ],
    [
      "0170527",
      "岡山分行"
    ],
    [
      "0170538",
      "屏東分行"
    ],
    [
      "0170550",
      "松山機場分行"
    ],
    [
      "0170561",
      "土城分行"
    ],
    [
      "0170572",
      "大稻埕分行"
    ],
    [
      "0170583",
      "頭份分行"
    ],
    [
      "0170594",
      "苓雅分行"
    ],
    [
      "0170608",
      "沙鹿分行"
    ],
    [
      "0170619",
      "八德分行"
    ],
    [
      "0170620",
      "宜蘭分行"
    ],
    [
      "0170631",
      "斗六分行"
    ],
    [
      "0170642",
      "南投分行"
    ],
    [
      "0170653",
      "東台南分行"
    ],
    [
      "0170664",
      "高雄國際機場分行"
    ],
    [
      "0170675",
      "東內湖分行"
    ],
    [
      "0170686",
      "太平分行"
    ],
    [
      "0170697",
      "中和分行"
    ],
    [
      "0170701",
      "南京東路分行"
    ],
    [
      "0170712",
      "東台中分行"
    ],
    [
      "0170723",
      "北高雄分行"
    ],
    [
      "0170745",
      "南港分行"
    ],
    [
      "0170756",
      "竹南科學園區分行"
    ],
    [
      "0170767",
      "中科分行"
    ],
    [
      "0170778",
      "大甲分行"
    ],
    [
      "0170789",
      "成功簡易型分行"
    ],
    [
      "0170790",
      "金門分行"
    ],
    [
      "0170804",
      "南崁分行"
    ],
    [
      "0170815",
      "中鋼簡易型分行"
    ],
    [
      "0170837",
      "向上分行"
    ],
    [
      "0170860",
      "駐外交部簡易型分行"
    ],
    [
      "0171030",
      "仁武分行"
    ],
    [
      "0171166",
      "高雄漁港簡易型分行"
    ],
    [
      "0172015",
      "金控總部分行"
    ],
    [
      "0172026",
      "台北分行"
    ],
    [
      "0172037",
      "新竹分行"
    ],
    [
      "0172048",
      "中台中分行"
    ],
    [
      "0172059",
      "高雄分行"
    ],
    [
      "0172060",
      "板橋分行"
    ],
    [
      "0172071",
      "桃興分行"
    ],
    [
      "0172082",
      "竹北分行"
    ],
    [
      "0172107",
      "敦化分行"
    ],
    [
      "0172129",
      "嘉興分行"
    ],
    [
      "0172130",
      "台南分行"
    ],
    [
      "0172141",
      "寶成分行"
    ],
    [
      "0172152",
      "竹科竹村分行"
    ],
    [
      "0172163",
      "世貿分行"
    ],
    [
      "0172196",
      "南三重分行"
    ],
    [
      "0172200",
      "南彰化分行"
    ],
    [
      "0172266",
      "城東分行"
    ],
    [
      "0172277",
      "五福分行"
    ],
    [
      "0172288",
      "羅東分行"
    ],
    [
      "0172299",
      "大安分行"
    ],
    [
      "0172314",
      "林口分行"
    ],
    [
      "0172325",
      "后里分行"
    ],
    [
      "0172336",
      "鹿港分行"
    ],
    [
      "0172347",
      "圓山分行"
    ],
    [
      "0172358",
      "思源分行"
    ],
    [
      "0172369",
      "北中壢分行"
    ],
    [
      "0172370",
      "內湖科學園區分行"
    ],
    [
      "0172381",
      "雙和分行"
    ],
    [
      "0172406",
      "衡陽分行"
    ],
    [
      "0172417",
      "大里分行"
    ],
    [
      "0172428",
      "台南科學園區分行"
    ]
  ],
  "018": [
    [
      "0180012",
      "營業部"
    ],
    [
      "0180034",
      "臺中分行"
    ],
    [
      "0180045",
      "高雄分行"
    ],
    [
      "0180067",
      "新竹分行"
    ],
    [
      "0180078",
      "嘉義分行"
    ],
    [
      "0180090",
      "桃園分行"
    ],
    [
      "0180104",
      "臺南分行"
    ]
  ],
  "021": [
    [
      "0210018",
      "營業部（保留僅企業金融客戶使用）"
    ]
  ],
  "048": [
    [
      "0480011",
      "營業部"
    ],
    [
      "0480022",
      "桃園分行"
    ],
    [
      "0480033",
      "高雄分行"
    ],
    [
      "0480055",
      "台中分行"
    ],
    [
      "0480066",
      "新竹分行"
    ],
    [
      "0480077",
      "南京復興分行"
    ]
  ],
  "050": [
    [
      "0500027",
      "中和分行"
    ],
    [
      "0500038",
      "博愛分行"
    ],
    [
      "0500049",
      "北桃園分行"
    ],
    [
      "0500050",
      "南崁分行"
    ],
    [
      "0500061",
      "西屯分行"
    ],
    [
      "0500072",
      "忠明分行"
    ],
    [
      "0500094",
      "金門分行"
    ],
    [
      "0500108",
      "營業部"
    ],
    [
      "0500119",
      "大雅分行"
    ],
    [
      "0500120",
      "仁大分行"
    ],
    [
      "0500201",
      "仁愛分行"
    ],
    [
      "0500212",
      "松山分行"
    ],
    [
      "0500223",
      "建成分行"
    ],
    [
      "0500234",
      "士林分行"
    ],
    [
      "0500245",
      "永和分行"
    ],
    [
      "0500256",
      "新店分行"
    ],
    [
      "0500267",
      "新莊分行"
    ],
    [
      "0500278",
      "化成分行"
    ],
    [
      "0500407",
      "松江分行"
    ],
    [
      "0500500",
      "台北分行"
    ],
    [
      "0500603",
      "萬華分行"
    ],
    [
      "0500614",
      "南台北分行"
    ],
    [
      "0500706",
      "復興分行"
    ],
    [
      "0500809",
      "中山分行"
    ],
    [
      "0500810",
      "建國分行"
    ],
    [
      "0500821",
      "內湖分行"
    ],
    [
      "0500902",
      "南京東路分行"
    ],
    [
      "0501002",
      "忠孝分行"
    ],
    [
      "0501024",
      "世貿分行"
    ],
    [
      "0501035",
      "永春分行"
    ],
    [
      "0501057",
      "南港分行"
    ],
    [
      "0501105",
      "松南分行"
    ],
    [
      "0501116",
      "東湖分行"
    ],
    [
      "0501208",
      "大安分行"
    ],
    [
      "0501219",
      "雙和分行"
    ],
    [
      "0501220",
      "錦和分行"
    ],
    [
      "0501301",
      "五股分行"
    ],
    [
      "0501312",
      "林口分行"
    ],
    [
      "0501323",
      "東林口分行"
    ],
    [
      "0501404",
      "板橋分行"
    ],
    [
      "0501415",
      "樹林分行"
    ],
    [
      "0501426",
      "土城分行"
    ],
    [
      "0501437",
      "迴龍分行"
    ],
    [
      "0501448",
      "汐止分行"
    ],
    [
      "0501482",
      "三峽分行"
    ],
    [
      "0501507",
      "基隆分行"
    ],
    [
      "0501518",
      "埔墘分行"
    ],
    [
      "0501529",
      "北三重分行"
    ],
    [
      "0501530",
      "南三重分行"
    ],
    [
      "0501541",
      "蘆洲分行"
    ],
    [
      "0501600",
      "宜蘭分行"
    ],
    [
      "0501703",
      "羅東分行"
    ],
    [
      "0501714",
      "蘇澳分行"
    ],
    [
      "0502906",
      "楊梅分行"
    ],
    [
      "0502917",
      "湖口分行"
    ],
    [
      "0503006",
      "桃園分行"
    ],
    [
      "0503017",
      "大園分行"
    ],
    [
      "0503028",
      "大溪分行"
    ],
    [
      "0503109",
      "中壢分行"
    ],
    [
      "0503110",
      "內壢分行"
    ],
    [
      "0503121",
      "新明分行"
    ],
    [
      "0503132",
      "東桃園分行"
    ],
    [
      "0503154",
      "新屋分行"
    ],
    [
      "0503202",
      "新竹分行"
    ],
    [
      "0503213",
      "竹北分行"
    ],
    [
      "0503224",
      "竹科分行"
    ],
    [
      "0503305",
      "八德分行"
    ],
    [
      "0503327",
      "龍潭分行"
    ],
    [
      "0503408",
      "竹東分行"
    ],
    [
      "0503501",
      "竹南分行"
    ],
    [
      "0503512",
      "頭份分行"
    ],
    [
      "0503604",
      "苗栗分行"
    ],
    [
      "0504601",
      "豐原分行"
    ],
    [
      "0504704",
      "太平分行"
    ],
    [
      "0504807",
      "大甲分行"
    ],
    [
      "0504829",
      "沙鹿分行"
    ],
    [
      "0504830",
      "烏日分行"
    ],
    [
      "0504900",
      "台中分行"
    ],
    [
      "0504911",
      "民權分行"
    ],
    [
      "0505000",
      "興中分行"
    ],
    [
      "0505011",
      "北屯分行"
    ],
    [
      "0505103",
      "南投分行"
    ],
    [
      "0505114",
      "草屯分行"
    ],
    [
      "0505206",
      "埔里分行"
    ],
    [
      "0505217",
      "潭子分行"
    ],
    [
      "0505309",
      "竹山分行"
    ],
    [
      "0505402",
      "彰化分行"
    ],
    [
      "0505413",
      "和美分行"
    ],
    [
      "0505505",
      "員林分行"
    ],
    [
      "0505608",
      "北斗分行"
    ],
    [
      "0505619",
      "二林分行"
    ],
    [
      "0506605",
      "斗六分行"
    ],
    [
      "0506708",
      "北港分行"
    ],
    [
      "0506719",
      "虎尾分行"
    ],
    [
      "0506801",
      "嘉義分行"
    ],
    [
      "0506812",
      "民雄分行"
    ],
    [
      "0506867",
      "嘉新分行"
    ],
    [
      "0506904",
      "新營分行"
    ],
    [
      "0506915",
      "開元分行"
    ],
    [
      "0507004",
      "永康分行"
    ],
    [
      "0507015",
      "學甲分行"
    ],
    [
      "0507026",
      "善化分行"
    ],
    [
      "0507037",
      "永大分行"
    ],
    [
      "0507107",
      "台南分行"
    ],
    [
      "0507118",
      "仁德分行"
    ],
    [
      "0507200",
      "成功分行"
    ],
    [
      "0507211",
      "東台南分行"
    ],
    [
      "0507303",
      "安平分行"
    ],
    [
      "0507602",
      "花蓮分行"
    ],
    [
      "0507705",
      "台東分行"
    ],
    [
      "0508207",
      "東高雄分行"
    ],
    [
      "0508300",
      "岡山分行"
    ],
    [
      "0508403",
      "北鳳山分行"
    ],
    [
      "0508414",
      "苓雅分行"
    ],
    [
      "0508506",
      "高雄分行"
    ],
    [
      "0508517",
      "北高雄分行"
    ],
    [
      "0508528",
      "大昌分行"
    ],
    [
      "0508539",
      "前鎮分行"
    ],
    [
      "0508609",
      "九如分行"
    ],
    [
      "0508702",
      "三民分行"
    ],
    [
      "0508805",
      "鳳山分行"
    ],
    [
      "0508816",
      "大發分行"
    ],
    [
      "0508908",
      "屏東分行"
    ],
    [
      "0508919",
      "小港分行"
    ],
    [
      "0508920",
      "潮州分行"
    ]
  ],
  "052": [
    [
      "0520041",
      "中壢分行"
    ],
    [
      "0520052",
      "竹東分行"
    ],
    [
      "0520063",
      "竹南分行"
    ],
    [
      "0520074",
      "苗栗分行"
    ],
    [
      "0520122",
      "新屋分行"
    ],
    [
      "0520133",
      "湖口分行"
    ],
    [
      "0520144",
      "苑裡分行"
    ],
    [
      "0520166",
      "龍潭分行"
    ],
    [
      "0520177",
      "竹北分行"
    ],
    [
      "0520199",
      "三民分行"
    ],
    [
      "0520214",
      "八德分行"
    ],
    [
      "0520225",
      "新明分行"
    ],
    [
      "0520247",
      "公館分行"
    ],
    [
      "0520269",
      "後龍分行"
    ],
    [
      "0520281",
      "南崁分行"
    ],
    [
      "0520328",
      "光復分行"
    ],
    [
      "0520373",
      "埔心分行"
    ],
    [
      "0520384",
      "新豐分行"
    ],
    [
      "0520454",
      "中正分行"
    ],
    [
      "0520476",
      "環北分行"
    ],
    [
      "0520513",
      "新興分行"
    ],
    [
      "0520524",
      "新社分行"
    ],
    [
      "0520579",
      "北新竹分行"
    ],
    [
      "0520649",
      "東內壢分行"
    ],
    [
      "0520672",
      "新店分行"
    ],
    [
      "0520683",
      "公西分行"
    ],
    [
      "0520708",
      "莊敬分行"
    ],
    [
      "0520719",
      "板橋分行"
    ],
    [
      "0520731",
      "豐原分行"
    ],
    [
      "0520742",
      "文心分行"
    ],
    [
      "0520753",
      "內湖分行"
    ],
    [
      "0520764",
      "九如分行"
    ],
    [
      "0520775",
      "台南分行"
    ],
    [
      "0520797",
      "南屯分行"
    ],
    [
      "0520812",
      "東寧分行"
    ],
    [
      "0520878",
      "北屯分行"
    ],
    [
      "0520889",
      "西屯分行"
    ],
    [
      "0520926",
      "彰化分行"
    ],
    [
      "0520959",
      "敦北分行"
    ],
    [
      "0520960",
      "北高雄分行"
    ],
    [
      "0520971",
      "台中分行"
    ],
    [
      "0520982",
      "高雄分行"
    ],
    [
      "0521015",
      "復興分行"
    ],
    [
      "0521060",
      "三多分行"
    ],
    [
      "0521093",
      "南京分行"
    ],
    [
      "0521118",
      "信義分行"
    ],
    [
      "0521129",
      "營業部"
    ],
    [
      "0521141",
      "敦化分行"
    ],
    [
      "0521152",
      "天母分行"
    ],
    [
      "0521163",
      "仁愛分行"
    ],
    [
      "0521185",
      "中山分行"
    ],
    [
      "0521196",
      "古亭分行"
    ],
    [
      "0521200",
      "大直分行"
    ],
    [
      "0521211",
      "金山分行"
    ]
  ],
  "053": [
    [
      "0530019",
      "中正分行"
    ],
    [
      "0530020",
      "營業部"
    ],
    [
      "0530042",
      "南台中分行"
    ],
    [
      "0530053",
      "霧峰分行"
    ],
    [
      "0530064",
      "大甲分行"
    ],
    [
      "0530075",
      "沙鹿分行"
    ],
    [
      "0530086",
      "豐原分行"
    ],
    [
      "0530097",
      "東勢分行"
    ],
    [
      "0530101",
      "彰化分行"
    ],
    [
      "0530112",
      "溪湖分行"
    ],
    [
      "0530123",
      "員林分行"
    ],
    [
      "0530134",
      "田中分行"
    ],
    [
      "0530145",
      "北斗分行"
    ],
    [
      "0530156",
      "二林分行"
    ],
    [
      "0530167",
      "南投分行"
    ],
    [
      "0530189",
      "草屯分行"
    ],
    [
      "0530190",
      "竹山分行"
    ],
    [
      "0530204",
      "埔里分行"
    ],
    [
      "0530215",
      "鹿港分行"
    ],
    [
      "0530226",
      "西台中分行"
    ],
    [
      "0530237",
      "清水分行"
    ],
    [
      "0530248",
      "東豐原分行"
    ],
    [
      "0530259",
      "烏日分行"
    ],
    [
      "0530271",
      "北台中分行"
    ],
    [
      "0530318",
      "和美分行"
    ],
    [
      "0530330",
      "西屯分行"
    ],
    [
      "0530341",
      "太平分行"
    ],
    [
      "0530363",
      "大雅分行"
    ],
    [
      "0530374",
      "后里分行"
    ],
    [
      "0530385",
      "潭子分行"
    ],
    [
      "0530396",
      "社頭分行"
    ],
    [
      "0530400",
      "永靖分行"
    ],
    [
      "0530411",
      "花壇分行"
    ],
    [
      "0530422",
      "秀水分行"
    ],
    [
      "0530444",
      "南屯分行"
    ],
    [
      "0530455",
      "大肚分行"
    ],
    [
      "0530466",
      "神岡分行"
    ],
    [
      "0530477",
      "內新分行"
    ],
    [
      "0530488",
      "伸港分行"
    ],
    [
      "0530499",
      "北太平分行"
    ],
    [
      "0530503",
      "台中港分行"
    ],
    [
      "0530514",
      "北員林分行"
    ],
    [
      "0530525",
      "南陽分行"
    ],
    [
      "0530536",
      "左營分行"
    ],
    [
      "0530570",
      "埤頭分行"
    ],
    [
      "0530581",
      "四民分行"
    ],
    [
      "0530592",
      "軍功分行"
    ],
    [
      "0530639",
      "北屯分行"
    ],
    [
      "0530662",
      "埔心分行"
    ],
    [
      "0530684",
      "台北分行"
    ],
    [
      "0530710",
      "松山分行"
    ],
    [
      "0530721",
      "三重分行"
    ],
    [
      "0530732",
      "高雄分行"
    ],
    [
      "0530754",
      "龍井分行"
    ],
    [
      "0530776",
      "林口分行"
    ],
    [
      "0530787",
      "虎尾分行"
    ],
    [
      "0530798",
      "苑裡分行"
    ],
    [
      "0530813",
      "斗南分行"
    ],
    [
      "0530824",
      "竹南分行"
    ],
    [
      "0530846",
      "內湖分行"
    ],
    [
      "0530857",
      "鳳山分行"
    ],
    [
      "0530868",
      "板橋分行"
    ],
    [
      "0530880",
      "新莊分行"
    ],
    [
      "0530891",
      "民雄分行"
    ],
    [
      "0530905",
      "桃園分行"
    ],
    [
      "0530916",
      "永康分行"
    ],
    [
      "0530927",
      "竹北分行"
    ],
    [
      "0530938",
      "南崁分行"
    ],
    [
      "0530949",
      "新竹分行"
    ],
    [
      "0530950",
      "內壢分行"
    ],
    [
      "0530961",
      "新豐分行"
    ],
    [
      "0530972",
      "大園分行"
    ],
    [
      "0530983",
      "中壢分行"
    ],
    [
      "0531005",
      "楊梅分行"
    ],
    [
      "0531016",
      "土城分行"
    ],
    [
      "0531038",
      "復興分行"
    ],
    [
      "0531050",
      "中山分行"
    ],
    [
      "0531061",
      "大同分行"
    ],
    [
      "0531072",
      "台南分行"
    ],
    [
      "0531083",
      "新港分行"
    ],
    [
      "0531094",
      "新店分行"
    ],
    [
      "0531108",
      "燕巢分行"
    ],
    [
      "0531119",
      "麥寮分行"
    ]
  ],
  "054": [
    [
      "0540010",
      "營業部"
    ],
    [
      "0540032",
      "台南分行"
    ],
    [
      "0540043",
      "嘉義分行"
    ],
    [
      "0540054",
      "新營分行"
    ],
    [
      "0540065",
      "鹽水分行"
    ],
    [
      "0540076",
      "虎尾分行"
    ],
    [
      "0540087",
      "斗六分行"
    ],
    [
      "0540098",
      "民雄分行"
    ],
    [
      "0540102",
      "北港分行"
    ],
    [
      "0540113",
      "麻豆分行"
    ],
    [
      "0540124",
      "朴子分行"
    ],
    [
      "0540135",
      "佳里分行"
    ],
    [
      "0540146",
      "梅山分行"
    ],
    [
      "0540157",
      "斗南分行"
    ],
    [
      "0540180",
      "東台南分行"
    ],
    [
      "0540227",
      "西螺分行"
    ],
    [
      "0540249",
      "善化分行"
    ],
    [
      "0540250",
      "學甲分行"
    ],
    [
      "0540272",
      "開元分行"
    ],
    [
      "0540283",
      "永康分行"
    ],
    [
      "0540294",
      "新市分行"
    ],
    [
      "0540308",
      "仁德分行"
    ],
    [
      "0540319",
      "六甲分行"
    ],
    [
      "0540320",
      "安南分行"
    ],
    [
      "0540331",
      "中埔分行"
    ],
    [
      "0540342",
      "崙背分行"
    ],
    [
      "0540353",
      "西港分行"
    ],
    [
      "0540364",
      "新化分行"
    ],
    [
      "0540375",
      "竹崎分行"
    ],
    [
      "0540397",
      "安和分行"
    ],
    [
      "0540401",
      "新興分行"
    ],
    [
      "0540412",
      "中華分行"
    ],
    [
      "0540434",
      "白河分行"
    ],
    [
      "0540445",
      "興業分行"
    ],
    [
      "0540467",
      "水上分行"
    ],
    [
      "0540489",
      "府城分行"
    ],
    [
      "0540504",
      "歸仁分行"
    ],
    [
      "0540515",
      "鹽行分行"
    ],
    [
      "0540537",
      "台北分行"
    ],
    [
      "0540548",
      "大林分行"
    ],
    [
      "0540607",
      "關廟分行"
    ],
    [
      "0540641",
      "太保分行"
    ],
    [
      "0540652",
      "蘆洲分行"
    ],
    [
      "0540663",
      "玉井分行"
    ],
    [
      "0540696",
      "高雄分行"
    ],
    [
      "0540700",
      "台中分行"
    ],
    [
      "0540711",
      "內湖分行"
    ],
    [
      "0540744",
      "桃園分行"
    ],
    [
      "0540755",
      "雙和分行"
    ],
    [
      "0540766",
      "岡山分行"
    ],
    [
      "0540777",
      "中正分行"
    ],
    [
      "0540788",
      "忠孝分行"
    ],
    [
      "0540799",
      "北高雄分行"
    ],
    [
      "0540814",
      "板橋分行"
    ],
    [
      "0540825",
      "文心分行"
    ],
    [
      "0540836",
      "松山分行"
    ],
    [
      "0540847",
      "新莊分行"
    ],
    [
      "0540858",
      "新竹分行"
    ],
    [
      "0540869",
      "中壢分行"
    ],
    [
      "0540870",
      "新店分行"
    ],
    [
      "0540881",
      "南崁分行"
    ],
    [
      "0540892",
      "大里分行"
    ],
    [
      "0540906",
      "楠梓分行"
    ],
    [
      "0540917",
      "彰化分行"
    ],
    [
      "0540928",
      "東新竹分行"
    ],
    [
      "0540939",
      "裕農分行"
    ]
  ],
  "081": [
    [
      "0810016",
      "台北分行"
    ],
    [
      "0810027",
      "高雄分行"
    ],
    [
      "0810049",
      "台中分行"
    ],
    [
      "0810050",
      "台南分行"
    ],
    [
      "0810061",
      "板橋分行"
    ],
    [
      "0810083",
      "建國分行"
    ],
    [
      "0810094",
      "天母分行"
    ],
    [
      "0810120",
      "光復分行"
    ],
    [
      "0810164",
      "新板分行"
    ],
    [
      "0810186",
      "古亭分行"
    ],
    [
      "0810197",
      "苓雅分行"
    ],
    [
      "0810201",
      "南港分行"
    ],
    [
      "0810212",
      "林口分行"
    ],
    [
      "0810223",
      "新竹分行"
    ],
    [
      "0810234",
      "松江分行"
    ],
    [
      "0810304",
      "安和分行"
    ],
    [
      "0810315",
      "中壢分行"
    ],
    [
      "0810326",
      "仁愛分行"
    ],
    [
      "0810360",
      "內湖分行"
    ],
    [
      "0810382",
      "復興分行"
    ],
    [
      "0810511",
      "國美分行"
    ],
    [
      "0810522",
      "敦南分行"
    ],
    [
      "0810533",
      "桃園分行"
    ],
    [
      "0810566",
      "大直分行"
    ],
    [
      "0810577",
      "士林分行"
    ],
    [
      "0810599",
      "崇德分行"
    ]
  ],
  "101": [
    [
      "1010011",
      "營業部"
    ],
    [
      "1010020",
      "民生分行"
    ],
    [
      "1010039",
      "建成分行"
    ],
    [
      "1010048",
      "大橋分行"
    ],
    [
      "1010057",
      "南京東路分行"
    ],
    [
      "1010066",
      "昆明分行"
    ],
    [
      "1010075",
      "長安分行"
    ],
    [
      "1010084",
      "永吉分行"
    ],
    [
      "1010093",
      "和平東路分行"
    ],
    [
      "1010109",
      "石牌分行"
    ],
    [
      "1010118",
      "內湖分行"
    ],
    [
      "1010127",
      "成功簡易型分行"
    ],
    [
      "1010136",
      "古亭分行"
    ],
    [
      "1010145",
      "景美分行"
    ],
    [
      "1010154",
      "南港分行"
    ],
    [
      "1010163",
      "信義簡易型分行"
    ],
    [
      "1010172",
      "萬華分行"
    ],
    [
      "1010181",
      "士林分行"
    ],
    [
      "1010190",
      "松山簡易型分行"
    ],
    [
      "1010206",
      "城內分行"
    ],
    [
      "1010215",
      "桃園分行"
    ],
    [
      "1010224",
      "中和分行"
    ]
  ],
  "102": [
    [
      "1020010",
      "營業部"
    ],
    [
      "1020029",
      "迪化街分行"
    ],
    [
      "1020038",
      "建成分行"
    ],
    [
      "1020047",
      "大同分行"
    ],
    [
      "1020056",
      "中山分行"
    ],
    [
      "1020065",
      "大安分行"
    ],
    [
      "1020074",
      "松山分行"
    ],
    [
      "1020083",
      "古亭分行"
    ],
    [
      "1020092",
      "士林分行"
    ],
    [
      "1020108",
      "內湖分行"
    ],
    [
      "1020117",
      "信義分行"
    ],
    [
      "1020126",
      "永吉分行"
    ],
    [
      "1020135",
      "和平分行"
    ],
    [
      "1020144",
      "光復分行"
    ],
    [
      "1020153",
      "文山分行"
    ],
    [
      "1020171",
      "石牌分行"
    ],
    [
      "1020180",
      "萬華分行"
    ],
    [
      "1020199",
      "桃園分行"
    ],
    [
      "1020205",
      "松德分行"
    ],
    [
      "1020214",
      "新莊分行"
    ],
    [
      "1020223",
      "中和分行"
    ],
    [
      "1020232",
      "板橋分行"
    ],
    [
      "1020241",
      "南京東路分行"
    ],
    [
      "1020250",
      "敦化分行"
    ],
    [
      "1020269",
      "新店分行"
    ],
    [
      "1020278",
      "中壢分行"
    ],
    [
      "1020287",
      "高雄分行"
    ],
    [
      "1020296",
      "三重分行"
    ],
    [
      "1020302",
      "總部分行"
    ],
    [
      "1020348",
      "台南分行"
    ],
    [
      "1020357",
      "北高雄分行"
    ],
    [
      "1020366",
      "台中分行"
    ],
    [
      "1020375",
      "彰化分行"
    ],
    [
      "1020384",
      "北台中分行"
    ]
  ],
  "103": [
    [
      "1030019",
      "中正分行"
    ],
    [
      "1030028",
      "東台北分行"
    ],
    [
      "1030037",
      "龍山分行"
    ],
    [
      "1030046",
      "西園分行"
    ],
    [
      "1030055",
      "西門分行"
    ],
    [
      "1030064",
      "大同分行"
    ],
    [
      "1030073",
      "復興分行"
    ],
    [
      "1030082",
      "忠孝分行"
    ],
    [
      "1030091",
      "五常分行"
    ],
    [
      "1030107",
      "城北分行"
    ],
    [
      "1030116",
      "城內分行"
    ],
    [
      "1030134",
      "新金湖分行"
    ],
    [
      "1030143",
      "慶城分行"
    ],
    [
      "1030152",
      "內湖分行"
    ],
    [
      "1030161",
      "世貿分行"
    ],
    [
      "1030170",
      "松山分行"
    ],
    [
      "1030189",
      "南港分行"
    ],
    [
      "1030198",
      "林森北路分行"
    ],
    [
      "1030204",
      "大安分行"
    ],
    [
      "1030213",
      "新竹分行"
    ],
    [
      "1030222",
      "中壢分行"
    ],
    [
      "1030231",
      "桃園分行"
    ],
    [
      "1030240",
      "東三重分行"
    ],
    [
      "1030259",
      "竹北分行"
    ],
    [
      "1030268",
      "連城路分行"
    ],
    [
      "1030277",
      "竹科分行"
    ],
    [
      "1030286",
      "土城分行"
    ],
    [
      "1030295",
      "蘆洲分行"
    ],
    [
      "1030301",
      "建成分行"
    ],
    [
      "1030310",
      "北三重分行"
    ],
    [
      "1030329",
      "永和分行"
    ],
    [
      "1030338",
      "新埔分行"
    ],
    [
      "1030347",
      "台中分行"
    ],
    [
      "1030356",
      "中港分行"
    ],
    [
      "1030365",
      "左營華夏路分行"
    ],
    [
      "1030374",
      "大甲分行"
    ],
    [
      "1030383",
      "大墩分行"
    ],
    [
      "1030392",
      "員林分行"
    ],
    [
      "1030408",
      "南屯分行"
    ],
    [
      "1030417",
      "東台南分行"
    ],
    [
      "1030426",
      "大里分行"
    ],
    [
      "1030435",
      "松竹分行"
    ],
    [
      "1030444",
      "彰化分行"
    ],
    [
      "1030453",
      "樹林分行"
    ],
    [
      "1030462",
      "新板分行"
    ],
    [
      "1030471",
      "古亭分行"
    ],
    [
      "1030480",
      "士林分行"
    ],
    [
      "1030499",
      "營業部"
    ],
    [
      "1030505",
      "丹鳳分行"
    ],
    [
      "1030514",
      "北投復興崗分行"
    ],
    [
      "1030523",
      "新生南路分行"
    ],
    [
      "1030541",
      "新營分行"
    ],
    [
      "1030550",
      "天母簡易型分行"
    ],
    [
      "1030569",
      "新店分行"
    ],
    [
      "1030578",
      "大直分行"
    ],
    [
      "1030587",
      "興隆分行"
    ],
    [
      "1030596",
      "八德分行"
    ],
    [
      "1030611",
      "長安分行"
    ],
    [
      "1030620",
      "嘉義分行"
    ],
    [
      "1030648",
      "鳳山分行"
    ],
    [
      "1030657",
      "台南分行"
    ],
    [
      "1030666",
      "北嘉義分行"
    ],
    [
      "1030675",
      "斗六分行"
    ],
    [
      "1030684",
      "竹南分行"
    ],
    [
      "1030693",
      "花蓮分行"
    ],
    [
      "1030709",
      "基隆分行"
    ],
    [
      "1030718",
      "宜蘭分行"
    ],
    [
      "1030727",
      "三峽分行"
    ],
    [
      "1030736",
      "路竹分行"
    ],
    [
      "1030745",
      "高雄分行"
    ],
    [
      "1030754",
      "新莊分行"
    ],
    [
      "1030763",
      "江子翠分行"
    ],
    [
      "1030772",
      "林口分行"
    ],
    [
      "1030781",
      "彌陀簡易型分行"
    ],
    [
      "1030790",
      "岡山分行"
    ],
    [
      "1030806",
      "北高雄分行"
    ],
    [
      "1030824",
      "小港分行"
    ],
    [
      "1030833",
      "中華分行"
    ],
    [
      "1030842",
      "承德分行"
    ],
    [
      "1030851",
      "敦南分行"
    ],
    [
      "1030860",
      "中和分行"
    ],
    [
      "1030879",
      "南台中分行"
    ],
    [
      "1030888",
      "水湳分行"
    ],
    [
      "1030897",
      "北屯分行"
    ],
    [
      "1030903",
      "西屯分行"
    ],
    [
      "1030912",
      "向上分行"
    ],
    [
      "1030921",
      "十甲分行"
    ],
    [
      "1030930",
      "豐原分行"
    ],
    [
      "1030949",
      "永安分行"
    ],
    [
      "1030958",
      "屏東分行"
    ],
    [
      "1030967",
      "東園分行"
    ],
    [
      "1030976",
      "萬丹分行"
    ],
    [
      "1030985",
      "七賢分行"
    ],
    [
      "1031003",
      "汐止分行"
    ],
    [
      "1031012",
      "桃北分行"
    ],
    [
      "1031021",
      "六家分行"
    ],
    [
      "1031030",
      "九如分行"
    ],
    [
      "1031049",
      "永康分行"
    ],
    [
      "1031058",
      "青埔分行"
    ],
    [
      "1031067",
      "沙鹿分行"
    ],
    [
      "1031076",
      "大雅分行"
    ],
    [
      "1031094",
      "草屯分行"
    ],
    [
      "1031100",
      "南東分行"
    ]
  ],
  "108": [
    [
      "1080014",
      "營業部"
    ],
    [
      "1080023",
      "石牌分行"
    ],
    [
      "1080032",
      "北投分行"
    ],
    [
      "1080041",
      "社子分行"
    ],
    [
      "1080050",
      "士林分行"
    ],
    [
      "1080069",
      "大屯分行"
    ],
    [
      "1080078",
      "劍潭分行"
    ],
    [
      "1080087",
      "蘭雅分行"
    ],
    [
      "1080096",
      "天母分行"
    ],
    [
      "1080102",
      "社中分行"
    ],
    [
      "1080111",
      "吉林分行"
    ],
    [
      "1080120",
      "成功分行"
    ],
    [
      "1080139",
      "民生分行"
    ],
    [
      "1080148",
      "延吉分行"
    ],
    [
      "1080157",
      "木柵分行"
    ],
    [
      "1080166",
      "龍江分行"
    ],
    [
      "1080175",
      "南京分行"
    ],
    [
      "1080184",
      "景美分行"
    ],
    [
      "1080193",
      "中興分行"
    ],
    [
      "1080209",
      "信義分行"
    ],
    [
      "1080218",
      "中和分行"
    ],
    [
      "1080227",
      "永和分行"
    ],
    [
      "1080236",
      "蘆洲分行"
    ],
    [
      "1080245",
      "板橋分行"
    ],
    [
      "1080263",
      "新和分行"
    ],
    [
      "1080272",
      "溪洲分行"
    ],
    [
      "1080281",
      "泰山分行"
    ],
    [
      "1080290",
      "新莊分行"
    ],
    [
      "1080306",
      "古亭分行"
    ],
    [
      "1080315",
      "三重分行"
    ],
    [
      "1080324",
      "大業分行"
    ],
    [
      "1080333",
      "雙和分行"
    ],
    [
      "1080342",
      "復興分行"
    ],
    [
      "1080351",
      "大安分行"
    ],
    [
      "1080360",
      "桃園分行"
    ],
    [
      "1080379",
      "新店分行"
    ],
    [
      "1080397",
      "新福分行"
    ],
    [
      "1080403",
      "新竹分行"
    ],
    [
      "1080412",
      "員林分行"
    ],
    [
      "1080421",
      "花蓮分行"
    ],
    [
      "1080430",
      "精武分行"
    ],
    [
      "1080449",
      "社頭分行"
    ],
    [
      "1080458",
      "屏東分行"
    ],
    [
      "1080467",
      "和平分行"
    ],
    [
      "1080476",
      "高雄分行"
    ],
    [
      "1080485",
      "大同分行"
    ],
    [
      "1080494",
      "北屯分行"
    ],
    [
      "1080500",
      "嘉義分行"
    ],
    [
      "1080519",
      "新埔分行"
    ],
    [
      "1080528",
      "台南分行"
    ],
    [
      "1080555",
      "東寧分行"
    ],
    [
      "1080564",
      "中華分行"
    ],
    [
      "1080573",
      "健康分行"
    ],
    [
      "1080582",
      "台中分行"
    ],
    [
      "1080607",
      "西華分行"
    ],
    [
      "1080616",
      "安順分行"
    ],
    [
      "1080634",
      "左營分行"
    ],
    [
      "1080643",
      "向上分行"
    ],
    [
      "1080652",
      "內湖分行"
    ],
    [
      "1080661",
      "中壢分行"
    ],
    [
      "1080670",
      "五股分行"
    ],
    [
      "1080689",
      "林森分行"
    ],
    [
      "1080698",
      "立文分行"
    ],
    [
      "1080704",
      "新興分行"
    ],
    [
      "1080713",
      "青年分行"
    ],
    [
      "1080722",
      "三鳳分行"
    ],
    [
      "1080731",
      "四維分行"
    ],
    [
      "1080740",
      "大公分行"
    ],
    [
      "1080759",
      "大順分行"
    ],
    [
      "1080768",
      "海光分行"
    ],
    [
      "1080777",
      "前鎮分行"
    ],
    [
      "1080786",
      "平等分行"
    ],
    [
      "1080795",
      "基隆分行"
    ],
    [
      "1080801",
      "小港分行"
    ],
    [
      "1080810",
      "右昌分行"
    ],
    [
      "1080829",
      "汐止分行"
    ],
    [
      "1080838",
      "五甲分行"
    ],
    [
      "1080847",
      "鼎力分行"
    ],
    [
      "1080856",
      "楠梓分行"
    ],
    [
      "1080865",
      "旗山分行"
    ],
    [
      "1080874",
      "土城分行"
    ],
    [
      "1080883",
      "南桃園分行"
    ],
    [
      "1080917",
      "林園分行"
    ],
    [
      "1080926",
      "岡山分行"
    ],
    [
      "1080935",
      "仁德分行"
    ],
    [
      "1080944",
      "東桃園分行"
    ],
    [
      "1080953",
      "永康分行"
    ],
    [
      "1080971",
      "南港分行"
    ],
    [
      "1080980",
      "里港分行"
    ],
    [
      "1080999",
      "大里分行"
    ],
    [
      "1081017",
      "萬華分行"
    ],
    [
      "1081026",
      "臺北分行"
    ],
    [
      "1081035",
      "長安分行"
    ],
    [
      "1081053",
      "羅東分行"
    ],
    [
      "1081062",
      "竹北分行"
    ],
    [
      "1081071",
      "重新分行"
    ],
    [
      "1081080",
      "彰化分行"
    ],
    [
      "1081336",
      "苗栗分行"
    ],
    [
      "1081354",
      "龍井分行"
    ],
    [
      "1081363",
      "雲林分行"
    ],
    [
      "1081372",
      "南投分行"
    ],
    [
      "1081503",
      "臺東分行"
    ],
    [
      "1081512",
      "宜蘭分行"
    ],
    [
      "1081567",
      "林口分行"
    ],
    [
      "1081576",
      "豐原分行"
    ],
    [
      "1081585",
      "竹科分行"
    ],
    [
      "1081594",
      "總部分行"
    ]
  ],
  "118": [
    [
      "1180011",
      "板橋分行"
    ],
    [
      "1180020",
      "後埔分行"
    ],
    [
      "1180039",
      "永和分行"
    ],
    [
      "1180048",
      "埔墘分行"
    ],
    [
      "1180057",
      "華江分行"
    ],
    [
      "1180066",
      "民族分行"
    ],
    [
      "1180075",
      "中和分行"
    ],
    [
      "1180084",
      "土城分行"
    ],
    [
      "1180093",
      "文化分行"
    ],
    [
      "1180109",
      "大觀分行"
    ],
    [
      "1180118",
      "興南分行"
    ],
    [
      "1180145",
      "小港分行"
    ],
    [
      "1180163",
      "新興分行"
    ],
    [
      "1180181",
      "前鎮分行"
    ],
    [
      "1180206",
      "陽明分行"
    ],
    [
      "1180215",
      "高新莊分行"
    ],
    [
      "1180279",
      "信義分行"
    ],
    [
      "1180288",
      "新莊分行"
    ],
    [
      "1180297",
      "秀朗分行"
    ],
    [
      "1180303",
      "桃園分行"
    ],
    [
      "1180312",
      "三重分行"
    ],
    [
      "1180330",
      "員山分行"
    ],
    [
      "1180349",
      "桃鶯分行"
    ],
    [
      "1180358",
      "民生分行"
    ],
    [
      "1180367",
      "龍岡分行"
    ],
    [
      "1180385",
      "樹林分行"
    ],
    [
      "1180394",
      "金城分行"
    ],
    [
      "1180400",
      "新竹分行"
    ],
    [
      "1180419",
      "八德分行"
    ],
    [
      "1180428",
      "台中分行"
    ],
    [
      "1180437",
      "台南分行"
    ],
    [
      "1180446",
      "新店分行"
    ],
    [
      "1180455",
      "內湖分行"
    ],
    [
      "1180482",
      "中正分行"
    ],
    [
      "1180507",
      "嘉義分行"
    ],
    [
      "1180598",
      "蘆洲分行"
    ],
    [
      "1180604",
      "羅東分行"
    ],
    [
      "1180613",
      "北台中分行"
    ],
    [
      "1180622",
      "成功分行"
    ],
    [
      "1180631",
      "福和分行"
    ],
    [
      "1180659",
      "營業部"
    ],
    [
      "1180668",
      "瑞光分行"
    ],
    [
      "1180677",
      "丹鳳分行"
    ],
    [
      "1180686",
      "北新分行"
    ],
    [
      "1180695",
      "艋舺分行"
    ],
    [
      "1180701",
      "興隆分行"
    ],
    [
      "1180710",
      "雙園分行"
    ],
    [
      "1180729",
      "西門分行"
    ],
    [
      "1180738",
      "古亭分行"
    ],
    [
      "1180747",
      "安東分行"
    ],
    [
      "1180756",
      "松山分行"
    ],
    [
      "1180765",
      "士林分行"
    ],
    [
      "1180774",
      "東湖分行"
    ],
    [
      "1180792",
      "復興分行"
    ],
    [
      "1180808",
      "民權分行"
    ],
    [
      "1180817",
      "重慶分行"
    ],
    [
      "1180826",
      "木柵分行"
    ],
    [
      "1180844",
      "大直分行"
    ],
    [
      "1180853",
      "萬大分行"
    ],
    [
      "1180880",
      "南京東路分行"
    ],
    [
      "1180899",
      "北桃園分行"
    ],
    [
      "1180905",
      "環東分行"
    ],
    [
      "1180914",
      "汐止分行"
    ],
    [
      "1180923",
      "燕巢分行"
    ],
    [
      "1180932",
      "苗栗分行"
    ],
    [
      "1180941",
      "南港分行"
    ]
  ],
  "147": [
    [
      "1470013",
      "台中分行"
    ],
    [
      "1470022",
      "營業部"
    ],
    [
      "1470040",
      "成功分行"
    ],
    [
      "1470059",
      "西屯分行"
    ],
    [
      "1470068",
      "國光分行"
    ],
    [
      "1470077",
      "大智分行"
    ],
    [
      "1470086",
      "林森分行"
    ],
    [
      "1470095",
      "南門分行"
    ],
    [
      "1470101",
      "進化分行"
    ],
    [
      "1470110",
      "南屯分行"
    ],
    [
      "1470138",
      "北屯分行"
    ],
    [
      "1470147",
      "豐原分行"
    ],
    [
      "1470156",
      "彰化分行"
    ],
    [
      "1470165",
      "員林分行"
    ],
    [
      "1470183",
      "台北分行"
    ],
    [
      "1470192",
      "桃園分行"
    ],
    [
      "1470208",
      "板橋分行"
    ],
    [
      "1470253",
      "豐信分行"
    ],
    [
      "1470262",
      "中山分行"
    ],
    [
      "1470299",
      "台南分行"
    ],
    [
      "1470305",
      "高雄分行"
    ],
    [
      "1470314",
      "新莊分行"
    ],
    [
      "1470323",
      "新竹分行"
    ],
    [
      "1470332",
      "鳳山分行"
    ],
    [
      "1470341",
      "大雅分行"
    ],
    [
      "1470350",
      "橋頭分行"
    ],
    [
      "1470369",
      "大肚分行"
    ],
    [
      "1470378",
      "龍井分行"
    ],
    [
      "1470387",
      "田中分行"
    ],
    [
      "1470396",
      "太平分行"
    ],
    [
      "1470402",
      "青埔分行"
    ],
    [
      "1470411",
      "烏日分行"
    ]
  ],
  "803": [
    [
      "8030010",
      "台北分行"
    ],
    [
      "8030021",
      "營業部"
    ],
    [
      "8030032",
      "桃園分行"
    ],
    [
      "8030043",
      "台中分行"
    ],
    [
      "8030054",
      "南京東路分行"
    ],
    [
      "8030065",
      "中壢分行"
    ],
    [
      "8030076",
      "三重分行"
    ],
    [
      "8030098",
      "東台北分行"
    ],
    [
      "8030102",
      "高雄分行"
    ],
    [
      "8030113",
      "板橋分行"
    ],
    [
      "8030124",
      "台南分行"
    ],
    [
      "8030135",
      "員林分行"
    ],
    [
      "8030157",
      "仁愛分行"
    ],
    [
      "8030168",
      "南崁分行"
    ],
    [
      "8030179",
      "新竹分行"
    ],
    [
      "8030180",
      "蘆洲分行"
    ],
    [
      "8030205",
      "九如分行"
    ],
    [
      "8030216",
      "雙和分行"
    ],
    [
      "8030227",
      "迴龍分行"
    ],
    [
      "8030238",
      "嘉義分行"
    ],
    [
      "8030249",
      "公館分行"
    ],
    [
      "8030250",
      "內壢分行"
    ],
    [
      "8030261",
      "忠孝分行"
    ],
    [
      "8030272",
      "新莊分行"
    ],
    [
      "8030283",
      "鳳山分行"
    ],
    [
      "8030294",
      "桃鶯分行"
    ],
    [
      "8030308",
      "龍潭分行"
    ],
    [
      "8030319",
      "新店分行"
    ],
    [
      "8030320",
      "大直分行"
    ],
    [
      "8030331",
      "中山分行"
    ],
    [
      "8030342",
      "文心分行"
    ],
    [
      "8030353",
      "健行分行"
    ],
    [
      "8030364",
      "中和分行"
    ],
    [
      "8030375",
      "內湖分行"
    ],
    [
      "8030386",
      "大園分行"
    ],
    [
      "8030397",
      "永和分行"
    ],
    [
      "8030401",
      "中港分行"
    ],
    [
      "8030412",
      "通化簡易型分行"
    ],
    [
      "8030423",
      "士東分行"
    ],
    [
      "8030434",
      "微風簡易型分行"
    ],
    [
      "8030445",
      "長春分行"
    ],
    [
      "8030456",
      "松江分行"
    ],
    [
      "8030467",
      "大安分行"
    ],
    [
      "8030478",
      "永吉分行"
    ],
    [
      "8030489",
      "文林分行"
    ],
    [
      "8030490",
      "東門分行"
    ],
    [
      "8030515",
      "西湖分行"
    ],
    [
      "8030526",
      "北投簡易型分行"
    ],
    [
      "8030537",
      "北三重分行"
    ],
    [
      "8030548",
      "後埔分行"
    ],
    [
      "8030559",
      "北中和簡易型分行"
    ],
    [
      "8030560",
      "富國分行"
    ],
    [
      "8030571",
      "樹林分行"
    ],
    [
      "8030582",
      "汐止分行"
    ],
    [
      "8030593",
      "北桃園分行"
    ],
    [
      "8030607",
      "北中壢分行"
    ],
    [
      "8030618",
      "北台中分行"
    ],
    [
      "8030629",
      "民權分行"
    ],
    [
      "8030630",
      "西屯分行"
    ],
    [
      "8030641",
      "興中分行"
    ],
    [
      "8030652",
      "北屯分行"
    ],
    [
      "8030685",
      "府城分行"
    ],
    [
      "8030696",
      "豐原分行"
    ],
    [
      "8030700",
      "富強分行"
    ],
    [
      "8030711",
      "開元分行"
    ],
    [
      "8030722",
      "南台南分行"
    ],
    [
      "8030733",
      "苓雅分行"
    ],
    [
      "8030744",
      "北高雄分行"
    ],
    [
      "8030755",
      "三民分行"
    ],
    [
      "8030766",
      "五甲分行"
    ],
    [
      "8030777",
      "屏東分行"
    ],
    [
      "8030788",
      "和平分行"
    ],
    [
      "8030799",
      "永春分行"
    ],
    [
      "8030803",
      "田心分行"
    ],
    [
      "8030814",
      "安康分行"
    ],
    [
      "8030825",
      "大竹分行"
    ],
    [
      "8030836",
      "龜山分行"
    ],
    [
      "8030847",
      "林口分行"
    ],
    [
      "8030858",
      "五股分行"
    ],
    [
      "8030869",
      "高榮分行"
    ],
    [
      "8030870",
      "大業分行"
    ],
    [
      "8030881",
      "蘆竹分行"
    ],
    [
      "8030892",
      "土城分行"
    ],
    [
      "8030906",
      "南桃園分行"
    ],
    [
      "8030917",
      "集賢分行"
    ],
    [
      "8030928",
      "三峽分行"
    ],
    [
      "8030939",
      "東湖分行"
    ],
    [
      "8030940",
      "淡水簡易型分行"
    ],
    [
      "8030951",
      "金城分行"
    ],
    [
      "8030962",
      "南港分行"
    ]
  ],
  "805": [
    [
      "8050012",
      "營業部"
    ],
    [
      "8050023",
      "台北城中分行"
    ],
    [
      "8050034",
      "台北逸仙分行"
    ],
    [
      "8050045",
      "桃園分行"
    ],
    [
      "8050056",
      "台中公益分行"
    ],
    [
      "8050067",
      "台南分行"
    ],
    [
      "8050078",
      "高雄五福分行"
    ],
    [
      "8050090",
      "板橋南雅分行"
    ],
    [
      "8050104",
      "新竹巨城分行"
    ],
    [
      "8050115",
      "高雄中正分行"
    ],
    [
      "8050148",
      "三重分行"
    ],
    [
      "8050159",
      "台北松江分行"
    ],
    [
      "8050160",
      "永康分行"
    ],
    [
      "8050171",
      "中壢分行"
    ],
    [
      "8050193",
      "永和分行"
    ],
    [
      "8050207",
      "台北東門分行"
    ],
    [
      "8050218",
      "高雄文化中心分行"
    ],
    [
      "8050229",
      "台中文心分行"
    ],
    [
      "8050230",
      "新竹科學園區分行"
    ],
    [
      "8050241",
      "桃園大興分行"
    ],
    [
      "8050252",
      "台北南門分行"
    ],
    [
      "8050263",
      "台北新莊分行"
    ],
    [
      "8050274",
      "台北松山分行"
    ],
    [
      "8050285",
      "新店分行"
    ],
    [
      "8050296",
      "台北重慶分行"
    ],
    [
      "8050300",
      "竹北分行"
    ],
    [
      "8050311",
      "台北忠孝分行"
    ],
    [
      "8050322",
      "林口分行"
    ],
    [
      "8050333",
      "板橋文化分行"
    ],
    [
      "8050344",
      "台中自由分行"
    ],
    [
      "8050355",
      "新莊富國分行"
    ],
    [
      "8050366",
      "台北永吉分行"
    ],
    [
      "8050388",
      "桃園大有分行"
    ],
    [
      "8050399",
      "台北金湖分行"
    ],
    [
      "8050414",
      "台北承德分行"
    ],
    [
      "8050425",
      "台北古亭分行"
    ],
    [
      "8050436",
      "台北信義分行"
    ],
    [
      "8050458",
      "蘆洲分行"
    ],
    [
      "8050469",
      "中和分行"
    ],
    [
      "8050470",
      "板橋中正分行"
    ],
    [
      "8050481",
      "新竹經國分行"
    ],
    [
      "8050492",
      "台中大雅分行"
    ],
    [
      "8050506",
      "台中朝富分行"
    ],
    [
      "8050517",
      "南投分行"
    ],
    [
      "8050528",
      "嘉義分行"
    ],
    [
      "8050540",
      "高雄博愛分行"
    ],
    [
      "8050562",
      "大里分行"
    ],
    [
      "8050573",
      "崇德分行"
    ],
    [
      "8050584",
      "板橋大遠百分行"
    ],
    [
      "8050595",
      "台北敦南分行"
    ],
    [
      "8050609",
      "雙和分行"
    ],
    [
      "8050610",
      "台北南京東路分行"
    ],
    [
      "8050621",
      "台北大稻埕分行"
    ],
    [
      "8050632",
      "石牌分行"
    ],
    [
      "8050654",
      "台北復興簡易型分行"
    ]
  ],
  "806": [
    [
      "8060013",
      "台中分行"
    ],
    [
      "8060024",
      "文心分行"
    ],
    [
      "8060035",
      "台北分行"
    ],
    [
      "8060046",
      "沙鹿分行"
    ],
    [
      "8060057",
      "豐原分行"
    ],
    [
      "8060068",
      "彰化分行"
    ],
    [
      "8060079",
      "員林分行"
    ],
    [
      "8060080",
      "三重分行"
    ],
    [
      "8060091",
      "平鎮分行"
    ],
    [
      "8060105",
      "草屯分行"
    ],
    [
      "8060116",
      "永康分行"
    ],
    [
      "8060150",
      "景美分行"
    ],
    [
      "8060161",
      "新竹分行"
    ],
    [
      "8060172",
      "鹿港分行"
    ],
    [
      "8060183",
      "斗信分行"
    ],
    [
      "8060194",
      "嘉義分行"
    ],
    [
      "8060219",
      "南京東路分行"
    ],
    [
      "8060220",
      "永和分行"
    ],
    [
      "8060231",
      "復興分行"
    ],
    [
      "8060242",
      "大里分行"
    ],
    [
      "8060253",
      "博愛分行"
    ],
    [
      "8060264",
      "苗栗分行"
    ],
    [
      "8060275",
      "崇德分行"
    ],
    [
      "8060286",
      "北斗分行"
    ],
    [
      "8060297",
      "佳里分行"
    ],
    [
      "8060301",
      "大甲分行"
    ],
    [
      "8060312",
      "虎尾分行"
    ],
    [
      "8060334",
      "士林分行"
    ],
    [
      "8060345",
      "南崁分行"
    ],
    [
      "8060367",
      "古亭分行"
    ],
    [
      "8060378",
      "新莊分行"
    ],
    [
      "8060389",
      "中壢分行"
    ],
    [
      "8060404",
      "三民分行"
    ],
    [
      "8060415",
      "城中分行"
    ],
    [
      "8060426",
      "屏東分行"
    ],
    [
      "8060448",
      "斗南分行"
    ],
    [
      "8060482",
      "板橋分行"
    ],
    [
      "8060493",
      "桃園分行"
    ],
    [
      "8060518",
      "三多分行"
    ],
    [
      "8060529",
      "東信分行"
    ],
    [
      "8060585",
      "內湖分行"
    ],
    [
      "8060596",
      "羅東分行"
    ],
    [
      "8060600",
      "金門分行"
    ],
    [
      "8060611",
      "台南分行"
    ],
    [
      "8060622",
      "林口分行"
    ],
    [
      "8060633",
      "竹北分行"
    ],
    [
      "8060688",
      "府城分行"
    ],
    [
      "8060699",
      "府東分行"
    ],
    [
      "8060806",
      "開元分行"
    ],
    [
      "8060828",
      "安和分行"
    ],
    [
      "8060839",
      "中和分行"
    ],
    [
      "8060840",
      "松江分行"
    ],
    [
      "8060851",
      "竹科分行"
    ],
    [
      "8060862",
      "天母分行"
    ],
    [
      "8060873",
      "蘆洲分行"
    ],
    [
      "8060884",
      "信義分行"
    ],
    [
      "8060895",
      "中山北路分行"
    ],
    [
      "8060909",
      "民生分行"
    ],
    [
      "8060910",
      "新店分行"
    ],
    [
      "8060932",
      "忠孝分行"
    ],
    [
      "8060943",
      "桃興分行"
    ],
    [
      "8060954",
      "中港分行"
    ],
    [
      "8060965",
      "花蓮分行"
    ],
    [
      "8060976",
      "承德分行"
    ],
    [
      "8060987",
      "太平分行"
    ],
    [
      "8060998",
      "營業部"
    ],
    [
      "8061009",
      "土城分行"
    ],
    [
      "8061021",
      "大同分行"
    ],
    [
      "8061032",
      "松山分行"
    ],
    [
      "8061043",
      "新生分行"
    ],
    [
      "8061076",
      "北三重分行"
    ],
    [
      "8061087",
      "上新莊分行"
    ],
    [
      "8061102",
      "高雄分行"
    ],
    [
      "8061191",
      "大統分行"
    ],
    [
      "8061205",
      "雙和分行"
    ],
    [
      "8061216",
      "北投分行"
    ],
    [
      "8061227",
      "延平分行"
    ],
    [
      "8061238",
      "文德分行"
    ],
    [
      "8061250",
      "左營分行"
    ],
    [
      "8061261",
      "埔墘分行"
    ],
    [
      "8061272",
      "公館分行"
    ],
    [
      "8061283",
      "新店中正分行"
    ],
    [
      "8061308",
      "西門分行"
    ],
    [
      "8061319",
      "樹林分行"
    ],
    [
      "8061320",
      "光復分行"
    ],
    [
      "8061331",
      "南港分行"
    ],
    [
      "8061342",
      "苓雅分行"
    ],
    [
      "8061353",
      "敦化分行"
    ],
    [
      "8061364",
      "屏榮分行"
    ],
    [
      "8061375",
      "前鎮中山分行"
    ],
    [
      "8061386",
      "高鳳分行"
    ],
    [
      "8061397",
      "北府分行"
    ],
    [
      "8061401",
      "南嘉義分行"
    ],
    [
      "8061412",
      "東台北分行"
    ],
    [
      "8061423",
      "南新莊分行"
    ],
    [
      "8061434",
      "新壢分行"
    ],
    [
      "8061445",
      "水湳分行"
    ],
    [
      "8061456",
      "大昌分行"
    ],
    [
      "8061467",
      "大直分行"
    ],
    [
      "8061478",
      "東板橋分行"
    ],
    [
      "8061489",
      "大雅分行"
    ],
    [
      "8061490",
      "十全分行"
    ],
    [
      "8061504",
      "延吉分行"
    ],
    [
      "8061526",
      "成功分行"
    ],
    [
      "8061548",
      "右昌分行"
    ],
    [
      "8061559",
      "前金分行"
    ],
    [
      "8061560",
      "五甲分行"
    ],
    [
      "8061571",
      "連城分行"
    ],
    [
      "8061582",
      "新營分行"
    ],
    [
      "8061593",
      "和平分行"
    ],
    [
      "8061607",
      "金華分行"
    ],
    [
      "8061618",
      "瑞光分行"
    ],
    [
      "8061629",
      "灣裡分行"
    ],
    [
      "8061630",
      "安南分行"
    ],
    [
      "8061641",
      "江翠分行"
    ],
    [
      "8061652",
      "長庚分行"
    ],
    [
      "8061674",
      "世貿分行"
    ],
    [
      "8061685",
      "東新竹分行"
    ],
    [
      "8061696",
      "汐止分行"
    ],
    [
      "8061700",
      "忠誠分行"
    ],
    [
      "8061722",
      "澄清分行"
    ],
    [
      "8061733",
      "秀朗分行"
    ],
    [
      "8061744",
      "小港分行"
    ],
    [
      "8061755",
      "北桃園分行"
    ],
    [
      "8061766",
      "永春分行"
    ],
    [
      "8061777",
      "圓山分行"
    ],
    [
      "8061788",
      "基隆分行"
    ],
    [
      "8061799",
      "彰興分行"
    ],
    [
      "8061814",
      "大里德芳分行"
    ],
    [
      "8061825",
      "北台中分行"
    ],
    [
      "8061836",
      "旗津分行"
    ],
    [
      "8061858",
      "鼓山分行"
    ],
    [
      "8061869",
      "前鎮分行"
    ],
    [
      "8061870",
      "岡山分行"
    ],
    [
      "8061881",
      "中正分行"
    ],
    [
      "8061892",
      "石牌分行"
    ],
    [
      "8061928",
      "南門分行"
    ],
    [
      "8061939",
      "新板分行"
    ],
    [
      "8061940",
      "北新分行"
    ],
    [
      "8061951",
      "南屯分行"
    ],
    [
      "8061962",
      "民生三民分行"
    ],
    [
      "8061973",
      "東門分行"
    ],
    [
      "8061984",
      "金城分行"
    ],
    [
      "8061995",
      "民族分行"
    ],
    [
      "8062006",
      "頭份分行"
    ],
    [
      "8062017",
      "萬華分行"
    ],
    [
      "8062028",
      "敦安分行"
    ],
    [
      "8062039",
      "環東分行"
    ],
    [
      "8062040",
      "城東分行"
    ]
  ],
  "807": [
    [
      "8070014",
      "世貿分行"
    ],
    [
      "8070025",
      "敦北分行"
    ],
    [
      "8070036",
      "台中分行"
    ],
    [
      "8070047",
      "高雄分行"
    ],
    [
      "8070058",
      "忠孝分行"
    ],
    [
      "8070069",
      "西松分行"
    ],
    [
      "8070070",
      "板新分行"
    ],
    [
      "8070092",
      "敦南分行"
    ],
    [
      "8070106",
      "新泰分行"
    ],
    [
      "8070117",
      "桃園分行"
    ],
    [
      "8070128",
      "北台中分行"
    ],
    [
      "8070139",
      "台南分行"
    ],
    [
      "8070151",
      "松江分行"
    ],
    [
      "8070162",
      "嘉義分行"
    ],
    [
      "8070173",
      "三民分行"
    ],
    [
      "8070184",
      "新竹分行"
    ],
    [
      "8070195",
      "三重分行"
    ],
    [
      "8070210",
      "台北分行"
    ],
    [
      "8070221",
      "彰化分行"
    ],
    [
      "8070232",
      "岡山分行"
    ],
    [
      "8070243",
      "中壢分行"
    ],
    [
      "8070254",
      "鳳山分行"
    ],
    [
      "8070276",
      "北新分行"
    ],
    [
      "8070287",
      "屏東分行"
    ],
    [
      "8070298",
      "北桃園分行"
    ],
    [
      "8070302",
      "學府分行"
    ],
    [
      "8070313",
      "南高雄分行"
    ],
    [
      "8070324",
      "光華分行"
    ],
    [
      "8070335",
      "東門分行"
    ],
    [
      "8070346",
      "天母分行"
    ],
    [
      "8070357",
      "東板橋分行"
    ],
    [
      "8070368",
      "東台南分行"
    ],
    [
      "8070379",
      "竹南分行"
    ],
    [
      "8070380",
      "南台中分行"
    ],
    [
      "8070391",
      "竹北自強分行"
    ],
    [
      "8070405",
      "永康分行"
    ],
    [
      "8070416",
      "中科分行"
    ],
    [
      "8070427",
      "北高雄分行"
    ],
    [
      "8070438",
      "金門分行"
    ],
    [
      "8070449",
      "興大分行"
    ],
    [
      "8070450",
      "中崙分行"
    ],
    [
      "8070461",
      "西湖分行"
    ],
    [
      "8070472",
      "豐原分行"
    ],
    [
      "8070483",
      "大里分行"
    ],
    [
      "8071011",
      "忠孝東路分行"
    ],
    [
      "8071033",
      "建成分行"
    ],
    [
      "8071044",
      "西門分行"
    ],
    [
      "8071055",
      "萬華分行"
    ],
    [
      "8071066",
      "興隆分行"
    ],
    [
      "8071077",
      "南門分行"
    ],
    [
      "8071088",
      "長安分行"
    ],
    [
      "8071099",
      "延平分行"
    ],
    [
      "8071103",
      "北投分行"
    ],
    [
      "8071114",
      "松山分行"
    ],
    [
      "8071125",
      "中山分行"
    ],
    [
      "8071136",
      "士林分行"
    ],
    [
      "8071158",
      "雙園分行"
    ],
    [
      "8071169",
      "永和分行"
    ],
    [
      "8071170",
      "板橋分行"
    ],
    [
      "8071181",
      "基隆分行"
    ],
    [
      "8071192",
      "羅東分行"
    ],
    [
      "8071206",
      "宜蘭分行"
    ],
    [
      "8071217",
      "營業部"
    ],
    [
      "8071228",
      "景美分行"
    ],
    [
      "8071239",
      "新莊分行"
    ],
    [
      "8071251",
      "汐止分行"
    ],
    [
      "8071262",
      "城中分行"
    ],
    [
      "8071273",
      "光復分行"
    ],
    [
      "8071284",
      "正義分行"
    ],
    [
      "8071295",
      "中和分行"
    ],
    [
      "8071310",
      "士東分行"
    ],
    [
      "8071321",
      "中港分行"
    ],
    [
      "8071332",
      "蘆洲分行"
    ],
    [
      "8071343",
      "內湖分行"
    ],
    [
      "8071354",
      "社子分行"
    ],
    [
      "8071365",
      "信義分行"
    ],
    [
      "8071376",
      "永春分行"
    ],
    [
      "8071387",
      "南三重分行"
    ],
    [
      "8071398",
      "積穗分行"
    ],
    [
      "8071402",
      "鶯歌分行"
    ],
    [
      "8071413",
      "新店分行"
    ],
    [
      "8071435",
      "西盛分行"
    ],
    [
      "8071446",
      "板橋忠孝分行"
    ],
    [
      "8071457",
      "思源分行"
    ],
    [
      "8071468",
      "土城分行"
    ],
    [
      "8071479",
      "三興分行"
    ],
    [
      "8071480",
      "龍江分行"
    ],
    [
      "8071491",
      "樹林分行"
    ],
    [
      "8071505",
      "五股分行"
    ],
    [
      "8071538",
      "松德分行"
    ],
    [
      "8071549",
      "東湖分行"
    ],
    [
      "8071550",
      "華江分行"
    ],
    [
      "8071561",
      "北三重分行"
    ],
    [
      "8071572",
      "蘭雅分行"
    ],
    [
      "8071583",
      "德惠分行"
    ],
    [
      "8071594",
      "迴龍分行"
    ],
    [
      "8071608",
      "仁愛分行"
    ],
    [
      "8071620",
      "和平分行"
    ],
    [
      "8071642",
      "重新分行"
    ],
    [
      "8071653",
      "中興分行"
    ],
    [
      "8071664",
      "海山分行"
    ],
    [
      "8071697",
      "南蘆洲分行"
    ],
    [
      "8071701",
      "江子翠分行"
    ],
    [
      "8071712",
      "民安分行"
    ],
    [
      "8071723",
      "苓雅分行"
    ],
    [
      "8071734",
      "林口忠孝分行"
    ],
    [
      "8071745",
      "板橋民族分行"
    ],
    [
      "8071756",
      "泰山分行"
    ],
    [
      "8071767",
      "花蓮分行"
    ],
    [
      "8071778",
      "南港分行"
    ],
    [
      "8071789",
      "深坑分行"
    ],
    [
      "8071790",
      "南崁分行"
    ],
    [
      "8071804",
      "北台南分行"
    ],
    [
      "8071815",
      "西屯分行"
    ],
    [
      "8071826",
      "成大分行"
    ],
    [
      "8071837",
      "濟南路分行"
    ],
    [
      "8071859",
      "南桃園分行"
    ],
    [
      "8071860",
      "竹科分行"
    ],
    [
      "8071871",
      "員林分行"
    ],
    [
      "8071882",
      "楊梅分行"
    ],
    [
      "8071893",
      "內壢分行"
    ],
    [
      "8071907",
      "重慶北路分行"
    ],
    [
      "8071929",
      "大園分行"
    ],
    [
      "8071930",
      "竹北光明分行"
    ],
    [
      "8071963",
      "竹圍分行"
    ]
  ],
  "808": [
    [
      "8080015",
      "營業部"
    ],
    [
      "8080026",
      "南京東路分行"
    ],
    [
      "8080048",
      "城東分行"
    ],
    [
      "8080059",
      "新莊分行"
    ],
    [
      "8080060",
      "新竹分行"
    ],
    [
      "8080071",
      "嘉義分行"
    ],
    [
      "8080082",
      "高雄分行"
    ],
    [
      "8080118",
      "基隆路分行"
    ],
    [
      "8080129",
      "雙和分行"
    ],
    [
      "8080130",
      "中壢分行"
    ],
    [
      "8080141",
      "文心分行"
    ],
    [
      "8080152",
      "台南分行"
    ],
    [
      "8080163",
      "天母分行"
    ],
    [
      "8080174",
      "埔墘分行"
    ],
    [
      "8080185",
      "桃園分行"
    ],
    [
      "8080196",
      "前鎮分行"
    ],
    [
      "8080211",
      "民生分行"
    ],
    [
      "8080222",
      "大里分行"
    ],
    [
      "8080233",
      "永康分行"
    ],
    [
      "8080244",
      "鳳山分行"
    ],
    [
      "8080255",
      "三和分行"
    ],
    [
      "8080266",
      "土城分行"
    ],
    [
      "8080277",
      "八德分行"
    ],
    [
      "8080288",
      "大墩分行"
    ],
    [
      "8080299",
      "七賢分行"
    ],
    [
      "8080303",
      "復興分行"
    ],
    [
      "8080314",
      "敦南分行"
    ],
    [
      "8080325",
      "三重分行"
    ],
    [
      "8080336",
      "彰化分行"
    ],
    [
      "8080347",
      "北高雄分行"
    ],
    [
      "8080358",
      "大雅分行"
    ],
    [
      "8080369",
      "楊梅分行"
    ],
    [
      "8080370",
      "樹林分行"
    ],
    [
      "8080381",
      "豐原分行"
    ],
    [
      "8080392",
      "斗六分行"
    ],
    [
      "8080406",
      "長春分行"
    ],
    [
      "8080417",
      "中山分行"
    ],
    [
      "8080428",
      "佳里分行"
    ],
    [
      "8080439",
      "中和分行"
    ],
    [
      "8080440",
      "竹南分行"
    ],
    [
      "8080451",
      "羅東分行"
    ],
    [
      "8080462",
      "內湖分行"
    ],
    [
      "8080473",
      "壢新分行"
    ],
    [
      "8080484",
      "板新分行"
    ],
    [
      "8080495",
      "光華分行"
    ],
    [
      "8080509",
      "東嘉義分行"
    ],
    [
      "8080510",
      "成功分行"
    ],
    [
      "8080521",
      "水湳分行"
    ],
    [
      "8080532",
      "城中分行"
    ],
    [
      "8080543",
      "五股分行"
    ],
    [
      "8080554",
      "新店分行"
    ],
    [
      "8080565",
      "松山分行"
    ],
    [
      "8080576",
      "和平分行"
    ],
    [
      "8080587",
      "新板特區分行"
    ],
    [
      "8080598",
      "民權分行"
    ],
    [
      "8080602",
      "新莊副都心分行"
    ],
    [
      "8080613",
      "南崁分行"
    ],
    [
      "8080624",
      "台大分行"
    ],
    [
      "8080635",
      "左營分行"
    ],
    [
      "8080646",
      "楠梓分行"
    ],
    [
      "8080657",
      "士林分行"
    ],
    [
      "8080668",
      "苓雅分行"
    ],
    [
      "8080679",
      "仁愛分行"
    ],
    [
      "8080680",
      "南屯分行"
    ],
    [
      "8080691",
      "木柵分行"
    ],
    [
      "8080705",
      "大昌分行"
    ],
    [
      "8080716",
      "台東分行"
    ],
    [
      "8080727",
      "澄清分行"
    ],
    [
      "8080738",
      "小港分行"
    ],
    [
      "8080749",
      "北新莊分行"
    ],
    [
      "8080750",
      "竹北分行"
    ],
    [
      "8080761",
      "東台南分行"
    ],
    [
      "8080772",
      "集賢分行"
    ],
    [
      "8080783",
      "基隆分行"
    ],
    [
      "8080794",
      "岡山分行"
    ],
    [
      "8080808",
      "連城分行"
    ],
    [
      "8080819",
      "林園分行"
    ],
    [
      "8080820",
      "蘆洲分行"
    ],
    [
      "8080831",
      "後庄分行"
    ],
    [
      "8080842",
      "中路特區分行"
    ],
    [
      "8080853",
      "東三重分行"
    ],
    [
      "8080864",
      "北投分行"
    ],
    [
      "8080875",
      "忠孝分行"
    ],
    [
      "8080886",
      "林口分行"
    ],
    [
      "8080897",
      "東湖分行"
    ],
    [
      "8080901",
      "北新分行"
    ],
    [
      "8080912",
      "中崙分行"
    ],
    [
      "8080923",
      "建成分行"
    ],
    [
      "8080934",
      "屏東分行"
    ],
    [
      "8080945",
      "二重分行"
    ],
    [
      "8080956",
      "台北分行"
    ],
    [
      "8080967",
      "大安分行"
    ],
    [
      "8080978",
      "東港分行"
    ],
    [
      "8080989",
      "古亭分行"
    ],
    [
      "8080990",
      "草屯分行"
    ],
    [
      "8081001",
      "新營分行"
    ],
    [
      "8081012",
      "迴龍分行"
    ],
    [
      "8081023",
      "花蓮分行"
    ],
    [
      "8081034",
      "澎湖分行"
    ],
    [
      "8081045",
      "三峽分行"
    ],
    [
      "8081056",
      "新生分行"
    ],
    [
      "8081067",
      "金華分行"
    ],
    [
      "8081078",
      "光復分行"
    ],
    [
      "8081089",
      "新湖分行"
    ],
    [
      "8081090",
      "桃鶯分行"
    ],
    [
      "8081104",
      "員林分行"
    ],
    [
      "8081115",
      "永安分行"
    ],
    [
      "8081126",
      "新豐分行"
    ],
    [
      "8081137",
      "仁德分行"
    ],
    [
      "8081148",
      "泰和分行"
    ],
    [
      "8081159",
      "西屯分行"
    ],
    [
      "8081160",
      "南勢角分行"
    ],
    [
      "8081171",
      "板橋分行"
    ],
    [
      "8081182",
      "南港分行"
    ],
    [
      "8081193",
      "東門分行"
    ],
    [
      "8081207",
      "南土城分行"
    ],
    [
      "8081218",
      "朴子分行"
    ],
    [
      "8081229",
      "信義分行"
    ],
    [
      "8081230",
      "汐止分行"
    ],
    [
      "8081241",
      "新樹分行"
    ],
    [
      "8081252",
      "中工分行"
    ],
    [
      "8081263",
      "台中都心分行"
    ],
    [
      "8081274",
      "鹽行分行"
    ],
    [
      "8081285",
      "頭份分行"
    ],
    [
      "8081296",
      "後龍分行"
    ],
    [
      "8081300",
      "五權分行"
    ],
    [
      "8081311",
      "南永康分行"
    ],
    [
      "8081322",
      "藝文分行"
    ],
    [
      "8081333",
      "中原分行"
    ],
    [
      "8081344",
      "竹科分行"
    ],
    [
      "8081355",
      "太平分行"
    ],
    [
      "8081366",
      "台中分行"
    ],
    [
      "8081377",
      "六家分行"
    ],
    [
      "8081388",
      "北屯分行"
    ],
    [
      "8081399",
      "烏日分行"
    ],
    [
      "8081403",
      "安南分行"
    ],
    [
      "8081425",
      "沙鹿分行"
    ],
    [
      "8081436",
      "東林口分行"
    ],
    [
      "8081458",
      "南山廣場分行"
    ]
  ],
  "809": [
    [
      "8090016",
      "中山分行"
    ],
    [
      "8090027",
      "忠孝分行"
    ],
    [
      "8090038",
      "三重分行"
    ],
    [
      "8090049",
      "台中分行"
    ],
    [
      "8090050",
      "台南分行"
    ],
    [
      "8090061",
      "高雄分行"
    ],
    [
      "8090072",
      "城東分行"
    ],
    [
      "8090108",
      "板橋分行"
    ],
    [
      "8090119",
      "桃園分行"
    ],
    [
      "8090120",
      "中壢分行"
    ],
    [
      "8090131",
      "北高雄分行"
    ],
    [
      "8090153",
      "新莊分行"
    ],
    [
      "8090164",
      "左營分行"
    ],
    [
      "8090175",
      "員林分行"
    ],
    [
      "8090197",
      "敦南分行"
    ],
    [
      "8090201",
      "松江分行"
    ],
    [
      "8090212",
      "蘆洲分行"
    ],
    [
      "8090223",
      "鳳山分行"
    ],
    [
      "8090234",
      "新竹分行"
    ],
    [
      "8090245",
      "松山分行"
    ],
    [
      "8090256",
      "土城分行"
    ],
    [
      "8090267",
      "中和分行"
    ],
    [
      "8090278",
      "赤崁分行"
    ],
    [
      "8090289",
      "基隆分行"
    ],
    [
      "8090304",
      "東門分行"
    ],
    [
      "8090315",
      "北門分行"
    ],
    [
      "8090326",
      "屏東分行"
    ],
    [
      "8090337",
      "雙和分行"
    ],
    [
      "8090348",
      "歸仁分行"
    ],
    [
      "8090359",
      "海東分行"
    ],
    [
      "8090371",
      "永康分行"
    ],
    [
      "8090382",
      "天母分行"
    ],
    [
      "8090393",
      "新店分行"
    ],
    [
      "8090407",
      "大安分行"
    ],
    [
      "8090429",
      "苗栗分行"
    ],
    [
      "8090452",
      "花蓮分行"
    ],
    [
      "8090474",
      "彰化分行"
    ],
    [
      "8090485",
      "豐原分行"
    ],
    [
      "8090511",
      "大里分行"
    ],
    [
      "8090522",
      "嘉義分行"
    ],
    [
      "8090577",
      "風城分行"
    ],
    [
      "8090588",
      "南大分行"
    ],
    [
      "8090599",
      "竹科分行"
    ],
    [
      "8090625",
      "台東分行"
    ],
    [
      "8090669",
      "羅東分行"
    ],
    [
      "8090670",
      "大直分行"
    ],
    [
      "8090681",
      "高美館分行"
    ],
    [
      "8090692",
      "市政分行"
    ],
    [
      "8090706",
      "藝文分行"
    ],
    [
      "8090717",
      "瑞光分行"
    ],
    [
      "8090728",
      "民生分行"
    ]
  ],
  "810": [
    [
      "8100021",
      "忠孝分行"
    ],
    [
      "8100054",
      "桃園分行"
    ],
    [
      "8100098",
      "台南分行"
    ],
    [
      "8100102",
      "大安分行"
    ],
    [
      "8100113",
      "華山分行（客戶移轉至松江分行服務）"
    ],
    [
      "8100124",
      "太平分行"
    ],
    [
      "8100135",
      "中清分行"
    ],
    [
      "8100157",
      "三重分行"
    ],
    [
      "8100168",
      "蘆洲分行（客戶移轉至三重分行服務）"
    ],
    [
      "8100179",
      "信義分行"
    ],
    [
      "8100180",
      "中港分行"
    ],
    [
      "8100205",
      "左營分行"
    ],
    [
      "8100216",
      "汐止分行（客戶移轉至內湖分行服務）"
    ],
    [
      "8100227",
      "天母分行"
    ],
    [
      "8100250",
      "新莊分行"
    ],
    [
      "8100272",
      "中和分行（客戶移轉至新店分行服務）"
    ],
    [
      "8100283",
      "楠梓分行（客戶移轉至左營分行服務）"
    ],
    [
      "8100294",
      "民權分行"
    ],
    [
      "8100308",
      "苓雅分行"
    ],
    [
      "8100320",
      "新店分行"
    ],
    [
      "8100331",
      "前鎮分行"
    ],
    [
      "8100342",
      "東新竹分行（客戶移轉至新竹分行服務）"
    ],
    [
      "8100364",
      "南京東路分行"
    ],
    [
      "8100375",
      "莒光分行（客戶移轉至左營分行服務）"
    ],
    [
      "8100397",
      "新竹分行"
    ],
    [
      "8100401",
      "大同分行（客戶移轉至松江分行服務）"
    ],
    [
      "8100412",
      "敦南分行"
    ],
    [
      "8100423",
      "內湖分行"
    ],
    [
      "8100456",
      "松山分行"
    ],
    [
      "8100467",
      "松江分行"
    ],
    [
      "8100478",
      "松仁分行"
    ],
    [
      "8100489",
      "新站分行"
    ],
    [
      "8100490",
      "中正分行"
    ],
    [
      "8100504",
      "中興分行"
    ],
    [
      "8100559",
      "四維分行"
    ],
    [
      "8106012",
      "市府分行"
    ],
    [
      "8106023",
      "高雄分行"
    ],
    [
      "8106034",
      "台中分行"
    ],
    [
      "8106045",
      "竹北分行"
    ],
    [
      "8106056",
      "東台南分行"
    ],
    [
      "8106067",
      "大興分行"
    ],
    [
      "8106078",
      "南京松江分行"
    ],
    [
      "8106089",
      "板橋分行"
    ],
    [
      "8106090",
      "文心分行"
    ],
    [
      "8106104",
      "世貿分行"
    ],
    [
      "8106115",
      "德行分行"
    ],
    [
      "8106126",
      "建成分行"
    ],
    [
      "8106137",
      "中山分行"
    ],
    [
      "8106159",
      "永福分行"
    ],
    [
      "8106160",
      "港都分行"
    ],
    [
      "8106171",
      "臺灣大道分行"
    ],
    [
      "8106182",
      "襄陽分行"
    ],
    [
      "8106193",
      "復興分行"
    ],
    [
      "8106218",
      "基隆分行"
    ],
    [
      "8106229",
      "北桃園分行"
    ],
    [
      "8106230",
      "永和分行"
    ],
    [
      "8106241",
      "豐原分行"
    ],
    [
      "8106252",
      "大益分行"
    ],
    [
      "8106274",
      "永定分行"
    ],
    [
      "8106285",
      "光復分行"
    ],
    [
      "8106296",
      "重陽分行"
    ],
    [
      "8106300",
      "員林分行"
    ],
    [
      "8106311",
      "士林分行"
    ],
    [
      "8106333",
      "中壢分行"
    ],
    [
      "8106344",
      "安和分行"
    ],
    [
      "8106355",
      "竹城分行"
    ],
    [
      "8106366",
      "嘉義分行"
    ],
    [
      "8106377",
      "北台中分行"
    ],
    [
      "8106388",
      "北高雄分行"
    ],
    [
      "8106399",
      "思源分行"
    ],
    [
      "8106414",
      "彰化分行"
    ],
    [
      "8106436",
      "新店中正分行"
    ],
    [
      "8106469",
      "巨蛋分行"
    ],
    [
      "8106539",
      "新生分行"
    ],
    [
      "8106551",
      "羅東分行"
    ],
    [
      "8106562",
      "敦化分行"
    ],
    [
      "8106609",
      "瑞光分行"
    ],
    [
      "8106610",
      "南港分行"
    ],
    [
      "8106654",
      "斗六分行"
    ],
    [
      "8106698",
      "土城分行"
    ]
  ],
  "812": [
    [
      "8120012",
      "營業部"
    ],
    [
      "8120023",
      "敦南分行"
    ],
    [
      "8120045",
      "新生分行"
    ],
    [
      "8120056",
      "新莊分行"
    ],
    [
      "8120067",
      "桃園分行"
    ],
    [
      "8120078",
      "台中分行"
    ],
    [
      "8120089",
      "板橋分行"
    ],
    [
      "8120090",
      "高雄分行"
    ],
    [
      "8120104",
      "台南分行"
    ],
    [
      "8120115",
      "南京東路分行"
    ],
    [
      "8120126",
      "中壢分行"
    ],
    [
      "8120137",
      "信託部"
    ],
    [
      "8120159",
      "苓雅分行"
    ],
    [
      "8120160",
      "蘆洲分行"
    ],
    [
      "8120171",
      "天母分行"
    ],
    [
      "8120182",
      "大里分行"
    ],
    [
      "8120207",
      "中和分行"
    ],
    [
      "8120218",
      "嘉義分行"
    ],
    [
      "8120229",
      "豐原分行"
    ],
    [
      "8120230",
      "花蓮分行"
    ],
    [
      "8120241",
      "新竹分行"
    ],
    [
      "8120252",
      "七賢分行"
    ],
    [
      "8120263",
      "信義分行"
    ],
    [
      "8120274",
      "北台中分行"
    ],
    [
      "8120285",
      "三重分行"
    ],
    [
      "8120296",
      "永福分行"
    ],
    [
      "8120300",
      "屏東分行"
    ],
    [
      "8120311",
      "大安分行"
    ],
    [
      "8120322",
      "龍潭分行"
    ],
    [
      "8120333",
      "崇德分行"
    ],
    [
      "8120344",
      "金華分行"
    ],
    [
      "8120355",
      "後甲分行"
    ],
    [
      "8120366",
      "海佃分行"
    ],
    [
      "8120377",
      "彰化分行"
    ],
    [
      "8120388",
      "五甲分行"
    ],
    [
      "8120399",
      "鳳山分行"
    ],
    [
      "8120403",
      "古亭分行"
    ],
    [
      "8120414",
      "建橋分行"
    ],
    [
      "8120436",
      "民生分行"
    ],
    [
      "8120447",
      "太平分行"
    ],
    [
      "8120458",
      "和平分行"
    ],
    [
      "8120469",
      "北高雄分行"
    ],
    [
      "8120470",
      "南新莊分行"
    ],
    [
      "8120481",
      "內湖分行"
    ],
    [
      "8120492",
      "永和分行"
    ],
    [
      "8120517",
      "逢甲分行"
    ],
    [
      "8120528",
      "竹科分行"
    ],
    [
      "8120540",
      "南屯分行"
    ],
    [
      "8120551",
      "大直分行"
    ],
    [
      "8120562",
      "南門分行"
    ],
    [
      "8120610",
      "西門分行"
    ],
    [
      "8120621",
      "敦北分行"
    ],
    [
      "8120632",
      "忠孝分行"
    ],
    [
      "8120643",
      "復興分行"
    ],
    [
      "8120654",
      "板南分行"
    ],
    [
      "8120665",
      "民權分行"
    ],
    [
      "8120676",
      "三民分行"
    ],
    [
      "8120687",
      "建北分行"
    ],
    [
      "8120698",
      "三和分行"
    ],
    [
      "8120702",
      "北新店分行"
    ],
    [
      "8120713",
      "府城分行"
    ],
    [
      "8120724",
      "東高雄分行"
    ],
    [
      "8120735",
      "基隆路分行"
    ],
    [
      "8120746",
      "新店分行"
    ],
    [
      "8120757",
      "北桃園分行"
    ],
    [
      "8120768",
      "大墩分行"
    ],
    [
      "8120779",
      "延平分行"
    ],
    [
      "8120780",
      "南崁分行"
    ],
    [
      "8120791",
      "景平分行"
    ],
    [
      "8120805",
      "文心分行"
    ],
    [
      "8120816",
      "岡山分行"
    ],
    [
      "8120827",
      "松江分行"
    ],
    [
      "8120838",
      "大雅分行"
    ],
    [
      "8120849",
      "汐止分行"
    ],
    [
      "8120850",
      "成功分行"
    ],
    [
      "8120861",
      "石牌分行"
    ],
    [
      "8120872",
      "永康分行"
    ],
    [
      "8120883",
      "南松山分行"
    ],
    [
      "8120894",
      "淡水分行"
    ],
    [
      "8120908",
      "東基隆分行"
    ],
    [
      "8120919",
      "新板分行"
    ],
    [
      "8120920",
      "北師分行"
    ],
    [
      "8120931",
      "永華分行"
    ],
    [
      "8120942",
      "江翠分行"
    ],
    [
      "8120975",
      "松德分行"
    ],
    [
      "8120986",
      "北大分行"
    ],
    [
      "8120997",
      "南港分行"
    ],
    [
      "8121008",
      "關東橋分行"
    ],
    [
      "8121019",
      "竹北分行"
    ],
    [
      "8121020",
      "南寮分行"
    ],
    [
      "8121031",
      "八德分行"
    ],
    [
      "8121042",
      "員林分行"
    ],
    [
      "8121053",
      "市府分行"
    ],
    [
      "8121064",
      "右昌分行"
    ],
    [
      "8121075",
      "沙鹿分行"
    ],
    [
      "8121086",
      "竹南分行"
    ],
    [
      "8121097",
      "羅東分行"
    ],
    [
      "8121101",
      "東湖分行"
    ],
    [
      "8121112",
      "文山分行"
    ],
    [
      "8121123",
      "副都心分行"
    ],
    [
      "8121134",
      "景美分行"
    ],
    [
      "8121145",
      "雄科分行"
    ]
  ],
  "816": [
    [
      "8160016",
      "長安東路分行"
    ],
    [
      "8160027",
      "信義分行"
    ],
    [
      "8160038",
      "營業部"
    ],
    [
      "8160049",
      "新生分行"
    ],
    [
      "8160050",
      "桃園分行"
    ],
    [
      "8160061",
      "新莊分行"
    ],
    [
      "8160072",
      "台中分行"
    ],
    [
      "8160083",
      "高雄分行"
    ],
    [
      "8160094",
      "台南分行"
    ],
    [
      "8160108",
      "興隆分行"
    ],
    [
      "8160119",
      "延平分行"
    ],
    [
      "8160120",
      "中壢分行"
    ],
    [
      "8160131",
      "板橋分行"
    ],
    [
      "8160142",
      "豐原分行"
    ],
    [
      "8160153",
      "前金分行"
    ],
    [
      "8160164",
      "中和分行"
    ],
    [
      "8160186",
      "鳳山分行"
    ],
    [
      "8160197",
      "松江分行"
    ],
    [
      "8160201",
      "中崙分行"
    ],
    [
      "8160212",
      "嘉義分行"
    ],
    [
      "8160223",
      "三重分行"
    ],
    [
      "8160245",
      "沙鹿分行"
    ],
    [
      "8160256",
      "新竹分行"
    ],
    [
      "8160267",
      "員林分行"
    ],
    [
      "8160278",
      "建國分行"
    ],
    [
      "8160289",
      "北高雄分行"
    ],
    [
      "8160290",
      "新店分行"
    ],
    [
      "8160304",
      "和平分行"
    ],
    [
      "8160315",
      "成功分行"
    ],
    [
      "8160326",
      "通化分行"
    ],
    [
      "8160337",
      "南門分行"
    ],
    [
      "8160348",
      "汀州分行"
    ],
    [
      "8160359",
      "農安分行"
    ],
    [
      "8160360",
      "景美分行"
    ],
    [
      "8160371",
      "民權分行"
    ],
    [
      "8160382",
      "松山分行"
    ],
    [
      "8160393",
      "內湖分行"
    ],
    [
      "8160407",
      "瑞湖分行"
    ],
    [
      "8160418",
      "蘆洲分行"
    ],
    [
      "8160429",
      "永康分行"
    ],
    [
      "8160430",
      "西壢分行"
    ],
    [
      "8160441",
      "北桃園簡易型分行"
    ],
    [
      "8160452",
      "幸福分行"
    ],
    [
      "8160463",
      "天母分行"
    ],
    [
      "8160474",
      "龍潭簡易型分行"
    ],
    [
      "8160500",
      "石牌分行"
    ],
    [
      "8160511",
      "八德簡易型分行"
    ],
    [
      "8160522",
      "竹北簡易型分行"
    ],
    [
      "8160533",
      "永和分行"
    ],
    [
      "8160566",
      "大里分行"
    ]
  ],
  "822": [
    [
      "8220015",
      "敦北分行"
    ],
    [
      "8220026",
      "台中分行"
    ],
    [
      "8220037",
      "高雄分行"
    ],
    [
      "8220059",
      "台南分行"
    ],
    [
      "8220060",
      "三重分行"
    ],
    [
      "8220071",
      "城東分行"
    ],
    [
      "8220082",
      "嘉義分行"
    ],
    [
      "8220093",
      "中崙分行"
    ],
    [
      "8220107",
      "城中分行"
    ],
    [
      "8220118",
      "三民分行"
    ],
    [
      "8220129",
      "中壢分行"
    ],
    [
      "8220130",
      "雙和分行"
    ],
    [
      "8220141",
      "中山分行"
    ],
    [
      "8220152",
      "仁愛分行"
    ],
    [
      "8220163",
      "敦南分行"
    ],
    [
      "8220174",
      "板橋分行"
    ],
    [
      "8220185",
      "忠孝分行"
    ],
    [
      "8220196",
      "新興分行"
    ],
    [
      "8220200",
      "南京東路分行"
    ],
    [
      "8220222",
      "西台南分行"
    ],
    [
      "8220255",
      "松山分行"
    ],
    [
      "8220266",
      "新莊分行"
    ],
    [
      "8220277",
      "桃園分行"
    ],
    [
      "8220288",
      "中港分行"
    ],
    [
      "8220299",
      "新竹分行"
    ],
    [
      "8220303",
      "蘆洲分行"
    ],
    [
      "8220314",
      "新店分行"
    ],
    [
      "8220325",
      "員林分行"
    ],
    [
      "8220336",
      "東新竹分行"
    ],
    [
      "8220347",
      "公館分行"
    ],
    [
      "8220358",
      "永康分行"
    ],
    [
      "8220369",
      "土城分行"
    ],
    [
      "8220370",
      "頭份分行"
    ],
    [
      "8220381",
      "基隆分行"
    ],
    [
      "8220392",
      "豐原分行"
    ],
    [
      "8220406",
      "天母分行"
    ],
    [
      "8220417",
      "板新分行"
    ],
    [
      "8220428",
      "彰化分行"
    ],
    [
      "8220439",
      "東高雄分行"
    ],
    [
      "8220440",
      "中華分行"
    ],
    [
      "8220451",
      "內湖分行"
    ],
    [
      "8220462",
      "斗六分行"
    ],
    [
      "8220473",
      "文心分行"
    ],
    [
      "8220484",
      "重陽分行"
    ],
    [
      "8220495",
      "永吉分行"
    ],
    [
      "8220509",
      "高美館分行"
    ],
    [
      "8220510",
      "南崁分行"
    ],
    [
      "8220521",
      "永和分行"
    ],
    [
      "8220532",
      "太平分行"
    ],
    [
      "8220543",
      "市府分行"
    ],
    [
      "8220554",
      "六家庄分行"
    ],
    [
      "8220565",
      "右昌分行"
    ],
    [
      "8220576",
      "江翠分行"
    ],
    [
      "8220587",
      "東湖分行"
    ],
    [
      "8220598",
      "中原分行"
    ],
    [
      "8220602",
      "大安分行"
    ],
    [
      "8220613",
      "北高雄分行"
    ],
    [
      "8220624",
      "承德分行"
    ],
    [
      "8220635",
      "復興分行"
    ],
    [
      "8220646",
      "石牌分行"
    ],
    [
      "8220657",
      "城北分行"
    ],
    [
      "8220668",
      "萬華分行"
    ],
    [
      "8220679",
      "西松分行"
    ],
    [
      "8220680",
      "北投分行"
    ],
    [
      "8220691",
      "安和分行"
    ],
    [
      "8220705",
      "西湖分行"
    ],
    [
      "8220716",
      "瑞光分行"
    ],
    [
      "8220727",
      "宜蘭分行"
    ],
    [
      "8220738",
      "民生分行"
    ],
    [
      "8220749",
      "中和分行"
    ],
    [
      "8220750",
      "重新分行"
    ],
    [
      "8220761",
      "丹鳳分行"
    ],
    [
      "8220772",
      "北新店分行"
    ],
    [
      "8220783",
      "汐止分行"
    ],
    [
      "8220794",
      "金城分行"
    ],
    [
      "8220808",
      "樹林分行"
    ],
    [
      "8220819",
      "南勢角分行"
    ],
    [
      "8220820",
      "北新莊分行"
    ],
    [
      "8220853",
      "南桃園分行"
    ],
    [
      "8220864",
      "北桃園分行"
    ],
    [
      "8220875",
      "竹科分行"
    ],
    [
      "8220901",
      "營業部"
    ],
    [
      "8221012",
      "八德分行"
    ],
    [
      "8221023",
      "林口分行"
    ],
    [
      "8221034",
      "竹北分行"
    ],
    [
      "8221045",
      "南屯分行"
    ],
    [
      "8221056",
      "大里分行"
    ],
    [
      "8221067",
      "洲際分行"
    ],
    [
      "8221078",
      "南投分行"
    ],
    [
      "8221090",
      "仁德分行"
    ],
    [
      "8221104",
      "中台南分行"
    ],
    [
      "8221115",
      "東台南分行"
    ],
    [
      "8221126",
      "台東分行"
    ],
    [
      "8221137",
      "南台南分行"
    ],
    [
      "8221148",
      "新營分行"
    ],
    [
      "8221159",
      "科博館分行"
    ],
    [
      "8221160",
      "西屯分行"
    ],
    [
      "8221171",
      "民族分行"
    ],
    [
      "8221182",
      "南高雄分行"
    ],
    [
      "8221193",
      "九如分行"
    ],
    [
      "8221207",
      "屏東分行"
    ],
    [
      "8221218",
      "復北分行"
    ],
    [
      "8221229",
      "鳳山分行"
    ],
    [
      "8221230",
      "五甲分行"
    ],
    [
      "8221241",
      "延吉分行"
    ],
    [
      "8221252",
      "信義分行"
    ],
    [
      "8221263",
      "青年分行"
    ],
    [
      "8221274",
      "岡山分行"
    ],
    [
      "8221285",
      "士林分行"
    ],
    [
      "8221296",
      "東民生分行"
    ],
    [
      "8221300",
      "文山分行"
    ],
    [
      "8222101",
      "淡水分行"
    ],
    [
      "8222112",
      "民安分行"
    ],
    [
      "8222123",
      "二重埔分行"
    ],
    [
      "8222134",
      "富錦分行"
    ],
    [
      "8222145",
      "站前分行"
    ],
    [
      "8222156",
      "惠中分行"
    ],
    [
      "8222167",
      "東蘆洲分行"
    ],
    [
      "8222178",
      "木柵分行"
    ],
    [
      "8222189",
      "東花蓮分行"
    ],
    [
      "8222190",
      "寶山分行"
    ],
    [
      "8222204",
      "藝文分行"
    ],
    [
      "8222215",
      "東門分行"
    ],
    [
      "8222226",
      "新板特區分行"
    ],
    [
      "8222237",
      "三和分行"
    ],
    [
      "8222248",
      "劍潭分行"
    ],
    [
      "8222259",
      "北蘆洲分行"
    ],
    [
      "8222260",
      "寶強分行"
    ],
    [
      "8222271",
      "華山分行"
    ],
    [
      "8222282",
      "龍江分行"
    ],
    [
      "8222293",
      "成功分行"
    ],
    [
      "8223108",
      "市政分行"
    ],
    [
      "8223119",
      "大直分行"
    ],
    [
      "8223120",
      "景美分行"
    ],
    [
      "8223131",
      "內壢分行"
    ],
    [
      "8223142",
      "重慶分行"
    ],
    [
      "8223153",
      "長安分行"
    ],
    [
      "8223164",
      "羅東分行"
    ],
    [
      "8223175",
      "南中壢分行"
    ],
    [
      "8223186",
      "板和分行"
    ],
    [
      "8223197",
      "花蓮分行"
    ],
    [
      "8223201",
      "北天母分行"
    ],
    [
      "8223212",
      "民權西路分行"
    ],
    [
      "8223223",
      "佳里分行"
    ],
    [
      "8223234",
      "博愛分行"
    ],
    [
      "8223245",
      "鹽行分行"
    ],
    [
      "8223267",
      "光復分行"
    ],
    [
      "8223278",
      "埔墘分行"
    ],
    [
      "8223289",
      "黎明分行"
    ],
    [
      "8223290",
      "新富分行"
    ],
    [
      "8223603",
      "三峽分行"
    ],
    [
      "8223614",
      "東林口分行"
    ],
    [
      "8223636",
      "善化分行"
    ],
    [
      "8223647",
      "青埔分行"
    ]
  ],
  "823": [
    [
      "8231688",
      "營業部"
    ]
  ],
  "824": [
    [
      "8246880",
      "總行"
    ]
  ],
  "826": [
    [
      "8260019",
      "營業部"
    ]
  ],
  "114": [
    [
      "1140015",
      "營業部"
    ],
    [
      "1140024",
      "仁一路分社"
    ],
    [
      "1140033",
      "愛三路分社"
    ],
    [
      "1140042",
      "忠二路分社"
    ],
    [
      "1140051",
      "安一路分社"
    ],
    [
      "1140060",
      "信二路分社"
    ],
    [
      "1140079",
      "中華路分社"
    ],
    [
      "1140088",
      "八斗子分社"
    ],
    [
      "1140097",
      "南興路分社"
    ],
    [
      "1140103",
      "大武崙分社"
    ],
    [
      "1140112",
      "碇內分社"
    ],
    [
      "1140121",
      "仁二路分社"
    ],
    [
      "1140130",
      "百福分社"
    ],
    [
      "1140149",
      "松山分社"
    ],
    [
      "1140158",
      "永春分社"
    ]
  ],
  "115": [
    [
      "1150014",
      "營業部"
    ],
    [
      "1150023",
      "廟口分社"
    ],
    [
      "1150032",
      "中正區分社"
    ],
    [
      "1150041",
      "新店分社（元大證券收付處）"
    ],
    [
      "1150050",
      "七堵分社"
    ],
    [
      "1150069",
      "安樂分社"
    ],
    [
      "1150078",
      "信義分社"
    ],
    [
      "1150087",
      "港東分社"
    ],
    [
      "1150096",
      "暖暖分社"
    ],
    [
      "1150102",
      "安和分社"
    ],
    [
      "1150111",
      "臺北分社"
    ],
    [
      "1150120",
      "百福分社"
    ],
    [
      "1150139",
      "基金分社"
    ],
    [
      "1150148",
      "新豐分社"
    ],
    [
      "1150157",
      "復興分社"
    ]
  ],
  "119": [
    [
      "1190010",
      "營業部"
    ],
    [
      "1190029",
      "三重分社"
    ],
    [
      "1190038",
      "三芝分社"
    ],
    [
      "1190047",
      "八里分社"
    ],
    [
      "1190056",
      "石門分社"
    ],
    [
      "1190065",
      "竹圍分社"
    ],
    [
      "1190074",
      "水碓分社"
    ],
    [
      "1190083",
      "英專分社"
    ],
    [
      "1190092",
      "新市分社"
    ],
    [
      "1190108",
      "龍形分社"
    ],
    [
      "1190117",
      "金山分社"
    ],
    [
      "1190126",
      "萬里分社"
    ],
    [
      "1190135",
      "板橋分社"
    ],
    [
      "1190153",
      "林口分社"
    ],
    [
      "1190162",
      "中和分社"
    ],
    [
      "1190180",
      "北投分社"
    ],
    [
      "1190199",
      "新莊分社"
    ]
  ],
  "130": [
    [
      "1300013",
      "營業部"
    ],
    [
      "1300022",
      "城中分社"
    ],
    [
      "1300031",
      "武昌分社"
    ],
    [
      "1300040",
      "新社分社"
    ],
    [
      "1300059",
      "竹北分社"
    ],
    [
      "1300068",
      "三民分社"
    ],
    [
      "1300077",
      "香山分社"
    ],
    [
      "1300086",
      "東南分社"
    ],
    [
      "1300095",
      "光復分社"
    ],
    [
      "1300101",
      "南寮分社"
    ],
    [
      "1300110",
      "南香山分社"
    ],
    [
      "1300129",
      "武陵分社"
    ],
    [
      "1300138",
      "延平分社"
    ],
    [
      "1300147",
      "建功分社"
    ],
    [
      "1300156",
      "芎林分社"
    ],
    [
      "1300165",
      "寶山分社"
    ],
    [
      "1300174",
      "平鎮分社"
    ],
    [
      "1300183",
      "楊梅分社"
    ],
    [
      "1300192",
      "八德分社"
    ],
    [
      "1300208",
      "中壢分社"
    ]
  ],
  "132": [
    [
      "1320011",
      "市中分社"
    ],
    [
      "1320020",
      "民生分社"
    ],
    [
      "1320039",
      "營業部"
    ],
    [
      "1320048",
      "中正分社"
    ],
    [
      "1320057",
      "東南分社"
    ],
    [
      "1320066",
      "西門分社"
    ],
    [
      "1320075",
      "東光分社"
    ],
    [
      "1320084",
      "香山分社"
    ],
    [
      "1320093",
      "竹南分社"
    ],
    [
      "1320109",
      "延平分社"
    ],
    [
      "1320118",
      "光華分社"
    ],
    [
      "1320127",
      "新豐分社"
    ],
    [
      "1320136",
      "竹北分社"
    ],
    [
      "1320145",
      "六家簡易型分社"
    ],
    [
      "1320154",
      "頭份分社"
    ]
  ],
  "146": [
    [
      "1460014",
      "營業部"
    ],
    [
      "1460023",
      "文昌分社"
    ],
    [
      "1460032",
      "南屯分社"
    ],
    [
      "1460041",
      "五權分社"
    ],
    [
      "1460050",
      "東南分社"
    ],
    [
      "1460069",
      "大智分社"
    ],
    [
      "1460078",
      "港路分社"
    ],
    [
      "1460087",
      "精進分社"
    ],
    [
      "1460096",
      "中興分社"
    ],
    [
      "1460102",
      "水湳分社"
    ],
    [
      "1460111",
      "中和分社"
    ],
    [
      "1460120",
      "松竹分社"
    ],
    [
      "1460139",
      "向上分社"
    ],
    [
      "1460148",
      "大雅分社"
    ],
    [
      "1460157",
      "西屯分社"
    ],
    [
      "1460166",
      "太平分社"
    ],
    [
      "1460175",
      "大里分社"
    ],
    [
      "1460184",
      "潭子分社"
    ],
    [
      "1460193",
      "文山分社"
    ],
    [
      "1460209",
      "軍功分社"
    ],
    [
      "1460218",
      "高工分社"
    ],
    [
      "1460227",
      "敦化分社"
    ],
    [
      "1460236",
      "富貴分社"
    ]
  ],
  "162": [
    [
      "1620012",
      "車路口分社"
    ],
    [
      "1620021",
      "營業部"
    ],
    [
      "1620030",
      "觀音亭口分社"
    ],
    [
      "1620049",
      "華陽分社"
    ],
    [
      "1620058",
      "和美分社"
    ],
    [
      "1620067",
      "花壇分社"
    ],
    [
      "1620076",
      "曉陽分社"
    ],
    [
      "1620085",
      "伸港分社"
    ],
    [
      "1620094",
      "秀水分社"
    ],
    [
      "1620100",
      "福興分社"
    ],
    [
      "1620119",
      "永靖分社"
    ],
    [
      "1620128",
      "埔心分社"
    ],
    [
      "1620137",
      "員林分社"
    ],
    [
      "1620146",
      "東興分社"
    ]
  ],
  "204": [
    [
      "2040011",
      "營業部"
    ],
    [
      "2040020",
      "八德分社"
    ],
    [
      "2040039",
      "苓雅分社"
    ],
    [
      "2040048",
      "新興分社"
    ],
    [
      "2040057",
      "三民分社"
    ],
    [
      "2040066",
      "鼓山分社"
    ],
    [
      "2040075",
      "臨海分社"
    ],
    [
      "2040084",
      "前鎮分社"
    ],
    [
      "2040093",
      "前金分社"
    ],
    [
      "2040109",
      "左營分社"
    ],
    [
      "2040118",
      "青年分社"
    ],
    [
      "2040127",
      "楠梓分社"
    ],
    [
      "2040136",
      "三多分社"
    ],
    [
      "2040145",
      "灣子分社"
    ],
    [
      "2040154",
      "天祥分社"
    ],
    [
      "2040163",
      "陽明分社"
    ],
    [
      "2040172",
      "武廟分社"
    ],
    [
      "2040181",
      "瑞祥分社"
    ],
    [
      "2040190",
      "右昌分社"
    ],
    [
      "2040206",
      "小港分社"
    ],
    [
      "2040215",
      "文川分社"
    ],
    [
      "2040224",
      "鳳山分社"
    ]
  ],
  "215": [
    [
      "2150017",
      "復興分社（宏遠證券，富邦證東花蓮收付處）"
    ],
    [
      "2150026",
      "自由分社"
    ],
    [
      "2150035",
      "中華分社"
    ],
    [
      "2150044",
      "總社〈營業部〉"
    ],
    [
      "2150053",
      "美崙分社"
    ],
    [
      "2150062",
      "信義簡易型分社"
    ],
    [
      "2150071",
      "自強分社"
    ],
    [
      "2150080",
      "國光簡易型分社"
    ],
    [
      "2150099",
      "鳳山分社"
    ],
    [
      "2150105",
      "建國簡易型分社"
    ],
    [
      "2150114",
      "永康分社"
    ],
    [
      "2150123",
      "慶豐簡易型分社"
    ],
    [
      "2150132",
      "台東分社"
    ],
    [
      "2150141",
      "仁武分社"
    ],
    [
      "2150150",
      "橋頭分社"
    ]
  ],
  "216": [
    [
      "2160016",
      "營業部"
    ],
    [
      "2160025",
      "中山分社"
    ],
    [
      "2160034",
      "主里分社"
    ],
    [
      "2160043",
      "美崙分社"
    ],
    [
      "2160052",
      "中正分社"
    ],
    [
      "2160061",
      "富國分社"
    ],
    [
      "2160070",
      "田蒲分社"
    ],
    [
      "2160089",
      "建國分社"
    ],
    [
      "2160098",
      "壽豐分社"
    ],
    [
      "2160104",
      "玉里分社"
    ],
    [
      "2160122",
      "台東分社"
    ],
    [
      "2160131",
      "大里分社"
    ],
    [
      "2160140",
      "太平分社"
    ],
    [
      "2160159",
      "大雅分社"
    ],
    [
      "2160168",
      "烏日分社"
    ],
    [
      "2160177",
      "公益分社"
    ],
    [
      "2160186",
      "西屯分社"
    ],
    [
      "2160195",
      "羅東分社"
    ],
    [
      "2160201",
      "左營分社"
    ]
  ],
  "104": [
    [
      "1040018",
      "營業部"
    ],
    [
      "1040027",
      "吉林分社"
    ],
    [
      "1040036",
      "大同分社"
    ],
    [
      "1040045",
      "中山分社"
    ],
    [
      "1040054",
      "松山分社"
    ],
    [
      "1040063",
      "大安分社"
    ],
    [
      "1040072",
      "石牌分社"
    ],
    [
      "1040081",
      "南港分社"
    ],
    [
      "1040090",
      "文山分社"
    ],
    [
      "1040106",
      "中正分社"
    ],
    [
      "1040115",
      "北投分社"
    ],
    [
      "1040124",
      "內湖分社"
    ],
    [
      "1040133",
      "天母分社"
    ]
  ],
  "120": [
    [
      "1200016",
      "營業部"
    ],
    [
      "1200025",
      "水碓分社"
    ],
    [
      "1200034",
      "竹圍分社"
    ],
    [
      "1200043",
      "英專分社"
    ],
    [
      "1200052",
      "義山分社"
    ],
    [
      "1200061",
      "三芝分社"
    ],
    [
      "1200070",
      "八里分社"
    ],
    [
      "1200089",
      "成州分社"
    ],
    [
      "1200098",
      "五股分社"
    ],
    [
      "1200104",
      "萬金分社"
    ],
    [
      "1200113",
      "新莊分社"
    ],
    [
      "1200122",
      "泰山分社"
    ],
    [
      "1200131",
      "林口分社"
    ],
    [
      "1200140",
      "板橋分社"
    ],
    [
      "1200159",
      "蘆洲分社"
    ],
    [
      "1200168",
      "三重分社"
    ]
  ],
  "124": [
    [
      "1240012",
      "營業部"
    ],
    [
      "1240021",
      "復興分社"
    ],
    [
      "1240030",
      "東門分社"
    ],
    [
      "1240058",
      "頭城分社"
    ],
    [
      "1240067",
      "礁溪分社"
    ],
    [
      "1240076",
      "冬山分社"
    ],
    [
      "1240085",
      "三星分社"
    ],
    [
      "1240094",
      "壯圍分社"
    ],
    [
      "1240100",
      "羅東分社"
    ],
    [
      "1240119",
      "蘇澳分社"
    ]
  ],
  "127": [
    [
      "1270019",
      "營業部"
    ],
    [
      "1270028",
      "大林分社"
    ],
    [
      "1270037",
      "永興分社"
    ],
    [
      "1270046",
      "南華分社"
    ],
    [
      "1270055",
      "介壽分社"
    ],
    [
      "1270064",
      "中山分社"
    ],
    [
      "1270073",
      "永安分社"
    ],
    [
      "1270082",
      "會稽分社"
    ],
    [
      "1270091",
      "莊敬分社"
    ],
    [
      "1270107",
      "大湳分社"
    ],
    [
      "1270116",
      "南崁分社"
    ]
  ],
  "158": [
    [
      "1580019",
      "營業部"
    ],
    [
      "1580028",
      "中華分社"
    ],
    [
      "1580037",
      "曉陽分社"
    ],
    [
      "1580046",
      "彰美分社"
    ],
    [
      "1580055",
      "花壇分社"
    ],
    [
      "1580064",
      "大竹分社"
    ],
    [
      "1580073",
      "和美分社"
    ],
    [
      "1580082",
      "中正分社"
    ],
    [
      "1580091",
      "員林分社"
    ]
  ],
  "161": [
    [
      "1610013",
      "營業部"
    ],
    [
      "1610022",
      "華山分社"
    ],
    [
      "1610031",
      "彰南路分社"
    ],
    [
      "1610040",
      "東芳分社"
    ],
    [
      "1610059",
      "旭光分社"
    ],
    [
      "1610068",
      "大里分社"
    ],
    [
      "1610077",
      "埔心分社"
    ],
    [
      "1610086",
      "田中分社"
    ],
    [
      "1610095",
      "芬園分社"
    ],
    [
      "1610101",
      "埤頭分社"
    ]
  ],
  "163": [
    [
      "1630011",
      "營業部"
    ],
    [
      "1630020",
      "華山分社"
    ],
    [
      "1630039",
      "三民分社"
    ],
    [
      "1630048",
      "中華分社"
    ],
    [
      "1630057",
      "大竹分社"
    ],
    [
      "1630066",
      "和美分社"
    ],
    [
      "1630075",
      "大埔分社"
    ],
    [
      "1630084",
      "埔鹽分社"
    ],
    [
      "1630093",
      "溪湖分社"
    ],
    [
      "1630109",
      "伸港分社"
    ]
  ],
  "165": [
    [
      "1650019",
      "營業部"
    ],
    [
      "1650028",
      "彰鹿分社"
    ],
    [
      "1650037",
      "頂番分社"
    ],
    [
      "1650046",
      "埔鹽分社"
    ],
    [
      "1650055",
      "彰濱分社"
    ],
    [
      "1650064",
      "管嶼分社"
    ],
    [
      "1650073",
      "王功分社"
    ],
    [
      "1650082",
      "草港分社"
    ],
    [
      "1650091",
      "溪湖分社"
    ],
    [
      "1650107",
      "員林分社"
    ],
    [
      "1650116",
      "中正分社"
    ]
  ],
  "178": [
    [
      "1780013",
      "營業部"
    ],
    [
      "1780022",
      "中埔分社"
    ],
    [
      "1780031",
      "新榮分社"
    ],
    [
      "1780040",
      "北興分社"
    ],
    [
      "1780059",
      "忠孝分社"
    ],
    [
      "1780068",
      "興嘉分社"
    ],
    [
      "1780077",
      "新南分社"
    ],
    [
      "1780086",
      "新興分社"
    ],
    [
      "1780095",
      "美源分社"
    ],
    [
      "1780101",
      "新生分社"
    ],
    [
      "1780110",
      "民生分社"
    ]
  ],
  "188": [
    [
      "1880010",
      "營業部"
    ],
    [
      "1880029",
      "東門分社"
    ],
    [
      "1880038",
      "西門分社"
    ],
    [
      "1880047",
      "安平分社"
    ],
    [
      "1880056",
      "成功分社"
    ],
    [
      "1880065",
      "大同分社"
    ],
    [
      "1880074",
      "文賢分社"
    ],
    [
      "1880083",
      "金華分社"
    ],
    [
      "1880092",
      "小東分社"
    ],
    [
      "1880108",
      "開元分社"
    ],
    [
      "1880117",
      "中華分社"
    ],
    [
      "1880126",
      "大灣分社"
    ],
    [
      "1880135",
      "安中分社"
    ]
  ],
  "222": [
    [
      "2220017",
      "營業部"
    ],
    [
      "2220026",
      "民權分社"
    ],
    [
      "2220035",
      "光復分社"
    ],
    [
      "2220044",
      "澎南分社"
    ],
    [
      "2220053",
      "赤崁分社"
    ],
    [
      "2220062",
      "西嶼分社"
    ],
    [
      "2220080",
      "湖西分社"
    ],
    [
      "2220099",
      "港都分社"
    ],
    [
      "2220105",
      "朝陽分社"
    ]
  ],
  "223": [
    [
      "2230016",
      "營業部"
    ],
    [
      "2230025",
      "民生分社"
    ],
    [
      "2230034",
      "陽明分社"
    ],
    [
      "2230043",
      "澎南分社"
    ],
    [
      "2230052",
      "白沙分社"
    ],
    [
      "2230061",
      "西嶼分社"
    ],
    [
      "2230070",
      "湖西分社"
    ],
    [
      "2230089",
      "漁港分社"
    ],
    [
      "2230098",
      "中興分社"
    ]
  ],
  "224": [
    [
      "2240015",
      "營業部"
    ],
    [
      "2240024",
      "金沙分社"
    ],
    [
      "2240033",
      "金湖分社"
    ],
    [
      "2240042",
      "烈嶼分社"
    ]
  ],
  "501": [
    [
      "5010017",
      "宜蘭縣蘇澳區漁會"
    ],
    [
      "5010028",
      "新馬分部"
    ]
  ],
  "502": [
    [
      "5020018",
      "宜蘭縣頭城區漁會"
    ],
    [
      "5020029",
      "大溪分部"
    ],
    [
      "5020030",
      "壯圍分部"
    ]
  ],
  "506": [
    [
      "5060012",
      "桃園區漁會"
    ]
  ],
  "507": [
    [
      "5070013",
      "新竹區漁會"
    ]
  ],
  "508": [
    [
      "5080014",
      "通苑區漁會"
    ],
    [
      "5080025",
      "苑裡分部"
    ]
  ],
  "510": [
    [
      "5100019",
      "南龍區漁會"
    ],
    [
      "5100020",
      "竹南分部"
    ]
  ],
  "511": [
    [
      "5110010",
      "彰化區漁會"
    ],
    [
      "5110021",
      "大城分部"
    ],
    [
      "5110032",
      "王功分部"
    ],
    [
      "5110043",
      "芳苑分部"
    ],
    [
      "5110054",
      "草港分部"
    ],
    [
      "5110065",
      "福興分部"
    ],
    [
      "5110076",
      "伸港分部"
    ],
    [
      "5110087",
      "埔心分部"
    ]
  ],
  "513": [
    [
      "5130012",
      "新北市瑞芳區漁會"
    ],
    [
      "5130023",
      "深澳分部"
    ]
  ],
  "514": [
    [
      "5140013",
      "新北市萬里區漁會"
    ]
  ],
  "516": [
    [
      "5160015",
      "基隆區漁會"
    ]
  ],
  "512": [
    [
      "5120011",
      "雲林區漁會"
    ],
    [
      "5120022",
      "台西分部"
    ],
    [
      "5120033",
      "口湖分部"
    ],
    [
      "5120044",
      "麥寮分部"
    ],
    [
      "5120055",
      "三條崙分部"
    ]
  ],
  "515": [
    [
      "5150014",
      "嘉義區漁會"
    ],
    [
      "5150025",
      "新塭分部"
    ],
    [
      "5150036",
      "義竹分部"
    ],
    [
      "5150047",
      "過溝分部"
    ],
    [
      "5150058",
      "東石分部"
    ],
    [
      "5150069",
      "過路分部"
    ],
    [
      "5150070",
      "副瀨分部"
    ],
    [
      "5150081",
      "景山分部"
    ]
  ],
  "517": [
    [
      "5170016",
      "南市區漁會"
    ],
    [
      "5170027",
      "四草分部"
    ],
    [
      "5170038",
      "安南分部"
    ]
  ],
  "518": [
    [
      "5180017",
      "南縣區漁會"
    ],
    [
      "5180028",
      "七股分部"
    ],
    [
      "5180039",
      "北門分部"
    ],
    [
      "5180040",
      "將軍港分部"
    ],
    [
      "5180051",
      "青山港分部"
    ],
    [
      "5180073",
      "永吉分部"
    ]
  ],
  "520": [
    [
      "5200012",
      "高雄區漁會信用部"
    ],
    [
      "5200034",
      "旗津分部"
    ],
    [
      "5200056",
      "援中港分部"
    ],
    [
      "5200023",
      "小港區漁會信用部"
    ]
  ],
  "521": [
    [
      "5210024",
      "興達港區漁會"
    ],
    [
      "5210035",
      "下茄萣分部"
    ],
    [
      "5210068",
      "林園區漁會"
    ],
    [
      "5210079",
      "彌陀區漁會"
    ],
    [
      "5210105",
      "舊港分部"
    ],
    [
      "5210149",
      "南寮分部"
    ],
    [
      "5210091",
      "永安區漁會"
    ],
    [
      "5210116",
      "梓官區漁會"
    ],
    [
      "5210127",
      "北梓官分部"
    ]
  ],
  "523": [
    [
      "5230015",
      "琉球區漁會"
    ],
    [
      "5230037",
      "東港區漁會"
    ],
    [
      "5230118",
      "光復分部"
    ],
    [
      "5230129",
      "新園分部"
    ],
    [
      "5230048",
      "林邊區漁會"
    ],
    [
      "5230059",
      "塭豐分部"
    ],
    [
      "5230082",
      "崎峰分部"
    ],
    [
      "5230093",
      "水利分部"
    ],
    [
      "5230130",
      "枋寮區漁會"
    ]
  ],
  "524": [
    [
      "5240016",
      "新港區漁會"
    ]
  ],
  "525": [
    [
      "5250017",
      "澎湖區漁會"
    ],
    [
      "5250028",
      "西嶼分部"
    ],
    [
      "5250039",
      "白沙分部"
    ]
  ],
  "526": [
    [
      "5260018",
      "金門區漁會"
    ]
  ],
  "519": [
    [
      "5190018",
      "新化區農會"
    ],
    [
      "5190029",
      "那拔林分部"
    ],
    [
      "5190030",
      "中山分部"
    ]
  ],
  "538": [
    [
      "5380013",
      "宜蘭市農會"
    ],
    [
      "5380024",
      "神農分部"
    ],
    [
      "5380035",
      "新店分部"
    ],
    [
      "5380057",
      "南門分部"
    ],
    [
      "5380068",
      "延平分部"
    ]
  ],
  "541": [
    [
      "5410019",
      "白河區農會"
    ],
    [
      "5410020",
      "市場分部"
    ],
    [
      "5410031",
      "玉豐分部"
    ],
    [
      "5410042",
      "關嶺分部"
    ],
    [
      "5410053",
      "竹門分部"
    ]
  ],
  "542": [
    [
      "5420010",
      "麻豆區農會"
    ],
    [
      "5420021",
      "新生分部"
    ],
    [
      "5420032",
      "復光分部"
    ],
    [
      "5420043",
      "安業分部"
    ]
  ],
  "547": [
    [
      "5470015",
      "後壁區農會"
    ],
    [
      "5470026",
      "菁寮分部"
    ],
    [
      "5470037",
      "安溪分部"
    ],
    [
      "5470048",
      "新東分部"
    ],
    [
      "5470059",
      "上茄苳分部"
    ],
    [
      "5470060",
      "竹新分部"
    ]
  ],
  "549": [
    [
      "5490017",
      "下營區農會"
    ],
    [
      "5490028",
      "中營分部"
    ],
    [
      "5490039",
      "中興分部"
    ],
    [
      "5490040",
      "甲中分部"
    ]
  ],
  "551": [
    [
      "5510012",
      "官田區農會"
    ],
    [
      "5510023",
      "官田辦事處"
    ],
    [
      "5510034",
      "渡頭辦事處"
    ],
    [
      "5510045",
      "西庄辦事處"
    ],
    [
      "5510056",
      "湖山辦事處"
    ],
    [
      "5510067",
      "二鎮辦事處"
    ]
  ],
  "552": [
    [
      "5520013",
      "大內區農會"
    ],
    [
      "5520024",
      "頭社分部"
    ],
    [
      "5520035",
      "環湖分部"
    ],
    [
      "5520046",
      "二溪辦事處"
    ]
  ],
  "556": [
    [
      "5560017",
      "學甲區農會"
    ],
    [
      "5560028",
      "中洲分部"
    ],
    [
      "5560039",
      "宅港分部"
    ],
    [
      "5560040",
      "頂洲分部"
    ],
    [
      "5560051",
      "大灣分部"
    ],
    [
      "5560062",
      "草圣分部"
    ]
  ],
  "557": [
    [
      "5570018",
      "新市區農會"
    ],
    [
      "5570029",
      "大社分部"
    ]
  ],
  "558": [
    [
      "5580019",
      "安定區農會"
    ],
    [
      "5580020",
      "港口分部"
    ],
    [
      "5580031",
      "蘇厝分部"
    ],
    [
      "5580042",
      "海寮分部"
    ],
    [
      "5580053",
      "中沙分部"
    ]
  ],
  "559": [
    [
      "5590010",
      "山上區農會"
    ]
  ],
  "561": [
    [
      "5610015",
      "左鎮區農會"
    ]
  ],
  "562": [
    [
      "5620016",
      "仁德區農會"
    ],
    [
      "5620027",
      "保安分部"
    ],
    [
      "5620038",
      "二行分部"
    ],
    [
      "5620049",
      "太子分部"
    ],
    [
      "5620050",
      "中洲分部"
    ],
    [
      "5620061",
      "後壁分部"
    ]
  ],
  "564": [
    [
      "5640018",
      "關廟區農會"
    ],
    [
      "5640029",
      "龜洞分部"
    ],
    [
      "5640030",
      "埤頭分部"
    ]
  ],
  "565": [
    [
      "5650019",
      "龍崎區農會"
    ],
    [
      "5650020",
      "龍船分部"
    ]
  ],
  "567": [
    [
      "5670011",
      "南化區農會"
    ]
  ],
  "568": [
    [
      "5680012",
      "七股區農會"
    ]
  ],
  "570": [
    [
      "5700017",
      "南投市農會"
    ],
    [
      "5700028",
      "內興分部"
    ],
    [
      "5700039",
      "永豐分部"
    ],
    [
      "5700040",
      "福山分部"
    ],
    [
      "5700051",
      "營南分部"
    ],
    [
      "5700062",
      "營北分部"
    ],
    [
      "5700084",
      "鳳山分部"
    ]
  ],
  "573": [
    [
      "5730010",
      "埔里鎮農會"
    ],
    [
      "5730021",
      "愛蘭分部"
    ],
    [
      "5730032",
      "合成分部"
    ],
    [
      "5730043",
      "東興分部"
    ]
  ],
  "574": [
    [
      "5740011",
      "竹山鎮農會"
    ],
    [
      "5740022",
      "社寮分部"
    ],
    [
      "5740033",
      "瑞竹分部"
    ],
    [
      "5740044",
      "延平分部"
    ],
    [
      "5740055",
      "中央分部"
    ]
  ],
  "575": [
    [
      "5750012",
      "中寮鄉農會"
    ],
    [
      "5750023",
      "爽文分部"
    ],
    [
      "5750034",
      "義和分部"
    ],
    [
      "5750045",
      "內城分部"
    ]
  ],
  "577": [
    [
      "5770014",
      "魚池鄉農會"
    ],
    [
      "5770025",
      "頭社分部"
    ],
    [
      "5770036",
      "日月潭分部"
    ],
    [
      "5770047",
      "東光分部"
    ],
    [
      "5770058",
      "共和分部"
    ],
    [
      "5770069",
      "五城分部"
    ]
  ],
  "578": [
    [
      "5780015",
      "水里鄉農會"
    ],
    [
      "5780026",
      "玉峰分部"
    ],
    [
      "5780037",
      "民和分部"
    ],
    [
      "5780048",
      "上安分部"
    ]
  ],
  "579": [
    [
      "5790016",
      "國姓鄉農會"
    ],
    [
      "5790038",
      "長流分部"
    ],
    [
      "5790049",
      "北山分部"
    ],
    [
      "5790050",
      "福龜分部"
    ],
    [
      "5790072",
      "北港分部"
    ]
  ],
  "580": [
    [
      "5800010",
      "鹿谷鄉農會"
    ],
    [
      "5800021",
      "廣興分部"
    ],
    [
      "5800032",
      "竹林分部"
    ],
    [
      "5800043",
      "永隆分部"
    ],
    [
      "5800054",
      "初鄉分部"
    ],
    [
      "5800065",
      "坪頂分部"
    ],
    [
      "5800076",
      "瑞田分部"
    ],
    [
      "5800087",
      "鳳凰分部"
    ]
  ],
  "581": [
    [
      "5810011",
      "信義鄉農會"
    ],
    [
      "5810022",
      "地利分部"
    ],
    [
      "5810033",
      "和社分部"
    ]
  ],
  "582": [
    [
      "5820012",
      "仁愛鄉農會"
    ]
  ],
  "583": [
    [
      "5830013",
      "東山區農會"
    ],
    [
      "5830024",
      "東原分部"
    ],
    [
      "5830035",
      "青山分部"
    ],
    [
      "5830046",
      "聖賢分部"
    ],
    [
      "5830057",
      "南溪分部"
    ]
  ],
  "585": [
    [
      "5850015",
      "頭城鎮農會"
    ],
    [
      "5850026",
      "金面分部"
    ],
    [
      "5850037",
      "大溪分部"
    ]
  ],
  "586": [
    [
      "5860016",
      "羅東鎮農會"
    ],
    [
      "5860027",
      "中正路分部"
    ],
    [
      "5860049",
      "民權分部"
    ],
    [
      "5860050",
      "南門分部"
    ],
    [
      "5860061",
      "北門分部"
    ],
    [
      "5860119",
      "東門分部"
    ]
  ],
  "587": [
    [
      "5870017",
      "礁溪鄉農會"
    ],
    [
      "5870028",
      "四結分部"
    ],
    [
      "5870039",
      "龍潭分部"
    ],
    [
      "5870040",
      "德陽分部"
    ]
  ],
  "588": [
    [
      "5880018",
      "壯圍鄉農會"
    ],
    [
      "5880029",
      "古亭分部"
    ],
    [
      "5880030",
      "美城分部"
    ]
  ],
  "589": [
    [
      "5890019",
      "員山鄉農會"
    ],
    [
      "5890020",
      "同樂分部"
    ],
    [
      "5890031",
      "深溝分部"
    ],
    [
      "5890042",
      "大湖分部"
    ]
  ],
  "596": [
    [
      "5960019",
      "五結鄉農會"
    ],
    [
      "5960020",
      "二結分部"
    ],
    [
      "5960031",
      "利澤分部"
    ],
    [
      "5960042",
      "四結分部"
    ]
  ],
  "598": [
    [
      "5980011",
      "蘇澳地區農會"
    ],
    [
      "5980022",
      "南方澳分部"
    ],
    [
      "5980033",
      "新馬分部"
    ],
    [
      "5980044",
      "新城分部"
    ],
    [
      "5980055",
      "南澳分部"
    ],
    [
      "5980066",
      "龍德分部"
    ]
  ],
  "599": [
    [
      "5990012",
      "三星地區農會"
    ],
    [
      "5990023",
      "大洲分部"
    ],
    [
      "5990034",
      "大隱分部"
    ],
    [
      "5990045",
      "福山分部"
    ],
    [
      "5990056",
      "大同分部"
    ]
  ],
  "602": [
    [
      "6020015",
      "中華民國農會中壢辦事處信用部"
    ],
    [
      "6020026",
      "大崙分部"
    ],
    [
      "6020037",
      "內壢分部"
    ]
  ],
  "605": [
    [
      "6050018",
      "高雄市高雄地區農會"
    ],
    [
      "6050029",
      "三民分部"
    ],
    [
      "6050030",
      "鼓山分部"
    ],
    [
      "6050041",
      "新興分部"
    ],
    [
      "6050052",
      "鼎力分部"
    ],
    [
      "6050063",
      "苓雅分部"
    ],
    [
      "6050074",
      "前鎮分部"
    ],
    [
      "6050085",
      "楠梓分部"
    ],
    [
      "6050096",
      "右昌分部"
    ],
    [
      "6050100",
      "後勁分部"
    ],
    [
      "6050111",
      "左營分部"
    ],
    [
      "6050122",
      "營北分部"
    ],
    [
      "6050133",
      "新庄分部"
    ]
  ],
  "615": [
    [
      "6150011",
      "基隆市農會"
    ],
    [
      "6150022",
      "安樂分部"
    ],
    [
      "6150033",
      "百福分部"
    ],
    [
      "6150044",
      "愛六路分部"
    ]
  ],
  "625": [
    [
      "6250014",
      "臺中地區農會信用部"
    ],
    [
      "6250025",
      "西屯分部"
    ],
    [
      "6250036",
      "北屯分部"
    ],
    [
      "6250047",
      "南屯分部"
    ],
    [
      "6250058",
      "四民分部"
    ],
    [
      "6250069",
      "西區分部"
    ],
    [
      "6250070",
      "東區分部"
    ],
    [
      "6250092",
      "南區分部"
    ],
    [
      "6250117",
      "北區分部"
    ],
    [
      "6250139",
      "軍功分部"
    ],
    [
      "6250140",
      "大坑分部"
    ]
  ],
  "628": [
    [
      "6280017",
      "鹿港鎮農會"
    ],
    [
      "6280028",
      "頂番分部"
    ],
    [
      "6280039",
      "草港分部"
    ],
    [
      "6280040",
      "東崎分部"
    ],
    [
      "6280051",
      "海埔分部"
    ]
  ],
  "629": [
    [
      "6290018",
      "和美鎮農會"
    ],
    [
      "6290029",
      "塗厝分部"
    ],
    [
      "6290030",
      "新庄分部"
    ],
    [
      "6290041",
      "鎮平分部"
    ]
  ],
  "631": [
    [
      "6310013",
      "溪湖鎮農會"
    ]
  ],
  "632": [
    [
      "6320014",
      "田中鎮農會"
    ]
  ],
  "633": [
    [
      "6330015",
      "北斗鎮農會"
    ]
  ],
  "635": [
    [
      "6350017",
      "線西鄉農會"
    ]
  ],
  "636": [
    [
      "6360018",
      "伸港鄉農會"
    ]
  ],
  "638": [
    [
      "6380010",
      "花壇鄉農會"
    ],
    [
      "6380021",
      "白沙分部"
    ],
    [
      "6380032",
      "灣雅分部"
    ],
    [
      "6380043",
      "口庄分部"
    ],
    [
      "6380054",
      "長沙分部"
    ]
  ],
  "639": [
    [
      "6390011",
      "大村鄉農會"
    ],
    [
      "6390022",
      "大村分部"
    ],
    [
      "6390033",
      "美港分部"
    ],
    [
      "6390044",
      "大西分部"
    ],
    [
      "6390055",
      "村東分部"
    ]
  ],
  "642": [
    [
      "6420017",
      "社頭鄉農會"
    ],
    [
      "6420028",
      "湳雅分部"
    ],
    [
      "6420039",
      "橋頭分部"
    ],
    [
      "6420040",
      "清水分部"
    ]
  ],
  "643": [
    [
      "6430018",
      "二水鄉農會"
    ]
  ],
  "646": [
    [
      "6460011",
      "大城鄉農會"
    ],
    [
      "6460022",
      "西港分部"
    ]
  ],
  "647": [
    [
      "6470012",
      "溪州鄉農會"
    ],
    [
      "6470023",
      "西畔分部"
    ],
    [
      "6470034",
      "大庄分部"
    ]
  ],
  "649": [
    [
      "6490014",
      "埔鹽鄉農會"
    ],
    [
      "6490025",
      "新水分部"
    ]
  ],
  "650": [
    [
      "6500018",
      "福興鄉農會"
    ],
    [
      "6500029",
      "管嶼分部"
    ],
    [
      "6500030",
      "外中分部"
    ]
  ],
  "651": [
    [
      "6510019",
      "彰化市農會"
    ]
  ],
  "683": [
    [
      "6830010",
      "北港鎮農會"
    ],
    [
      "6830021",
      "好收分部"
    ]
  ],
  "685": [
    [
      "6850012",
      "土庫鎮農會"
    ],
    [
      "6850023",
      "馬光分部"
    ],
    [
      "6850034",
      "新庄分部"
    ],
    [
      "6850045",
      "忠正分部"
    ],
    [
      "6850056",
      "後埔分部"
    ]
  ],
  "693": [
    [
      "6930013",
      "東勢鄉農會"
    ],
    [
      "6930024",
      "新坤分部"
    ]
  ],
  "696": [
    [
      "6960016",
      "水林鄉農會"
    ],
    [
      "6960027",
      "蔦松分部"
    ],
    [
      "6960038",
      "宏仁分部"
    ],
    [
      "6960049",
      "西井分部"
    ],
    [
      "6960050",
      "溪墘分部"
    ]
  ],
  "697": [
    [
      "6970017",
      "元長鄉農會"
    ],
    [
      "6970028",
      "客庴分部"
    ],
    [
      "6970039",
      "鹿寮分部"
    ]
  ],
  "698": [
    [
      "6980018",
      "麥寮鄉農會"
    ],
    [
      "6980029",
      "橋頭分部"
    ]
  ],
  "699": [
    [
      "6990019",
      "林內鄉農會"
    ]
  ],
  "749": [
    [
      "7490011",
      "內埔地區農會"
    ],
    [
      "7490022",
      "龍泉分部"
    ],
    [
      "7490033",
      "水門分部"
    ],
    [
      "7490044",
      "東勢分部"
    ],
    [
      "7490055",
      "豐田分部"
    ],
    [
      "7490066",
      "老埤分部"
    ]
  ],
  "762": [
    [
      "7620010",
      "大溪區農會"
    ],
    [
      "7620021",
      "一心分部"
    ],
    [
      "7620032",
      "中新分部"
    ],
    [
      "7620043",
      "新峰分部"
    ],
    [
      "7620054",
      "埔頂分部"
    ],
    [
      "7620065",
      "員林分部"
    ],
    [
      "7620087",
      "崎頂分部"
    ],
    [
      "7620098",
      "南興分部"
    ]
  ],
  "763": [
    [
      "7630011",
      "桃園區農會"
    ],
    [
      "7630022",
      "大林分部"
    ],
    [
      "7630033",
      "會稽分部"
    ],
    [
      "7630055",
      "中路分部"
    ],
    [
      "7630066",
      "慈文分部"
    ],
    [
      "7630077",
      "埔子分部"
    ],
    [
      "7630088",
      "龍山分部"
    ]
  ],
  "764": [
    [
      "7640012",
      "平鎮區農會"
    ],
    [
      "7640023",
      "北勢分部"
    ],
    [
      "7640034",
      "山峰分部"
    ],
    [
      "7640045",
      "龍岡分部"
    ],
    [
      "7640056",
      "宋屋分部"
    ],
    [
      "7640067",
      "金陵分部"
    ]
  ],
  "765": [
    [
      "7650013",
      "楊梅區農會"
    ],
    [
      "7650035",
      "埔心分部"
    ],
    [
      "7650046",
      "富岡分部"
    ],
    [
      "7650057",
      "老街分部"
    ]
  ],
  "766": [
    [
      "7660014",
      "大園區農會"
    ],
    [
      "7660025",
      "埔心分部"
    ],
    [
      "7660047",
      "三和分部"
    ],
    [
      "7660058",
      "和平分部"
    ],
    [
      "7660069",
      "五權分部"
    ],
    [
      "7660070",
      "潮音分部"
    ],
    [
      "7660081",
      "青埔分部"
    ]
  ],
  "767": [
    [
      "7670015",
      "蘆竹區農會"
    ],
    [
      "7670026",
      "新興分部"
    ],
    [
      "7670037",
      "山腳分部"
    ],
    [
      "7670048",
      "宏竹分部"
    ],
    [
      "7670059",
      "大竹分部"
    ],
    [
      "7670060",
      "外社分部"
    ],
    [
      "7670071",
      "蘆竹分部"
    ],
    [
      "7670082",
      "中福分部"
    ],
    [
      "7670093",
      "五福分部"
    ],
    [
      "7670107",
      "海湖分部"
    ]
  ],
  "768": [
    [
      "7680016",
      "龜山區農會"
    ],
    [
      "7680027",
      "大崗分部"
    ],
    [
      "7680038",
      "山頂分部"
    ],
    [
      "7680049",
      "龍壽分部"
    ],
    [
      "7680050",
      "南上分部"
    ],
    [
      "7680061",
      "公西分部"
    ],
    [
      "7680072",
      "嶺頂分部"
    ],
    [
      "7680083",
      "山福分部"
    ],
    [
      "7680094",
      "舊路分部"
    ],
    [
      "7680108",
      "樂善分部"
    ]
  ],
  "769": [
    [
      "7690017",
      "八德區農會"
    ],
    [
      "7690028",
      "大湳分部"
    ],
    [
      "7690039",
      "瑞豐分部"
    ],
    [
      "7690040",
      "大福分部"
    ],
    [
      "7690051",
      "茄苳分部"
    ],
    [
      "7690062",
      "桃鶯分部"
    ],
    [
      "7690073",
      "霄裡分部"
    ]
  ],
  "770": [
    [
      "7700011",
      "新屋區農會"
    ],
    [
      "7700022",
      "永安分部"
    ],
    [
      "7700033",
      "大坡分部"
    ]
  ],
  "771": [
    [
      "7710012",
      "龍潭區農會"
    ],
    [
      "7710023",
      "中興分部"
    ],
    [
      "7710034",
      "烏林分部"
    ],
    [
      "7710045",
      "高平分部"
    ],
    [
      "7710056",
      "八德分部"
    ]
  ],
  "772": [
    [
      "7720013",
      "復興區農會"
    ],
    [
      "7720024",
      "三民分部"
    ]
  ],
  "773": [
    [
      "7730014",
      "觀音區農會"
    ]
  ],
  "775": [
    [
      "7750016",
      "土城區農會"
    ],
    [
      "7750027",
      "清水分部"
    ],
    [
      "7750038",
      "貨饒分部"
    ],
    [
      "7750049",
      "頂埔分部"
    ],
    [
      "7750050",
      "峰廷分部"
    ],
    [
      "7750061",
      "廣福分部"
    ],
    [
      "7750072",
      "永豐分部"
    ]
  ],
  "776": [
    [
      "7760017",
      "三重區農會"
    ],
    [
      "7760028",
      "溪美分部"
    ],
    [
      "7760040",
      "三民分部"
    ],
    [
      "7760051",
      "力行分部"
    ],
    [
      "7760062",
      "光復分部"
    ],
    [
      "7760073",
      "成功分部"
    ],
    [
      "7760084",
      "慈福分部"
    ]
  ],
  "777": [
    [
      "7770018",
      "中和地區農會"
    ],
    [
      "7770029",
      "中正分部"
    ],
    [
      "7770030",
      "員山分部"
    ],
    [
      "7770063",
      "興南分部"
    ],
    [
      "7770085",
      "民享分部"
    ],
    [
      "7770096",
      "連城分部"
    ],
    [
      "7770111",
      "仁愛分部"
    ],
    [
      "7770122",
      "錦和分部"
    ],
    [
      "7770133",
      "智光分部"
    ],
    [
      "7770166",
      "竹林分部"
    ]
  ],
  "778": [
    [
      "7780019",
      "淡水區農會"
    ],
    [
      "7780020",
      "竹圍分部"
    ],
    [
      "7780031",
      "中興分部"
    ],
    [
      "7780042",
      "水碓分部"
    ],
    [
      "7780053",
      "義山分部"
    ],
    [
      "7780064",
      "新興分部"
    ],
    [
      "7780075",
      "福德分部"
    ]
  ],
  "779": [
    [
      "7790010",
      "樹林區農會"
    ],
    [
      "7790021",
      "柑園分部"
    ],
    [
      "7790032",
      "山佳分部"
    ],
    [
      "7790043",
      "三多分部"
    ],
    [
      "7790054",
      "大同分部"
    ],
    [
      "7790065",
      "保安分部"
    ],
    [
      "7790113",
      "復興分部"
    ],
    [
      "7790124",
      "東山分部"
    ],
    [
      "7790135",
      "金寮分部"
    ],
    [
      "7790157",
      "圳安分部"
    ],
    [
      "7790168",
      "大學城分部"
    ]
  ],
  "780": [
    [
      "7800014",
      "鶯歌區農會"
    ],
    [
      "7800025",
      "二橋分部"
    ],
    [
      "7800036",
      "鳳鳴分部"
    ],
    [
      "7800047",
      "永昌分部"
    ]
  ],
  "781": [
    [
      "7810015",
      "三峽區農會"
    ],
    [
      "7810026",
      "大埔分部"
    ],
    [
      "7810037",
      "成福分部"
    ],
    [
      "7810048",
      "橫溪分部"
    ],
    [
      "7810059",
      "民生分部"
    ],
    [
      "7810060",
      "北大分部"
    ]
  ],
  "785": [
    [
      "7850019",
      "蘆洲區農會"
    ],
    [
      "7850020",
      "成功分部"
    ],
    [
      "7850031",
      "長安分部"
    ],
    [
      "7850053",
      "長榮分部"
    ]
  ],
  "786": [
    [
      "7860010",
      "五股區農會"
    ],
    [
      "7860021",
      "興珍分部"
    ],
    [
      "7860032",
      "成州分部"
    ],
    [
      "7860043",
      "德泰分部"
    ],
    [
      "7860054",
      "五福分部"
    ],
    [
      "7860065",
      "德音分部"
    ],
    [
      "7860076",
      "成德分部"
    ],
    [
      "7860087",
      "成功分部"
    ]
  ],
  "787": [
    [
      "7870011",
      "林口區農會"
    ],
    [
      "7870022",
      "南勢分部"
    ]
  ],
  "788": [
    [
      "7880012",
      "泰山區農會"
    ],
    [
      "7880023",
      "貴子分部"
    ],
    [
      "7880034",
      "明志分部"
    ],
    [
      "7880045",
      "貴和分部"
    ],
    [
      "7880056",
      "泰友分部"
    ],
    [
      "7880067",
      "泰林分部"
    ]
  ],
  "789": [
    [
      "7890013",
      "坪林區農會"
    ]
  ],
  "790": [
    [
      "7900017",
      "八里區農會"
    ],
    [
      "7900028",
      "龍形分部"
    ],
    [
      "7900039",
      "埤頭分部"
    ]
  ],
  "791": [
    [
      "7910018",
      "金山地區農會"
    ],
    [
      "7910029",
      "萬里分部"
    ],
    [
      "7910030",
      "野柳分部"
    ]
  ],
  "792": [
    [
      "7920019",
      "瑞芳地區農會"
    ],
    [
      "7920020",
      "雙溪分部"
    ],
    [
      "7920031",
      "貢寮分部"
    ],
    [
      "7920042",
      "澳底分部"
    ],
    [
      "7920053",
      "龍興分部"
    ],
    [
      "7920064",
      "四腳亭分部"
    ],
    [
      "7920075",
      "福隆分部"
    ]
  ],
  "793": [
    [
      "7930010",
      "新店地區農會"
    ],
    [
      "7930021",
      "中正分部"
    ],
    [
      "7930032",
      "烏來分部"
    ],
    [
      "7930043",
      "安康分部"
    ],
    [
      "7930054",
      "青潭分部"
    ],
    [
      "7930065",
      "德安分部"
    ]
  ],
  "795": [
    [
      "7950012",
      "深坑區農會"
    ],
    [
      "7950023",
      "萬順分部"
    ]
  ],
  "796": [
    [
      "7960013",
      "石碇區農會"
    ]
  ],
  "797": [
    [
      "7970014",
      "平溪區農會"
    ]
  ],
  "798": [
    [
      "7980015",
      "石門區農會"
    ],
    [
      "7980026",
      "老梅分部"
    ]
  ],
  "799": [
    [
      "7990016",
      "三芝區農會"
    ],
    [
      "7990027",
      "北新庄分部"
    ]
  ],
  "860": [
    [
      "8600015",
      "中埔鄉農會"
    ],
    [
      "8600026",
      "同仁分部"
    ],
    [
      "8600037",
      "隆興分部"
    ],
    [
      "8600048",
      "金蘭分部"
    ],
    [
      "8600059",
      "和睦分部"
    ],
    [
      "8600060",
      "和美分部"
    ],
    [
      "8600071",
      "和興分部"
    ],
    [
      "8600093",
      "沄水分部"
    ]
  ],
  "866": [
    [
      "8660011",
      "阿里山鄉農會"
    ],
    [
      "8660022",
      "中山分部"
    ],
    [
      "8660033",
      "達邦分部"
    ]
  ],
  "868": [
    [
      "8680013",
      "東勢區農會"
    ]
  ],
  "869": [
    [
      "8690014",
      "清水區農會"
    ],
    [
      "8690025",
      "臨江分部"
    ],
    [
      "8690036",
      "南社分部"
    ]
  ],
  "870": [
    [
      "8700018",
      "梧棲區農會"
    ],
    [
      "8700029",
      "興農分部"
    ],
    [
      "8700030",
      "安寧分部"
    ],
    [
      "8700041",
      "大莊分部"
    ],
    [
      "8700052",
      "南簡分部"
    ]
  ],
  "871": [
    [
      "8710019",
      "大甲區農會"
    ],
    [
      "8710020",
      "日南分部"
    ],
    [
      "8710031",
      "順天分部"
    ],
    [
      "8710042",
      "西岐分部"
    ],
    [
      "8710053",
      "幼獅社區分部"
    ],
    [
      "8710064",
      "庄美分部"
    ]
  ],
  "872": [
    [
      "8720010",
      "沙鹿區農會"
    ],
    [
      "8720021",
      "北勢分部"
    ],
    [
      "8720032",
      "鹿峰分部"
    ],
    [
      "8720043",
      "西明分部"
    ],
    [
      "8720054",
      "公館分部"
    ]
  ],
  "874": [
    [
      "8740012",
      "霧峰區農會"
    ],
    [
      "8740023",
      "萬豐分部"
    ],
    [
      "8740034",
      "北柳分部"
    ],
    [
      "8740045",
      "吉峰分部"
    ],
    [
      "8740056",
      "舊正分部"
    ],
    [
      "8740067",
      "吉峰路分部"
    ]
  ],
  "875": [
    [
      "8750013",
      "太平區農會"
    ],
    [
      "8750024",
      "新光分部"
    ],
    [
      "8750035",
      "頭汴分部"
    ],
    [
      "8750046",
      "光隆分部"
    ],
    [
      "8750057",
      "中山分部"
    ],
    [
      "8750068",
      "東平分部"
    ],
    [
      "8750079",
      "坪林分部"
    ],
    [
      "8750080",
      "新興分部"
    ]
  ],
  "876": [
    [
      "8760014",
      "烏日區農會"
    ],
    [
      "8760025",
      "溪埧分部"
    ],
    [
      "8760036",
      "九德分部"
    ],
    [
      "8760047",
      "榮泉分部"
    ]
  ],
  "877": [
    [
      "8770015",
      "后里區農會"
    ],
    [
      "8770026",
      "公館分部"
    ],
    [
      "8770037",
      "義里分部"
    ],
    [
      "8770048",
      "眉山分部"
    ]
  ],
  "878": [
    [
      "8780016",
      "大雅區農會"
    ],
    [
      "8780027",
      "橫山分部"
    ],
    [
      "8780038",
      "上楓分部"
    ],
    [
      "8780049",
      "馬岡分部"
    ],
    [
      "8780050",
      "忠義分部"
    ]
  ],
  "879": [
    [
      "8790017",
      "潭子區農會"
    ],
    [
      "8790028",
      "頭家分部"
    ],
    [
      "8790039",
      "東寶分部"
    ],
    [
      "8790040",
      "栗林分部"
    ],
    [
      "8790051",
      "甘蔗分部"
    ]
  ],
  "880": [
    [
      "8800011",
      "石岡區農會"
    ],
    [
      "8800022",
      "和盛分部"
    ]
  ],
  "881": [
    [
      "8810012",
      "新社區農會"
    ],
    [
      "8810023",
      "福興分部"
    ],
    [
      "8810034",
      "中興嶺分部"
    ]
  ],
  "882": [
    [
      "8820013",
      "大肚區農會"
    ],
    [
      "8820024",
      "福山分部"
    ],
    [
      "8820035",
      "成功分部"
    ],
    [
      "8820046",
      "蔗部分部"
    ],
    [
      "8820057",
      "王田分部"
    ]
  ],
  "883": [
    [
      "8830014",
      "外埔區農會"
    ],
    [
      "8830025",
      "土城分部"
    ],
    [
      "8830036",
      "大東分部"
    ]
  ],
  "884": [
    [
      "8840015",
      "大安區農會"
    ],
    [
      "8840026",
      "海墘分部"
    ],
    [
      "8840037",
      "松雅分部"
    ]
  ],
  "885": [
    [
      "8850016",
      "龍井區農會"
    ],
    [
      "8850027",
      "龍泉分部"
    ],
    [
      "8850038",
      "龍津分部"
    ],
    [
      "8850049",
      "新庄分部"
    ],
    [
      "8850050",
      "國際分部"
    ]
  ],
  "886": [
    [
      "8860017",
      "和平區農會"
    ],
    [
      "8860028",
      "梨山分部"
    ],
    [
      "8860039",
      "雙崎分部"
    ]
  ],
  "891": [
    [
      "8910015",
      "花蓮市農會"
    ],
    [
      "8910026",
      "花商分部"
    ],
    [
      "8910037",
      "自強分部"
    ],
    [
      "8910048",
      "美崙分部"
    ]
  ],
  "895": [
    [
      "8950019",
      "瑞穗鄉農會"
    ],
    [
      "8950020",
      "富源分部"
    ]
  ],
  "896": [
    [
      "8960010",
      "玉溪地區農會"
    ],
    [
      "8960021",
      "松浦分部"
    ]
  ],
  "897": [
    [
      "8970011",
      "鳳榮地區農會"
    ],
    [
      "8970022",
      "萬榮分部"
    ],
    [
      "8970033",
      "林榮分部"
    ]
  ],
  "898": [
    [
      "8980012",
      "光豐地區農會"
    ],
    [
      "8980023",
      "豐濱分部"
    ],
    [
      "8980034",
      "大富分部"
    ]
  ],
  "901": [
    [
      "9010015",
      "大里區農會"
    ],
    [
      "9010026",
      "內新分部"
    ],
    [
      "9010037",
      "草湖分部"
    ],
    [
      "9010048",
      "健民分部"
    ],
    [
      "9010059",
      "東榮分部"
    ],
    [
      "9010060",
      "金城分部"
    ],
    [
      "9010071",
      "十九甲分部"
    ],
    [
      "9010093",
      "仁化分部"
    ],
    [
      "9010107",
      "國光分部"
    ],
    [
      "9010118",
      "成功分部"
    ],
    [
      "9010129",
      "立新分部"
    ]
  ],
  "902": [
    [
      "9020016",
      "苗栗市農會"
    ],
    [
      "9020027",
      "南苗分部"
    ],
    [
      "9020038",
      "北苗分部"
    ],
    [
      "9020049",
      "嘉盛分部"
    ]
  ],
  "903": [
    [
      "9030017",
      "汐止區農會"
    ],
    [
      "9030028",
      "社后分部"
    ],
    [
      "9030039",
      "橫科分部"
    ],
    [
      "9030040",
      "白雲分部"
    ],
    [
      "9030051",
      "大新分部"
    ],
    [
      "9030062",
      "中興分部"
    ],
    [
      "9030073",
      "中正分部"
    ],
    [
      "9030084",
      "樟樹分部"
    ],
    [
      "9030095",
      "大同分部"
    ]
  ],
  "904": [
    [
      "9040018",
      "新莊區農會信用部"
    ],
    [
      "9040029",
      "丹鳳分部"
    ],
    [
      "9040030",
      "頭前分部"
    ],
    [
      "9040063",
      "西盛分部"
    ],
    [
      "9040074",
      "中港分部"
    ],
    [
      "9040085",
      "後港分部"
    ],
    [
      "9040096",
      "營盤分部"
    ],
    [
      "9040100",
      "瓊林分部"
    ],
    [
      "9040111",
      "思源分部"
    ],
    [
      "9040122",
      "新泰分部"
    ]
  ],
  "906": [
    [
      "9060010",
      "頭份市農會"
    ],
    [
      "9060021",
      "上街分部"
    ],
    [
      "9060032",
      "珊湖分部"
    ],
    [
      "9060054",
      "中山分部"
    ]
  ],
  "907": [
    [
      "9070011",
      "竹南鎮農會"
    ],
    [
      "9070022",
      "中港分部"
    ],
    [
      "9070033",
      "大埔分部"
    ],
    [
      "9070044",
      "龍鳳分部"
    ]
  ],
  "908": [
    [
      "9080012",
      "通霄鎮農會"
    ],
    [
      "9080023",
      "白沙屯分部"
    ]
  ],
  "909": [
    [
      "9090013",
      "苑裡鎮農會"
    ],
    [
      "9090024",
      "山腳分部"
    ],
    [
      "9090035",
      "社苓分部"
    ]
  ],
  "912": [
    [
      "9120019",
      "冬山鄉農會"
    ],
    [
      "9120020",
      "羅東分部"
    ],
    [
      "9120031",
      "順安分部"
    ],
    [
      "9120042",
      "廣興分部"
    ],
    [
      "9120053",
      "群英分部"
    ]
  ],
  "913": [
    [
      "9130010",
      "後龍鎮農會"
    ],
    [
      "9130021",
      "新港分部"
    ]
  ],
  "914": [
    [
      "9140011",
      "卓蘭鎮農會"
    ]
  ],
  "915": [
    [
      "9150012",
      "西湖鄉農會"
    ],
    [
      "9150023",
      "五湖分部"
    ]
  ],
  "916": [
    [
      "9160013",
      "草屯鎮農會"
    ],
    [
      "9160024",
      "雙冬分部"
    ],
    [
      "9160035",
      "南埔分部"
    ],
    [
      "9160068",
      "虎山分部"
    ],
    [
      "9160079",
      "北勢分部"
    ],
    [
      "9160080",
      "新庄分部"
    ],
    [
      "9160091",
      "富寮分部"
    ]
  ],
  "917": [
    [
      "9170014",
      "公館鄉農會"
    ],
    [
      "9170025",
      "鶴岡分部"
    ],
    [
      "9170036",
      "福基分部"
    ],
    [
      "9170047",
      "五谷分部"
    ]
  ],
  "918": [
    [
      "9180015",
      "銅鑼鄉農會"
    ],
    [
      "9180026",
      "中平分部"
    ],
    [
      "9180037",
      "新盛隆分部"
    ]
  ],
  "919": [
    [
      "9190016",
      "三義鄉農會"
    ],
    [
      "9190027",
      "鯉魚分部"
    ]
  ],
  "920": [
    [
      "9200010",
      "造橋鄉農會"
    ],
    [
      "9200021",
      "朝陽分部"
    ],
    [
      "9200032",
      "大西分部"
    ],
    [
      "9200043",
      "龍昇分部"
    ],
    [
      "9200054",
      "豐湖分部"
    ]
  ],
  "921": [
    [
      "9210011",
      "南庄鄉農會"
    ],
    [
      "9210033",
      "南富分部"
    ]
  ],
  "922": [
    [
      "9220012",
      "臺南地區農會信用部"
    ],
    [
      "9220023",
      "成功分部"
    ],
    [
      "9220034",
      "聯合分部"
    ],
    [
      "9220056",
      "安順分部"
    ],
    [
      "9220067",
      "和順分部"
    ],
    [
      "9220078",
      "土城分部"
    ],
    [
      "9220089",
      "灣裡分部"
    ]
  ],
  "923": [
    [
      "9230013",
      "獅潭鄉農會"
    ],
    [
      "9230024",
      "汶水分部"
    ]
  ],
  "924": [
    [
      "9240014",
      "頭屋鄉農會"
    ],
    [
      "9240025",
      "明德分部"
    ]
  ],
  "925": [
    [
      "9250015",
      "三灣鄉農會"
    ]
  ],
  "926": [
    [
      "9260016",
      "苗栗縣大湖地區農會"
    ],
    [
      "9260049",
      "南湖分部"
    ],
    [
      "9260050",
      "大湖分部"
    ]
  ],
  "928": [
    [
      "9280018",
      "板橋區農會信用部"
    ],
    [
      "9280029",
      "後埔分部"
    ],
    [
      "9280030",
      "埔墘分部"
    ],
    [
      "9280041",
      "社後分部"
    ],
    [
      "9280052",
      "江翠分部"
    ],
    [
      "9280063",
      "溪崑分部"
    ],
    [
      "9280074",
      "浮洲分部"
    ],
    [
      "9280111",
      "新埔分部"
    ],
    [
      "9280122",
      "文化分部"
    ]
  ],
  "929": [
    [
      "9290019",
      "關西鎮農會"
    ],
    [
      "9290020",
      "石光分部"
    ],
    [
      "9290031",
      "錦山分部"
    ]
  ],
  "930": [
    [
      "9300013",
      "新埔鎮農會"
    ],
    [
      "9300024",
      "照門分部"
    ],
    [
      "9300035",
      "田新分部"
    ]
  ],
  "931": [
    [
      "9310014",
      "竹北市農會"
    ],
    [
      "9310025",
      "六家分部"
    ],
    [
      "9310036",
      "豐田分部"
    ],
    [
      "9310047",
      "鳳岡分部"
    ],
    [
      "9310058",
      "高鐵分部"
    ]
  ],
  "932": [
    [
      "9320015",
      "湖口鄉農會"
    ],
    [
      "9320026",
      "中興分部"
    ],
    [
      "9320037",
      "客家樓分部"
    ]
  ],
  "933": [
    [
      "9330016",
      "芎林鄉農會"
    ],
    [
      "9330027",
      "秀湖分部"
    ],
    [
      "9330038",
      "石潭分部"
    ],
    [
      "9330049",
      "上山分部"
    ]
  ],
  "934": [
    [
      "9340017",
      "寶山鄉農會"
    ],
    [
      "9340028",
      "新城分部"
    ],
    [
      "9340039",
      "寶山分部"
    ]
  ],
  "935": [
    [
      "9350018",
      "峨眉鄉農會"
    ],
    [
      "9350029",
      "富興分部"
    ]
  ],
  "936": [
    [
      "9360019",
      "北埔鄉農會"
    ]
  ],
  "937": [
    [
      "9370010",
      "竹東地區農會"
    ],
    [
      "9370021",
      "竹中分部"
    ],
    [
      "9370032",
      "二重分部"
    ],
    [
      "9370043",
      "東寧分部"
    ],
    [
      "9370054",
      "五峰分部"
    ]
  ],
  "938": [
    [
      "9380011",
      "橫山地區農會"
    ],
    [
      "9380022",
      "橫山分部"
    ]
  ],
  "939": [
    [
      "9390012",
      "新豐鄉農會"
    ]
  ],
  "940": [
    [
      "9400016",
      "新竹市農會信用部"
    ],
    [
      "9400027",
      "三姓橋分部"
    ],
    [
      "9400038",
      "內湖分部"
    ],
    [
      "9400049",
      "民權分部"
    ],
    [
      "9400050",
      "樹林頭分部"
    ],
    [
      "9400061",
      "光復分部"
    ],
    [
      "9400072",
      "新興分部"
    ],
    [
      "9400083",
      "虎林分部"
    ],
    [
      "9400094",
      "光華分部"
    ]
  ],
  "953": [
    [
      "9530012",
      "田尾鄉農會"
    ],
    [
      "9530023",
      "溪畔分部"
    ],
    [
      "9530034",
      "福田分部"
    ],
    [
      "9530045",
      "海豐分部"
    ]
  ],
  "984": [
    [
      "9840012",
      "北投區農會"
    ],
    [
      "9840023",
      "石牌分部"
    ],
    [
      "9840034",
      "關渡分部"
    ],
    [
      "9840056",
      "立農分部"
    ],
    [
      "9840067",
      "大屯分部"
    ],
    [
      "9840078",
      "福興分部"
    ]
  ],
  "985": [
    [
      "9850013",
      "士林區農會"
    ],
    [
      "9850024",
      "文林分部"
    ],
    [
      "9850035",
      "社子分部"
    ],
    [
      "9850046",
      "天母分部"
    ],
    [
      "9850068",
      "陽明山分部"
    ],
    [
      "9850079",
      "延平分部"
    ]
  ],
  "986": [
    [
      "9860014",
      "內湖區農會"
    ],
    [
      "9860025",
      "潭美分部"
    ],
    [
      "9860036",
      "東湖分部"
    ]
  ],
  "987": [
    [
      "9870015",
      "南港區農會"
    ],
    [
      "9870026",
      "中研分部"
    ]
  ],
  "988": [
    [
      "9880016",
      "木柵區農會"
    ],
    [
      "9880027",
      "木新分部"
    ]
  ],
  "989": [
    [
      "9890017",
      "景美區農會"
    ]
  ],
  "612": [
    [
      "6121107",
      "臺中市豐原區農會"
    ],
    [
      "6121118",
      "神岡區農會"
    ],
    [
      "6121129",
      "豐洲分部"
    ],
    [
      "6121130",
      "社口分部"
    ]
  ],
  "613": [
    [
      "6130031",
      "集集鎮農會"
    ],
    [
      "6130488",
      "田寮分部"
    ],
    [
      "6130075",
      "名間鄉農會"
    ],
    [
      "6130260",
      "新街分部"
    ],
    [
      "6130271",
      "大庄分部"
    ],
    [
      "6130282",
      "赤水分部"
    ],
    [
      "6130293",
      "松柏嶺分部"
    ],
    [
      "6130466",
      "新光分部"
    ]
  ],
  "614": [
    [
      "6140043",
      "員林市農會"
    ],
    [
      "6140526",
      "東山分部"
    ],
    [
      "6140700",
      "百果山分部"
    ],
    [
      "6140087",
      "二林鎮農會"
    ],
    [
      "6140711",
      "原斗分部"
    ],
    [
      "6140799",
      "挖仔分部"
    ],
    [
      "6140858",
      "中山分部"
    ],
    [
      "6141291",
      "萬興分部"
    ],
    [
      "6140124",
      "秀水鄉農會"
    ],
    [
      "6140320",
      "福安分部"
    ],
    [
      "6140478",
      "馬鳴分部"
    ],
    [
      "6140515",
      "金興分部"
    ],
    [
      "6140179",
      "埔心鄉農會"
    ],
    [
      "6140559",
      "舊館分部"
    ],
    [
      "6140593",
      "明聖分部"
    ],
    [
      "6140180",
      "永靖鄉農會"
    ],
    [
      "6140696",
      "永安分部"
    ],
    [
      "6140733",
      "五福分部"
    ],
    [
      "6140870",
      "同安分部"
    ],
    [
      "6141028",
      "永興分部"
    ],
    [
      "6140227",
      "埤頭鄉農會"
    ],
    [
      "6140401",
      "路口厝分部"
    ],
    [
      "6140412",
      "埤頭分部"
    ],
    [
      "6140423",
      "芙朝分部"
    ],
    [
      "6140261",
      "竹塘鄉農會"
    ],
    [
      "6141017",
      "長安分部"
    ],
    [
      "6141327",
      "芬園鄉農會"
    ],
    [
      "6141338",
      "芳苑鄉農會"
    ]
  ],
  "616": [
    [
      "6160012",
      "斗六市農會"
    ],
    [
      "6160492",
      "石榴分部"
    ],
    [
      "6160595",
      "鎮南分部"
    ],
    [
      "6160609",
      "光興分部"
    ],
    [
      "6160746",
      "成功分部"
    ],
    [
      "6160757",
      "虎溪分部"
    ],
    [
      "6160023",
      "虎尾鎮農會"
    ],
    [
      "6160506",
      "大屯分部"
    ],
    [
      "6160517",
      "惠來分部"
    ],
    [
      "6160610",
      "頂溪分部"
    ],
    [
      "6160034",
      "西螺鎮農會"
    ],
    [
      "6160403",
      "埤源分部"
    ],
    [
      "6160528",
      "九隆分部"
    ],
    [
      "6160539",
      "和心分部"
    ],
    [
      "6160540",
      "建興分部"
    ],
    [
      "6160621",
      "中山分部"
    ],
    [
      "6160056",
      "斗南鎮農會"
    ],
    [
      "6160218",
      "石龜溪分部"
    ],
    [
      "6160458",
      "西埤分部"
    ],
    [
      "6160469",
      "新光分部"
    ],
    [
      "6160702",
      "明昌分部"
    ],
    [
      "6160735",
      "西岐分部"
    ],
    [
      "6160078",
      "古坑鄉農會"
    ],
    [
      "6160230",
      "永光分部"
    ],
    [
      "6160241",
      "東和分部"
    ],
    [
      "6160089",
      "大埤鄉農會"
    ],
    [
      "6160252",
      "怡然分部"
    ],
    [
      "6160562",
      "嘉興分部"
    ],
    [
      "6160090",
      "莿桐鄉農會"
    ],
    [
      "6160263",
      "饒平分部"
    ],
    [
      "6160436",
      "六合分部"
    ],
    [
      "6160115",
      "二崙鄉農會"
    ],
    [
      "6160274",
      "油車分部"
    ],
    [
      "6160285",
      "永定分部"
    ],
    [
      "6160126",
      "崙背鄉農會"
    ],
    [
      "6160713",
      "豐榮分部"
    ],
    [
      "6160137",
      "台西鄉農會"
    ],
    [
      "6160296",
      "崙豐分部"
    ],
    [
      "6160643",
      "牛厝分部"
    ],
    [
      "6160665",
      "蚊港分部"
    ],
    [
      "6160148",
      "褒忠鄉農會"
    ],
    [
      "6160160",
      "四湖鄉農會"
    ],
    [
      "6160300",
      "飛沙分部"
    ],
    [
      "6160447",
      "溪底分部"
    ],
    [
      "6160573",
      "林厝分部"
    ],
    [
      "6160698",
      "箔子分部"
    ],
    [
      "6160171",
      "口湖鄉農會"
    ],
    [
      "6160311",
      "宜梧分部"
    ],
    [
      "6160322",
      "金湖分部"
    ],
    [
      "6160333",
      "下崙分部"
    ]
  ],
  "617": [
    [
      "6170024",
      "朴子市農會"
    ],
    [
      "6170220",
      "文化分部"
    ],
    [
      "6170231",
      "松梅分部"
    ],
    [
      "6171353",
      "大慷榔分部"
    ],
    [
      "6171364",
      "雙溪口分部"
    ],
    [
      "6170035",
      "布袋鎮農會"
    ],
    [
      "6170242",
      "過溝分部"
    ],
    [
      "6170253",
      "永安分部"
    ],
    [
      "6171375",
      "新塭分部"
    ],
    [
      "6170046",
      "大林鎮農會"
    ],
    [
      "6170275",
      "溝背分部"
    ],
    [
      "6170286",
      "大美分部"
    ],
    [
      "6170297",
      "排路分部"
    ],
    [
      "6170781",
      "中林分部"
    ],
    [
      "6171467",
      "中坑分部"
    ],
    [
      "6170057",
      "民雄鄉農會"
    ],
    [
      "6170301",
      "北斗分部"
    ],
    [
      "6170312",
      "山中分部"
    ],
    [
      "6170323",
      "菁埔分部"
    ],
    [
      "6170714",
      "秀林分部"
    ],
    [
      "6171478",
      "三興分部"
    ],
    [
      "6171489",
      "興南分部"
    ],
    [
      "6170068",
      "溪口鄉農會"
    ],
    [
      "6170334",
      "柴林分部"
    ],
    [
      "6170345",
      "崙尾分部"
    ],
    [
      "6171386",
      "柳溝分部"
    ],
    [
      "6170079",
      "東石鄉農會"
    ],
    [
      "6170356",
      "東石分部"
    ],
    [
      "6170367",
      "副瀨分部"
    ],
    [
      "6170378",
      "下楫分部"
    ],
    [
      "6170389",
      "西崙分部"
    ],
    [
      "6170080",
      "義竹鄉農會"
    ],
    [
      "6170390",
      "過路分部"
    ],
    [
      "6170404",
      "光榮分部"
    ],
    [
      "6171397",
      "新店分部"
    ],
    [
      "6170091",
      "鹿草鄉農會"
    ],
    [
      "6170415",
      "下潭分部"
    ],
    [
      "6170426",
      "後堀分部"
    ],
    [
      "6171331",
      "重寮分部"
    ],
    [
      "6171401",
      "松山分部"
    ],
    [
      "6170105",
      "太保市農會"
    ],
    [
      "6170437",
      "後潭分部"
    ],
    [
      "6170448",
      "新埤分部"
    ],
    [
      "6170459",
      "南新分部"
    ],
    [
      "6170758",
      "嘉太分部"
    ],
    [
      "6171412",
      "安東分部"
    ],
    [
      "6170116",
      "水上鄉農會"
    ],
    [
      "6170460",
      "成功分部"
    ],
    [
      "6170471",
      "南靖分部"
    ],
    [
      "6170482",
      "大崙分部"
    ],
    [
      "6170493",
      "忠和分部"
    ],
    [
      "6170507",
      "北回分部"
    ],
    [
      "6170518",
      "柳林分部"
    ],
    [
      "6170725",
      "民生分部"
    ],
    [
      "6170138",
      "番路鄉農會"
    ],
    [
      "6170563",
      "觸口分部"
    ],
    [
      "6171320",
      "隙頂分部"
    ],
    [
      "6170149",
      "竹崎地區農會"
    ],
    [
      "6170574",
      "內埔分部"
    ],
    [
      "6170585",
      "灣橋分部"
    ],
    [
      "6170596",
      "東義分部"
    ],
    [
      "6170699",
      "大埔分部"
    ],
    [
      "6171423",
      "石棹分部"
    ],
    [
      "6171490",
      "鹿滿分部"
    ],
    [
      "6170150",
      "梅山鄉農會"
    ],
    [
      "6170600",
      "瑞里分部"
    ],
    [
      "6170611",
      "太平分部"
    ],
    [
      "6170622",
      "太和分部"
    ],
    [
      "6170806",
      "六腳鄉農會"
    ],
    [
      "6170172",
      "蒜頭分部"
    ],
    [
      "6170666",
      "港尾寮分部"
    ],
    [
      "6170677",
      "六腳分部"
    ],
    [
      "6170688",
      "灣內分部"
    ],
    [
      "6170703",
      "更寮分部"
    ],
    [
      "6171434",
      "蘇崙分部"
    ],
    [
      "6170817",
      "新港鄉農會"
    ],
    [
      "6170633",
      "月眉分部"
    ],
    [
      "6170644",
      "大潭分部"
    ],
    [
      "6170655",
      "崙子分部"
    ],
    [
      "6171261",
      "安和分部"
    ],
    [
      "6170862",
      "嘉義市農會"
    ],
    [
      "6170013",
      "吳鳳分部"
    ],
    [
      "6170194",
      "福全分部"
    ],
    [
      "6170208",
      "北興分部"
    ],
    [
      "6171272",
      "宣信分部"
    ],
    [
      "6171283",
      "民生分部"
    ]
  ],
  "618": [
    [
      "6180025",
      "新營區農會"
    ],
    [
      "6180335",
      "太子宮分部"
    ],
    [
      "6180346",
      "延平分部"
    ],
    [
      "6181066",
      "三民分部"
    ],
    [
      "6181217",
      "中正分部"
    ],
    [
      "6180036",
      "鹽水區農會"
    ],
    [
      "6180357",
      "歡雅分部"
    ],
    [
      "6180368",
      "圣頭港分部"
    ],
    [
      "6180069",
      "佳里區農會"
    ],
    [
      "6180416",
      "佳興分部"
    ],
    [
      "6180427",
      "子龍分部"
    ],
    [
      "6180438",
      "塭內分部"
    ],
    [
      "6180449",
      "延平分部"
    ],
    [
      "6180081",
      "善化區農會"
    ],
    [
      "6180450",
      "東關里分部"
    ],
    [
      "6180461",
      "六分寮分部"
    ],
    [
      "6181365",
      "茄拔分部"
    ],
    [
      "6180092",
      "柳營區農會"
    ],
    [
      "6180472",
      "重溪辦事處"
    ],
    [
      "6180483",
      "果毅分部"
    ],
    [
      "6180494",
      "太康辦事處"
    ],
    [
      "6180508",
      "旭山辦事處"
    ],
    [
      "6180139",
      "六甲區農會"
    ],
    [
      "6180612",
      "林鳳營分部"
    ],
    [
      "6180162",
      "西港區農會"
    ],
    [
      "6180689",
      "後營分部"
    ],
    [
      "6180715",
      "竹林分部"
    ],
    [
      "6180184",
      "將軍區農會"
    ],
    [
      "6180771",
      "苓仔寮分部"
    ],
    [
      "6180782",
      "將軍分部"
    ],
    [
      "6180793",
      "馬沙溝分部"
    ],
    [
      "6180807",
      "青鯤鯓分部"
    ],
    [
      "6180195",
      "北門區農會"
    ],
    [
      "6180818",
      "溪底寮分部"
    ],
    [
      "6180829",
      "蚵寮分部"
    ],
    [
      "6181206",
      "三慈分部"
    ],
    [
      "6180243",
      "臺南市玉井區農會"
    ],
    [
      "6180298",
      "歸仁區農會"
    ],
    [
      "6180966",
      "大潭武東分部"
    ],
    [
      "6180977",
      "大廟分部"
    ],
    [
      "6180988",
      "新市場分部"
    ],
    [
      "6181239",
      "歸南分部"
    ],
    [
      "6180324",
      "永康區農會"
    ],
    [
      "6181011",
      "大灣分部"
    ],
    [
      "6181181",
      "鹽行分部"
    ],
    [
      "6181240",
      "中華分部"
    ],
    [
      "6181262",
      "崑山分部"
    ],
    [
      "6181343",
      "龍潭分部"
    ],
    [
      "6181413",
      "大橋分部"
    ],
    [
      "6181402",
      "楠西區農會"
    ]
  ],
  "619": [
    [
      "6190015",
      "鳳山區農會"
    ],
    [
      "6190266",
      "五甲分部"
    ],
    [
      "6190738",
      "老爺分部"
    ],
    [
      "6190749",
      "市場分部"
    ],
    [
      "6190864",
      "文山分部"
    ],
    [
      "6190886",
      "東區分部"
    ],
    [
      "6190897",
      "鎮北分部"
    ],
    [
      "6190990",
      "過埤分部"
    ],
    [
      "6190026",
      "岡山區農會"
    ],
    [
      "6190277",
      "市場分部"
    ],
    [
      "6190288",
      "嘉興分部"
    ],
    [
      "6190299",
      "仁壽分部"
    ],
    [
      "6190772",
      "協榮分部"
    ],
    [
      "6191067",
      "後紅分部"
    ],
    [
      "6190037",
      "旗山區農會"
    ],
    [
      "6190314",
      "旗尾分部"
    ],
    [
      "6190325",
      "溪洲分部"
    ],
    [
      "6190336",
      "南溪洲分部"
    ],
    [
      "6190347",
      "嶺口分部"
    ],
    [
      "6190358",
      "中正分部"
    ],
    [
      "6190048",
      "美濃區農會"
    ],
    [
      "6190369",
      "中壇分部"
    ],
    [
      "6190370",
      "龍肚分部"
    ],
    [
      "6190381",
      "廣興分部"
    ],
    [
      "6190392",
      "南隆分部"
    ],
    [
      "6190059",
      "橋頭區農會"
    ],
    [
      "6190716",
      "橋頭分部"
    ],
    [
      "6190901",
      "甲圍分部"
    ],
    [
      "6190923",
      "隆豐和分部"
    ],
    [
      "6190934",
      "五林分部"
    ],
    [
      "6190060",
      "燕巢區農會"
    ],
    [
      "6190406",
      "鳳雄分部"
    ],
    [
      "6190417",
      "深水分部"
    ],
    [
      "6190680",
      "安招分部"
    ],
    [
      "6190071",
      "田寮區農會"
    ],
    [
      "6190794",
      "新興分部"
    ],
    [
      "6190808",
      "崇德分部"
    ],
    [
      "6190082",
      "阿蓮區農會"
    ],
    [
      "6190624",
      "中路分部"
    ],
    [
      "6191078",
      "復安分部"
    ],
    [
      "6190093",
      "路竹區農會"
    ],
    [
      "6190428",
      "竹滬分部"
    ],
    [
      "6190439",
      "一甲分部"
    ],
    [
      "6190440",
      "下坑分部"
    ],
    [
      "6190451",
      "三爺分部"
    ],
    [
      "6190107",
      "湖內區農會"
    ],
    [
      "6190462",
      "大湖分部"
    ],
    [
      "6190657",
      "海埔分部"
    ],
    [
      "6190118",
      "茄萣區農會"
    ],
    [
      "6190129",
      "彌陀區農會"
    ],
    [
      "6190646",
      "南安分部"
    ],
    [
      "6190783",
      "壽齡分部"
    ],
    [
      "6190130",
      "永安區農會"
    ],
    [
      "6190679",
      "保寧分部"
    ],
    [
      "6190761",
      "維新分部"
    ],
    [
      "6190141",
      "梓官區農會"
    ],
    [
      "6190473",
      "赤崁分部"
    ],
    [
      "6190484",
      "大舍分部"
    ],
    [
      "6190495",
      "梓官分部"
    ],
    [
      "6190185",
      "林園區農會"
    ],
    [
      "6190831",
      "中厝分部"
    ],
    [
      "6190196",
      "大寮區農會"
    ],
    [
      "6190565",
      "大寮分部"
    ],
    [
      "6190576",
      "中庄分部"
    ],
    [
      "6190587",
      "後庄分部"
    ],
    [
      "6190598",
      "昭明分部"
    ],
    [
      "6190602",
      "潮寮分部"
    ],
    [
      "6191012",
      "翁園分部"
    ],
    [
      "6190211",
      "仁武區農會"
    ],
    [
      "6190727",
      "灣內分部"
    ],
    [
      "6191023",
      "大灣分部"
    ],
    [
      "6191045",
      "八卦分部"
    ],
    [
      "6190222",
      "大社區農會"
    ],
    [
      "6190244",
      "杉林區農會"
    ],
    [
      "6190255",
      "甲仙地區農會"
    ],
    [
      "6190819",
      "桃源分部"
    ],
    [
      "6190989",
      "那瑪夏分部"
    ],
    [
      "6190303",
      "六龜區農會"
    ],
    [
      "6191089",
      "鳥松區農會"
    ],
    [
      "6190967",
      "仁美分部"
    ],
    [
      "6191090",
      "澄清湖分部"
    ],
    [
      "6191104",
      "大樹區農會"
    ],
    [
      "6191115",
      "內門區農會"
    ],
    [
      "6190978",
      "溝坪分部"
    ],
    [
      "6191001",
      "觀亭分部"
    ]
  ],
  "620": [
    [
      "6200031",
      "東港鎮農會"
    ],
    [
      "6200721",
      "下部分部"
    ],
    [
      "6200042",
      "恆春鎮農會"
    ],
    [
      "6200547",
      "墾丁分部"
    ],
    [
      "6200075",
      "麟洛鄉農會"
    ],
    [
      "6200086",
      "九如鄉農會"
    ],
    [
      "6200787",
      "洽興分部"
    ],
    [
      "6200112",
      "里港鄉農會"
    ],
    [
      "6200330",
      "土庫辦事處"
    ],
    [
      "6200341",
      "載興辦事處"
    ],
    [
      "6200628",
      "三廓分部"
    ],
    [
      "6200167",
      "崁頂鄉農會"
    ],
    [
      "6200709",
      "力社分部"
    ],
    [
      "6200710",
      "港東分部"
    ],
    [
      "6200189",
      "南州地區農會"
    ],
    [
      "6200813",
      "新埤分部"
    ],
    [
      "6200204",
      "琉球鄉農會"
    ],
    [
      "6200215",
      "滿州鄉農會"
    ],
    [
      "6200259",
      "枋山地區農會"
    ],
    [
      "6200743",
      "枋山分部"
    ],
    [
      "6200754",
      "加祿分部"
    ],
    [
      "6200868",
      "屏東市農會"
    ],
    [
      "6200879",
      "車城地區農會"
    ],
    [
      "6200880",
      "屏東縣農會"
    ],
    [
      "6200891",
      "枋寮地區農會"
    ],
    [
      "6200905",
      "竹田鄉農會"
    ],
    [
      "6200916",
      "萬丹鄉農會"
    ],
    [
      "6200927",
      "長治鄉農會"
    ],
    [
      "6200938",
      "林邊鄉農會"
    ],
    [
      "6200949",
      "佳冬鄉農會"
    ],
    [
      "6200961",
      "高樹鄉農會"
    ],
    [
      "6200972",
      "萬巒地區農會"
    ],
    [
      "6200983",
      "潮州鎮農會"
    ],
    [
      "6200994",
      "新園鄉農會"
    ]
  ],
  "621": [
    [
      "6210021",
      "吉安鄉農會"
    ],
    [
      "6210102",
      "仁里分部"
    ],
    [
      "6210227",
      "北昌分部"
    ],
    [
      "6210238",
      "宜昌分部"
    ],
    [
      "6210032",
      "壽豐鄉農會"
    ],
    [
      "6210124",
      "志學分部"
    ],
    [
      "6210331",
      "豐裡分部"
    ],
    [
      "6210043",
      "富里鄉農會"
    ],
    [
      "6210135",
      "東竹分部"
    ],
    [
      "6210146",
      "東里分部"
    ],
    [
      "6210098",
      "新秀地區農會"
    ],
    [
      "6210191",
      "新城分部"
    ],
    [
      "6210205",
      "嘉里分部"
    ],
    [
      "6210216",
      "秀林分部"
    ]
  ],
  "622": [
    [
      "6220011",
      "關山鎮農會"
    ],
    [
      "6220239",
      "海端分部"
    ],
    [
      "6220022",
      "成功鎮農會"
    ],
    [
      "6220206",
      "忠孝分部"
    ],
    [
      "6220251",
      "信義分部"
    ],
    [
      "6220033",
      "池上鄉農會"
    ],
    [
      "6220055",
      "長濱鄉農會"
    ],
    [
      "6220066",
      "台東地區農會"
    ],
    [
      "6220099",
      "豐里分部"
    ],
    [
      "6220125",
      "台東分部"
    ],
    [
      "6220136",
      "知本分部"
    ],
    [
      "6220147",
      "綠島分部"
    ],
    [
      "6220158",
      "初鹿分部"
    ],
    [
      "6220217",
      "太平分部"
    ],
    [
      "6220228",
      "蘭嶼分部"
    ],
    [
      "6220284",
      "新園分部"
    ],
    [
      "6220077",
      "鹿野地區農會"
    ],
    [
      "6220169",
      "瑞源分部"
    ],
    [
      "6220240",
      "瑞豐分部"
    ],
    [
      "6220088",
      "太麻里地區農會"
    ],
    [
      "6220170",
      "美和分部"
    ],
    [
      "6220181",
      "金崙分部"
    ],
    [
      "6220192",
      "大武分部"
    ],
    [
      "6220103",
      "東河鄉農會"
    ],
    [
      "6220044",
      "東河分部"
    ],
    [
      "6220114",
      "泰源分部"
    ]
  ],
  "624": [
    [
      "6240013",
      "澎湖縣農會信用部"
    ],
    [
      "6240024",
      "湖西分部"
    ],
    [
      "6240035",
      "西嶼分部"
    ],
    [
      "6240046",
      "望安分部"
    ],
    [
      "6240057",
      "白沙分部"
    ],
    [
      "6240068",
      "七美分部"
    ]
  ],
  "627": [
    [
      "6270016",
      "連江縣農會"
    ]
  ],
  "952": [
    [
      "9520103",
      "小港區農會"
    ]
  ],
  "020": [
    [
      "0200017",
      "台北分行"
    ],
    [
      "0200028",
      "高雄分行"
    ],
    [
      "0200040",
      "台中分行"
    ]
  ],
  "022": [
    [
      "0220019",
      "美國銀行台北分行"
    ]
  ],
  "023": [
    [
      "0230010",
      "台北分行"
    ],
    [
      "0230032",
      "高雄分行"
    ],
    [
      "0230043",
      "台中分行"
    ]
  ],
  "025": [
    [
      "0250012",
      "台北分行"
    ]
  ],
  "029": [
    [
      "0290005",
      "台北分行"
    ]
  ],
  "030": [
    [
      "0300010",
      "台北分行"
    ]
  ],
  "037": [
    [
      "0370017",
      "台北分行"
    ]
  ],
  "039": [
    [
      "0390019",
      "台北分行"
    ]
  ],
  "072": [
    [
      "0720014",
      "台北分行"
    ]
  ],
  "075": [
    [
      "0750006",
      "台北分行"
    ]
  ],
  "076": [
    [
      "0760018",
      "台北分行"
    ]
  ],
  "082": [
    [
      "0820017",
      "台北分行"
    ],
    [
      "0820039",
      "高雄分行"
    ],
    [
      "0820051",
      "台中分行"
    ]
  ],
  "085": [
    [
      "0850009",
      "台北分行"
    ]
  ],
  "086": [
    [
      "0860011",
      "台北分行"
    ]
  ],
  "092": [
    [
      "0920010",
      "台北分行"
    ],
    [
      "0920032",
      "台中分行"
    ],
    [
      "0920043",
      "高雄分行"
    ]
  ],
  "093": [
    [
      "0930011",
      "台北分行"
    ]
  ],
  "098": [
    [
      "0980016",
      "台北分行"
    ]
  ],
  "321": [
    [
      "3210019",
      "台北分行"
    ]
  ],
  "326": [
    [
      "3268881",
      "臺北分行"
    ]
  ],
  "329": [
    [
      "3290017",
      "台北分行"
    ]
  ],
  "330": [
    [
      "3300011",
      "台北分行"
    ]
  ],
  "380": [
    [
      "3800016",
      "臺北分行"
    ]
  ],
  "381": [
    [
      "3810888",
      "臺北分行"
    ]
  ],
  "382": [
    [
      "3820018",
      "臺北分行"
    ]
  ],
  "060": [
    [
      "0600019",
      "總公司"
    ]
  ],
  "061": [
    [
      "0610010",
      "台北總公司"
    ],
    [
      "0610021",
      "高雄分公司"
    ],
    [
      "0610032",
      "台中分公司"
    ],
    [
      "0610043",
      "台南分公司"
    ],
    [
      "0610054",
      "桃園分公司"
    ],
    [
      "0610065",
      "板橋分公司"
    ]
  ],
  "062": [
    [
      "0620011",
      "台北總公司"
    ],
    [
      "0620022",
      "台中分公司"
    ],
    [
      "0620033",
      "台南分公司"
    ],
    [
      "0620044",
      "高雄分公司"
    ],
    [
      "0620055",
      "臺北分公司"
    ],
    [
      "0620066",
      "桃園分公司"
    ],
    [
      "0620077",
      "板橋分公司"
    ],
    [
      "0620088",
      "中山分公司"
    ],
    [
      "0620099",
      "新竹分公司"
    ]
  ],
  "066": [
    [
      "0660015",
      "總公司"
    ]
  ],
  "372": [
    [
      "3720015",
      "總公司"
    ]
  ],
  "995": [
    [
      "9950016",
      "關貿網路股份有限公司"
    ]
  ],
  "996": [
    [
      "9960017",
      "財政部國庫署"
    ],
    [
      "9960028",
      "中部辦公室"
    ]
  ],
  "700": [
    [
      "7000021",
      "中華郵政股份有限公司"
    ]
  ]
};

export default branches2;



/**
 * 根據銀行代碼過濾分行
 * @param {string} bankCode 銀行代碼
 * @returns {Array} 分行列表
 */
export function getBranchesByBankCode(bankCode) {
  if (!bankCode) return [];
  return branches2[bankCode] || [];
}